<template>
  <div style="margin-top:-25px">
    <div class="row">
      <div class="col-sm-12 col-md-12 col-lg-12 text-left">
        <h2 style="font-size: 40px; font-weight: 700; line-height: 48px; " class="mb-0 mt-2">
          Campaign Management
        </h2>
      </div>
    </div>
    <div class="pt-3 pb-3">&nbsp;</div>
    <div class="row" id="processingArea">
      <div class="col-sm-12 col-md-12 col-lg-12">
        <div class="d-flex flex-wrap" style="justify-content: space-between;">
          <div class="d-flex align-items-center flex-wrap" style="column-gap:8px;row-gap:20px">
            <div class="campaign-filter-item-wrapper">
              <span style="opacity:0.3">Showing</span>
              <span v-for="(filter, index) in optionCampaignStatus" @click="applyFilter(filter)" :class="[
                '--filter-item',
                { '--active': filterCampaignStatus === filter.value, '--disabled' : fetchingCampaignData}
              ]" :key="index">{{ filter.label }}</span>
            </div>
            <div class="container__input__campaign__management">
              <base-input class="mb-0">
                <el-input type="text" class="search-input input__campaign__management" clearable
                  placeholder="Search" v-model="searchQuery" aria-controls="datatables"
                  @keyup.native.enter="searchKeyWord" @clear="searchKeyWord">
                </el-input>
              </base-input>
            </div>
            <SelectClientDropdown class="client-filter-anchor"></SelectClientDropdown>
          </div>
          <div class="container__filter__campaign__management">
            <div>
              <base-button  
                :class="{ '--disabled': fetchingCampaignData }"
                :disabled="fetchingCampaignData"
                v-if="(this.$global.menuLeadsPeek_create || (userType == 'client' && disabledaddcampaign && (this.$store.getters.userData.manual_bill == 'F' || this.$store.getters.userData.company_parent == '1251'))) && (this.$global.betaFeature.simplifi_module && this.$global.betaFeature.simplifi_module.has_agreement && this.$global.betaFeature.simplifi_module.has_agreement === true)"
                size="sm" style="height:40px"
                class="button__filter__campaign__management create-campaign-anchor" @click="AddEditClient('')">
                <i class="fas fa-plus-circle"></i> Add Campaign
              </base-button>
              <base-button size="sm" style="height:40px" class="button_filtercampaign_management" @click="startTour">
                <i class="fas fa-question-circle"></i> Help
              </base-button>
            </div>
          </div>
        </div>
        <transition name="fade">
          <div v-if="fetchingCampaignData">
            <div style="min-height: 40vh; display: flex; justify-content: center; align-items: center;">
              <i class="fas fa-spinner fa-spin" style="font-size: 40px;"></i>
            </div>
          </div>
          <div v-else class="mt-3 mt-md-5 d-flex flex-column" style="gap: 16px">

            <card class="mb-0" v-for="(campaign, index) in queriedData" :key="campaign.leadspeek_api_id" @click.native="showCampaignDetails(campaign)" style="cursor: pointer;">
              <div class="d-flex justify-content-between align-items-center flex-wrap cursor-pointer" style="gap: 8px">
                <div class="campaign-card-title-info-wrapper" @click.stop>
                  <span class="card-icon-styling" :style="{ backgroundColor: '#FFE9F0' }">
                    <i class="fa-solid fa-image" :style="{ color: '#000000' }"></i>
                  </span>
                  <div class="align-items-center d-flex flex-wrap" style="gap:16px">
                    <div class="campaign-card-title-info">
                      <span class="campaign-card-client-name">{{
                        campaign.company_name
                      }}</span>
                      <span class="campain-card-name d-flex justify-content-between"><span
                          class="campaign-name-ellips">{{
                            campaign.campaign_name
                          }}</span>
                        <!-- <span
                                                    class='arrows'><i class="fa-solid fa-arrow-up"
                                                        :style="{ opacity: currOrderBy == 'ascending' ? 0.3 : 0.6 }"
                                                        @click.stop="sortdynamic('campaign_name', 'ascending')"></i><i
                                                        :style="{ opacity: currOrderBy == 'descending' ? 0.3 : 0.6 }"
                                                        class="fa-solid fa-arrow-down"
                                                        @click.stop="sortdynamic('campaign_name', 'descending')"></i></span> -->
                      </span>
                      <span v-if="campaign.last_lead_added" class="campaign-card-update-date">Last updated on {{
                        campaign.last_lead_added }}</span>
                    </div>
                    <div v-if="
                      campaign.disabled == 'F' && campaign.active_user == 'T' && campaign.campaign_never_started == 'F'
                    " class="campaign-card-status-badge" style="background:rgb(0, 81, 97);color:white">
                      <span>Running</span>
                    </div>
                    <div v-if="
                      campaign.disabled == 'T' && campaign.active_user == 'T' && campaign.campaign_never_started == 'F'
                    " class="campaign-card-status-badge" style="background:#fdae61">
                      <span>Paused</span>
                    </div>
                    <div v-if="campaign.active_user == 'F' && campaign.campaign_never_started == 'F'" class="campaign-card-status-badge"
                      style="background:rgb(147, 2, 30);color:white">
                      <span>Stopped</span>
                    </div>
                    <div v-if="
                      campaign.campaign_never_started == 'T' &&
                      campaign.active_user == 'F' &&
                      campaign.total_leads == '0'
                    " class="campaign-card-status-badge" style="background:rgb(88, 92, 102);color:white;padding-left: 1rem;padding-right: 1rem;">
                      <span>Draft</span>
                    </div>
                    <div v-if="campaign.audience_status != 'finish'" class="campaign-card-status-badge" style="background:rgb(88, 92, 102);color:white;padding-left:0.7rem;padding-right:0.7rem;">
                      <span v-if="campaign.audience_status == 'error'">Audience Processing Failed</span>
                      <span v-else>Pending Processing Audience <i class="fas fa-spinner fa-spin ml-1" style="font-size: 13px;"></i></span>
                    </div>
                    <div v-if="campaign.ads_upload_status && campaign.ads_upload_status != 'finish' && campaign.ads_upload_status != null" class="campaign-card-status-badge" style="background:rgb(88, 92, 102);color:white;padding-left:0.7rem;padding-right:0.7rem;">
                      <span v-if="campaign.ads_upload_status == 'error'">Ads Upload Failed</span>
                      <span v-else>Pending Processing Ads <i class="fas fa-spinner fa-spin ml-1" style="font-size: 13px;"></i></span>
                    </div>
                    <div v-if="(externalData[campaign.leadspeek_api_id] && externalData[campaign.leadspeek_api_id].status && (externalData[campaign.leadspeek_api_id].status == 'Pending' || externalData[campaign.leadspeek_api_id].status == 'pending')) ? true : false" class="campaign-card-status-badge" style="background:rgb(88, 92, 102);color:white;padding-left:0.7rem;padding-right:0.7rem;">
                      <span >Pending Review</span>
                    </div>
                  </div>
                </div>
                <div class="d-flex justify-content-between align-items-center flex-wrap campaign-card-right-wrapper">
                  <div class="campaign-card-stat-wrapper d-flex flex-wrap" style="min-width:253px">
                    <!-- campaign simplifi for development -->
                    <div v-if="false" class="campaign-card-stat-block-simplifi stat-block-id-anchor">
                      <span class="--stat-block-title">simplifi id</span>
                      <span class="--stat-block-value">{{ campaign.clientcampaignsid }}
                        <span v-if="
                          $global.globalviewmode &&
                          $global.rootcomp &&
                          ($global.user_permissions == null || $global.user_permissions.report_analytics)">
                          <span v-if="campaign.clientcampaignsid != ''" class="pl-2"><a :href="'/configuration/report-analytics/?campaignid=' +
                            campaign.clientcampaignsid +
                            ''
                            " target="_blank"><i class="fas fa-file-chart-line" style="color:gray"></i></a></span>
                        </span></span>
                    </div>
                    <!-- campaign simplifi for development -->

                    <div class="campaign-card-stat-block-simplifi stat-block-id-anchor">
                      <span class="--stat-block-title">ID</span>
                      <span class="--stat-block-value">{{ campaign.leadspeek_api_id }}
                        <span v-if="$global.globalviewmode && userTypeOri != 'sales' && isMasterCompany && ($global.user_permissions == null || $global.user_permissions.external_sf)">
                          <span v-if="campaign.clientcampaignsid != ''" class="pl-2"><a :href="'https://app.simpli.fi/organizations/' +  campaign.clientorganizationid + '/campaigns/' + campaign.clientcampaignsid + ''" target="_blank" @click.stop><i class="fas fa-chart-line" style="color:green"></i></a></span>
                          <i v-if="campaign.clientcampaignsid == ''" class="fas fa-exclamation-triangle pl-2" style="color:yellow"></i>
                        </span>
                        <span v-if="
                          false &&
                          $global.globalviewmode &&
                          $global.rootcomp &&
                          ($global.user_permissions == null ||
                            $global.user_permissions.report_analytics)
                        ">
                          <span v-if="campaign.leadspeek_api_id != ''" class="pl-2"><a :href="'/configuration/report-analytics/?campaignid=' +
                            campaign.leadspeek_api_id +
                            ''
                            " target="_blank"><i class="fas fa-file-chart-line" style="color:gray"></i></a></span>
                        </span></span>
                    </div>

                    <!-- <div class="campaign-card-stat-block stat-block-total-anchor">
                      <span class="--stat-block-title">Start Date</span>
                      <span class="--stat-block-value">{{
                        campaign.last_lead_added
                      }}</span>
                    </div> -->

                    <div class="campaign-card-stat-block-simplifi stat-block-total-anchor">
                      <span class="--stat-block-title">Start Date</span>
                      <span class="--stat-block-value">
                        <span v-if="loadingExternal || !externalData[campaign.leadspeek_api_id]">
                          <i class="fas fa-spinner fa-spin"></i>
                        </span>
                        <el-popover v-else-if="externalData[campaign.leadspeek_api_id] == 'error'" content="Something's wrong when fetching data. Refresh to load data again" effect="light" :open-delay="300" placement="top" trigger="hover">
                          <span  slot="reference">
                            <i class="fas fa-exclamation-circle " style="color: orange;"></i>
                          </span>
                        </el-popover>
                        <span v-else>
                          {{ externalData[campaign.leadspeek_api_id] ? externalData[campaign.leadspeek_api_id].start_date : '-' }}
                        </span>
                      </span>
                    </div>



                    <!-- DATA EXTERNAL -->
                    <!-- <div class="campaign-card-stat-block stat-block-yesterday-anchor">
                      <span class="--stat-block-title">Total Spend</span>
                      <span class="--stat-block-value"> <span>$5</span></span>
                    </div> -->
                    <!-- Total Spend -->
                    <div class="campaign-card-stat-block-simplifi">
                      <span class="--stat-block-title">Total Spend</span>
                      <span class="--stat-block-value">
                        <span v-if="loadingExternal || !externalData[campaign.leadspeek_api_id]">
                          <i class="fas fa-spinner fa-spin"></i>
                        </span>
                        <el-popover v-else-if="externalData[campaign.leadspeek_api_id] == 'error'" content="Something's wrong when fetching data. Refresh to load data again" effect="light" :open-delay="300" placement="top" trigger="hover">
                          <span  slot="reference">
                            <i class="fas fa-exclamation-circle " style="color: orange;"></i>
                          </span>
                        </el-popover>
                        <span v-else>
                          ${{ externalData[campaign.leadspeek_api_id] ? formatPrice(externalData[campaign.leadspeek_api_id].total_spend) : '-' }}
                        </span>
                      </span>
                    </div>


                    <!-- <div class="campaign-card-stat-block stat-block-list-queue-id-anchor"
                      v-if="$global.globalviewmode && $global.rootcomp">
                      <span class="--stat-block-title">Budget</span>
                      <span class="--stat-block-value">
                        <span>$500</span>
                      </span>
                    </div> -->
                    <!-- Budget -->
                    <div class="campaign-card-stat-block-simplifi">
                      <span class="--stat-block-title">Total Budget</span>
                      <span class="--stat-block-value">
                        <span v-if="loadingExternal || !externalData[campaign.leadspeek_api_id]">
                          <i class="fas fa-spinner fa-spin"></i>
                        </span>
                        <el-popover v-else-if="externalData[campaign.leadspeek_api_id] == 'error'" content="Something's wrong when fetching data. Refresh to load data again" effect="light" :open-delay="300" placement="top" trigger="hover">
                          <span  slot="reference">
                            <i class="fas fa-exclamation-circle " style="color: orange;"></i>
                          </span>
                        </el-popover>
                        <span v-else>
                          ${{ externalData[campaign.leadspeek_api_id] ? formatPrice(externalData[campaign.leadspeek_api_id].total_budget) : '-' }}
                        </span>
                      </span>
                    </div>


                    <!-- <div class="campaign-card-stat-block">
                      <span class="--stat-block-title">Overall CTR</span>
                      <span class="--stat-block-value"> <span>0%</span></span>
                    </div> -->

                    <!-- CTR -->
                    <div class="campaign-card-stat-block-simplifi">
                      <span class="--stat-block-title">Overall CTR</span>
                      <span class="--stat-block-value">
                        <span v-if="loadingExternal || !externalData[campaign.leadspeek_api_id]">
                          <i class="fas fa-spinner fa-spin"></i>
                        </span>
                        <el-popover v-else-if="externalData[campaign.leadspeek_api_id] == 'error'" content="Something's wrong when fetching data. Refresh to load data again" effect="light" :open-delay="300" placement="top" trigger="hover">
                          <span  slot="reference">
                            <i class="fas fa-exclamation-circle " style="color: orange;"></i>
                          </span>
                        </el-popover>
                        <span v-else>
                          {{ externalData[campaign.leadspeek_api_id] ? formatPercentage(externalData[campaign.leadspeek_api_id].ctr) : '-' }}
                        </span>
                      </span>
                    </div>

                    <!-- <div class="campaign-card-stat-block">
                      <span class="--stat-block-title">CPM</span>
                      <span class="--stat-block-value"> <span>$5</span></span>
                    </div> -->
                    
                    <!-- CPM -->
                    <div class="campaign-card-stat-block-simplifi">
                      <span class="--stat-block-title">CPM</span>
                      <span class="--stat-block-value">
                        <span v-if="loadingExternal || !externalData[campaign.leadspeek_api_id]">
                          <i class="fas fa-spinner fa-spin"></i>
                        </span>
                        <el-popover v-else-if="externalData[campaign.leadspeek_api_id] == 'error'" content="Something's wrong when fetching data. Refresh to load data again" effect="light" :open-delay="300" placement="top" trigger="hover">
                          <span  slot="reference">
                            <i class="fas fa-exclamation-circle " style="color: orange;"></i>
                          </span>
                        </el-popover>
                        <span v-else>
                          ${{ externalData[campaign.leadspeek_api_id] ? formatPrice(externalData[campaign.leadspeek_api_id].cpm) : '-' }}
                        </span>
                      </span>
                    </div>

                    <!-- CPC -->
                    <div class="campaign-card-stat-block-simplifi">
                      <span class="--stat-block-title">CPC</span>
                      <span class="--stat-block-value">
                        <span v-if="loadingExternal || !externalData[campaign.leadspeek_api_id]">
                          <i class="fas fa-spinner fa-spin"></i>
                        </span>
                        <el-popover v-else-if="externalData[campaign.leadspeek_api_id] == 'error'" content="Something's wrong when fetching data. Refresh to load data again" effect="light" :open-delay="300" placement="top" trigger="hover">
                          <span  slot="reference">
                            <i class="fas fa-exclamation-circle " style="color: orange;"></i>
                          </span>
                        </el-popover>
                        <span v-else>
                          ${{ externalData[campaign.leadspeek_api_id] ? formatPrice(externalData[campaign.leadspeek_api_id].cpc) : '-' }}
                        </span>
                      </span>
                    </div>

                    <!-- <div class="campaign-card-stat-block">
                      <span class="--stat-block-title">GOAL</span>
                      <span class="--stat-block-value">
                        <span>$5.00 CPA</span></span>
                    </div> -->
                    
                    <!-- GOAL -->
                    <div class="campaign-card-stat-block-simplifi">
                      <span class="--stat-block-title">GOAL</span>
                      <span class="--stat-block-value">
                        <span v-if="loadingExternal || !externalData[campaign.leadspeek_api_id]">
                          <i class="fas fa-spinner fa-spin"></i>
                        </span>
                        <el-popover v-else-if="externalData[campaign.leadspeek_api_id] == 'error'" content="Something's wrong when fetching data. Refresh to load data again" effect="light" :open-delay="300" placement="top" trigger="hover">
                          <span  slot="reference">
                            <i class="fas fa-exclamation-circle " style="color: orange;"></i>
                          </span>
                        </el-popover>
                        <span v-else>
                          <template v-if="externalData[campaign.leadspeek_api_id] && externalData[campaign.leadspeek_api_id].campaign_goal">
                            <!-- CTR tidak pakai $ -->
                            <span v-if="externalData[campaign.leadspeek_api_id].campaign_goal.goal_type === 'ctr'">
                              {{ formatPercentage(externalData[campaign.leadspeek_api_id].campaign_goal.goal_value) }}
                            </span>
                            <span v-else>
                              ${{ formatPrice(externalData[campaign.leadspeek_api_id].campaign_goal.goal_value) }}
                              {{ externalData[campaign.leadspeek_api_id].campaign_goal.goal_type.toUpperCase() }}
                            </span>
                          </template>
                          <template v-else>
                            -
                          </template>
                        </span>
                      </span>
                    </div>

                    <!-- Clicks -->
                    <div class="campaign-card-stat-block-simplifi">
                      <span class="--stat-block-title">Clicks</span>
                      <span class="--stat-block-value">
                        <span v-if="loadingExternal || !externalData[campaign.leadspeek_api_id]">
                          <i class="fas fa-spinner fa-spin"></i>
                        </span>
                        <el-popover v-else-if="externalData[campaign.leadspeek_api_id] == 'error'" content="Something's wrong when fetching data. Refresh to load data again" effect="light" :open-delay="300" placement="top" trigger="hover">
                          <span  slot="reference">
                            <i class="fas fa-exclamation-circle " style="color: orange;"></i>
                          </span>
                        </el-popover>
                        <span v-else>
                          {{ externalData[campaign.leadspeek_api_id] ? externalData[campaign.leadspeek_api_id].clicks : '-' }}
                        </span>
                      </span>
                    </div>

                    <!-- Impressions -->
                    <div class="campaign-card-stat-block-simplifi">
                      <span class="--stat-block-title">Impressions</span>
                      <span class="--stat-block-value">
                        <span v-if="loadingExternal || !externalData[campaign.leadspeek_api_id]">
                          <i class="fas fa-spinner fa-spin"></i>
                        </span>
                        <el-popover v-else-if="externalData[campaign.leadspeek_api_id] == 'error'" content="Something's wrong when fetching data. Refresh to load data again" effect="light" :open-delay="300" placement="top" trigger="hover">
                          <span  slot="reference">
                            <i class="fas fa-exclamation-circle " style="color: orange;"></i>
                          </span>
                        </el-popover>
                        <span v-else>
                          {{ externalData[campaign.leadspeek_api_id] ? externalData[campaign.leadspeek_api_id].impressions : '-' }}
                        </span>
                      </span>
                    </div>

                    <!-- DATA EXTERNAL -->
                  </div>
                  <div class="campaign-card-actions-block flex-column" style="min-width: auto;">
                    <div class="campaign-card-actions-block" style="min-width: auto;">
                      <el-popover content="Edit This Campaign" effect="light" :open-delay="300" placement="top" trigger="hover">
                        <span
                          slot="reference"
                          @click.stop="onEditCampaignCardClick(campaign, queriedData)"
                          class="card-action-icon-wrapper edit-btn-anchor"
                          :class="{ 'disabled-area': fetchingCampaignData }"
                          :style="fetchingCampaignData ? { opacity: 0.45, cursor: 'not-allowed' } : {}"
                          :title="fetchingCampaignData ? 'Wait for the campaign list to finish loading' : ''"
                        >
                          <i class="fa-solid fa-pen"></i>
                        </span>
                      </el-popover>
                      <el-popover content="Campaign Financials" effect="light" :open-delay="300" placement="top" trigger="hover">
                        <span slot="reference" @click.stop="handlePriceSet(index, campaign)" style="position: relative;"
                          class="card-action-icon-wrapper campaign-financials-btn">
                          <i class="fa-solid fa-dollar-sign"></i>
                          <span v-if="isLoadingIconFinancials[campaign.id]" class="d-flex justify-content-center align-items-center loading-icon-financial">
                            <i class="fas fa-spinner fa-spin" style="font-size: 18px;"></i>
                          </span>
                        </span>
                      </el-popover>
                      <el-popover content="View Campaign Details" effect="light" :open-delay="300" placement="top" trigger="hover">
                        <span slot="reference" @click.stop="showCampaignDetails(campaign)"
                          class="card-action-icon-wrapper detail-btn-anchor">
                          <i class="fa-solid fa-file-chart-line"></i>
                        </span>
                      </el-popover>
                      <!-- <el-tooltip
                        effect="light"
                        :open-delay="300"
                        placement="top"
                        content="Configure integrations"
                      >
                        <span
                          @click.stop="handleIntegrationClick(index, campaign)"
                          class="card-action-icon-wrapper campaign-integration-btn"
                        >
                          <i class="fas fa-plug"></i>
                        </span>
                      </el-tooltip> -->
                      <el-popover v-show="campaign.payment_status != 'failed' &&
                        (campaign.active_user == 'F' ||
                          (campaign.disabled == 'T' &&
                            campaign.active_user == 'T'))
                        " :content="tooltip_campaign(index, campaign, 'play')" effect="light" :open-delay="300"
                        placement="top" trigger="hover">
                        <span 
                          slot="reference"
                          @click.stop="
                          activepauseclient(index, campaign, 'play')
                          " class="card-action-icon-wrapper play-pause-stop-anchor">
                          <i :class="['fas fa-play', { 'cursornodrop': campaign.active_user == 'F' && (campaign.customer_card_id == '' && $store.getters.userData.manual_bill == 'F') }]"></i>
                          <span v-if="isLoadingIconActiveCampaigns[campaign.id]" class="d-flex justify-content-center align-items-center loading-icon-active-campaign">
                            <i class="fas fa-spinner fa-spin" style="font-size: 18px;"></i>
                          </span>
                        </span>
                      </el-popover>
                      <el-popover v-show="(campaign.disabled == 'F' &&
                        campaign.active_user == 'T') ||
                        (campaign.disabled == 'T' &&
                          campaign.active_user == 'T')
                        " :content="tooltip_campaign(index, campaign, 'stop')" effect="light" :open-delay="300"
                        placement="top" trigger="hover">
                        <span
                          slot="reference"
                          @click.stop="handleDelete(index, campaign)" 
                          class="card-action-icon-wrapper play-pause-stop-anchor">
                          <i class="fas fa-stop"></i>
                        </span>
                      </el-popover>
                    </div>
                  </div>
                  <div @click.stop>
                    <el-dropdown trigger="click">
                      <span class="menu-drop-anchor">
                        <i class="fa-solid fa-ellipsis-vertical"></i>
                      </span>
                      <el-dropdown-menu slot="dropdown">
                        <div @click.stop="archiveCampaign(index, campaign)">
                          <el-dropdown-item>Archive</el-dropdown-item>
                        </div>

                        <div @click.stop="duplicateCampaign(index, campaign)">
                          <el-dropdown-item>Duplicate</el-dropdown-item>
                        </div>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>
                </div>
              </div>
            </card>
            <div class="align-items-center d-flex justify-content-center text-center" style="height: 200px;" v-if='queriedData.length <= 0'>
                No campaigns found 
            </div>  
          </div>
        </transition>
        <div class="tab-footer pull-right">
          <div class="pt-3">
            <p class="card-category">
              Showing {{ pagination.from }} to {{ pagination.to }} of
              {{ pagination.total }} entries
            </p>
          </div>
          <base-pagination class="pagination-no-border pt-4" v-model="pagination.currentPage"
            :per-page="pagination.perPage" :total="pagination.total" @input="changePage">
          </base-pagination>
        </div>
      </div>
    </div>

    <div id="popProcessing" class="popProcessing" style="display:none" v-html="popProcessingTxt"></div> 

    <!-- create campaign modal end -->
    <modal 
      :show.sync="modals.addEditCampaign"
      id="addCampaign"
      bodyClasses="create-campaign-modal-body"
      footerClasses="border-top p-2">
      <div slot="header" class="border-bottom pb-3 w-100">
        <h3 class="title title-up text-center">Create Campaign</h3>
        <p class="m-0 mt-2 text-sm text-black-50 text-center">
          Fill in the details below to create a new advertising campaign.
        </p>

        <div class="row mt-3">
          <div class="col-12">
            <el-steps :active="stepCreateCampaignActive" :class="{ 'is-last-step': stepCreateCampaignActive == 2 }" finish-status="success" align-center>
              <el-step title="Campaign Information"></el-step>
              <el-step title="Budget Information"></el-step>
            </el-steps>
          </div>
        </div>
      </div>

      <!-- step 1 -->
      <div v-if="stepCreateCampaignActive == 1" class="row">
        <h4 class="col-sm-12 col-md-12 col-lg-12 font-weight-600 m-0 text-dark mb-4" style="font-size: 20px;">
          Client Info
        </h4>
        <div class="col-sm-12 col-md-12 col-lg-12 has-label pull-left">
          <div style="display: flex; flex-direction: column; margin-bottom: 15px;">
            <label>{{
              CompanyNamedisabled ? "Client Name" : "Select Client Name"
            }}</label>
            <el-select class="select__form__client" size="large" placeholder="Select Client Name"
              filterable
              default-first-option
              v-model="selectsCompany.companySelected" @change="onCompanyChange(selectsCompany.companySelected, true)"
              :disabled="CompanyNamedisabled">
              <el-option v-for="option in selectsCompany.companyList" :value="option.id" :label="(option.company_name == null || option.company_name === false) ? '' : String(option.company_name)"
                :key="option.id">
              </el-option>
            </el-select>
            <small style="color:#942434 !important;" v-if="err_companyselect">* Client Company is required</small>
          </div>
        </div>
        <div class="col-sm-12 col-md-12 col-lg-12"
          style="cursor: not-allowed;">
          <base-input class="disabled" label="Contact Name" type="text" placeholder="Input Client Contact Name"
            v-model="ClientFullName">
          </base-input>
        </div>
        <div class="col-sm-6 col-md-6 col-lg-6"
          style="cursor: not-allowed;">
          <base-input class="disabled" label="Email" type="email" placeholder="Input Client Email"
            v-model="ClientEmail">
          </base-input>
        </div>
        <div class="col-sm-6 col-md-6 col-lg-6"
          style="cursor: not-allowed;">
          <base-input class="disabled" label="Phone Number" type="text" placeholder="Input Client Phone"
            v-model="ClientPhone">
          </base-input>
        </div>
        
        <!-- Divider -->
        <div class="col-sm-12 col-md-12 col-lg-12 my-4">
          <hr style="border: 0; border-top: 2px solid #e0e0e0; margin: 0;">
        </div>
        
        <h4 class="col-sm-12 col-md-12 col-lg-12 font-weight-600 m-0 text-dark my-4" style="font-size: 20px;">
          General Info
        </h4>
        <div class="col-sm-12 col-md-12 col-lg-12 form-group has-label pull-left">
          <base-input label="Campaign Name" type="text" placeholder="e.g., Summer 2024 Launch"
            v-model="ClientCampaignName" :maxlength="255" class="mb-0 pb-0">
          </base-input>
          <small id="err_campaignname" style="display:none;color:#942434 !important;">
            * Campaign Name is required
          </small>
        </div>
        <div class="col-sm-12 col-md-12 col-lg-12 pull-left mt-2 mb-3">
          <div class="d-flex">
            <label for="frequency-capping-input">Frequency Capping</label>
            <el-popover
                placement="top"
                :width="300"
                trigger="hover"
              >
                <div class="tooltip-content">
                  <p>A campaign feature that allows you to limit, or cap, the number of impressions a device is served within a certain timeframe.</p>
                  <p>The timeframe can range from 1 to 24 hours.</p>
                </div>
                <template #reference>
                  <div class="text-center">
                    <i
                      class="fa fa-question-circle text-black-50"
                      style="cursor: pointer; margin-left: 12px;"
                    ></i>
                  </div>
                </template>
            </el-popover>
          </div>
          <div class="m-0 d-flex flex-wrap align-items-center" style="gap: 8px;">
            <base-input id="frequency-capping-input" label="" type="text" placeholder="e.g., 5"
              v-model="frequencyCapping.impressions" :maxlength="2" class="mb-0 pb-0 w-25" @keydown="event => restrictInput(event, 'integer')">
            </base-input>
            <span class="text-black-50" style="font-size: small;">imps/per</span>
            <el-select class="select__form__client" size="large" placeholder="e.g., 24" v-model="frequencyCapping.hours">
              <el-option v-for="option in frequencyCapping.hoursOptions" :value="option.id" :label="(option.val == null || option.val === false) ? '' : String(option.val)"
                :key="option.id">
              </el-option>
            </el-select>
            <span class="text-black-50" style="font-size: small;">hours</span>
          </div>

          <small id="err_frequencycapping" style="display:none;color:#942434 !important;">
            * frequency capping required
          </small>
        </div>
        
        <div class="col-sm-12 col-md-12 col-lg-12 pull-left mt-2 mb-3">
          <div class="d-flex">
            <label for="goal-select-step1">Campaign Goal</label>
            <el-popover
                placement="top"
                :width="300"
                trigger="hover"
              >
                <div class="tooltip-content">
                  <p>The goal of your current Campaign. The selected Goal dictates how the campaign will be optimized.</p>
                  <p><strong>CPC</strong>: Cost Per Click</p>
                  <p><strong>CTR</strong>: Click-Through Rate</p>
                  <p><strong>CPA</strong>: Cost Per Acquisition</p>
                  <p style="margin-top: 10px; font-size: 12px; color: #666;">Note: Goal value will be set in Step 2 (Budget section).</p>
                </div>
                <template #reference>
                  <div class="text-center">
                    <i
                      class="fa fa-question-circle text-black-50"
                      style="cursor: pointer; margin-left: 12px;"
                    ></i>
                  </div>
                </template>
            </el-popover>
          </div>
          <el-select 
            id="goal-select-step1"
            class="select__form__client w-100" 
            size="large" 
            placeholder="Select Goal" 
            v-model="campaignGoal.goal" 
            @change="campaignGoalChange">
            <el-option v-for="option in campaignGoal.options" :value="option.id" :label="(option.value == null || option.value === false) ? '' : String(option.value)"
              :key="option.id">
            </el-option>
          </el-select>
        </div>

        <!-- Divider -->
        <div class="col-sm-12 col-md-12 col-lg-12 my-4">
          <hr style="border: 0; border-top: 2px solid #e0e0e0; margin: 0;">
        </div>

        <!-- Targeting Settings section -->
        <h4 class="col-sm-12 col-md-12 col-lg-12 font-weight-600 m-0 text-dark my-4" style="font-size: 20px;">
          Targeting Settings
        </h4>
        
        <!-- Geo Fences Section -->
        <h4 class="col-sm-12 col-md-12 col-lg-12 font-weight-600 m-0 text-dark my-4" style="font-size: 20px;">
          Geo Targeting
        </h4>
        <div class="col-sm-12 col-md-12 col-lg-12">
          <div class="d-flex flex-column flex-md-row align-items-start align-items-md-center mb-3">
          <div class="d-flex align-items-center mb-2 mb-md-0 flex-shrink-0">
            <el-switch
              v-model="useGeoFence"
              active-text="Use Geo Fences"
              inactive-text="Use Default Targeting"
              active-color="#13ce66"
              inactive-color="#ff4949"
              :disabled="!leafletAvailable">
            </el-switch>
            
            <el-popover
              placement="top"
              :width="300" 
              trigger="hover"
              effect="light"
              :open-delay="300"
              style="margin-left: 10px;">
              <template>
                <div style="text-align: left; white-space: normal; word-break: normal; overflow-wrap: break-word; line-height: 1.6;">
                  <div style="margin-bottom: 8px;">
                    <strong>Geo Fences:</strong> Draw custom geographic boundaries on a map for precise location targeting.
                  </div>
                  <div style="margin-bottom: 8px;">
                    <strong>Default:</strong> Targets all available locations using the default geographic targeting.
                  </div>
                  <div style="margin-bottom: 8px;">
                    You can only use one method at a time.
                  </div>
                  <div>
                    <strong>Important:</strong> The Geo Targeting mode (Default vs Geo Fences) can only be chosen when creating a campaign. Once the campaign has started running, this mode cannot be changed.
                  </div>
                </div>
              </template>
              <template #reference>
                <i class="fa fa-question-circle text-black-50" style="cursor: pointer;"></i>
              </template>
            </el-popover>
          </div>
          <div
            class="d-flex align-items-start w-100 ml-md-3"
            style="max-width: 600px; padding: 10px 12px; background: #fff3cd; border: 1px solid #ffc107; border-radius: 6px; box-shadow: 0 2px 4px rgba(0,0,0,0.05);"
          >
            <i class="fas fa-exclamation-triangle" style="color: #ff9800; font-size: 16px; margin-right: 10px; margin-top: 2px; flex-shrink: 0;"></i>
              <div style="font-size: 13px; line-height: 1.5; color: #856404;">
                <strong style="color: #856404; font-weight: 600;">Important:</strong>
                <span style="color: #856404;"> The Geo Targeting mode (Default vs Geo Fences) can only be configured when creating a campaign. Once the campaign has started running, this mode cannot be changed.</span>
              </div>
              </div>
          </div>
          <div v-if="useGeoFence" class="geo-fence-section">
            <div class="alert alert-info" style="margin-bottom: 15px; padding: 12px; border-left: 4px solid #409EFF; background: #e1f3ff; border-radius: 4px; color: #303133;">
              <i class="fas fa-info-circle" style="color: #409EFF; margin-right: 8px;"></i>
              <strong style="color: #303133;">Note:</strong> <span style="color: #606266;">Draw polygons on the map to define your geo fences. Maximum 12 points per polygon. 
              Geo fences will be saved after campaign creation.</span>
            </div>
            <div style="border: 1px solid #e0e0e0; border-radius: 8px; padding: 0; background: #fff; box-shadow: 0 2px 4px rgba(0,0,0,0.1); overflow: hidden;">
              <GeoFenceMap 
                ref="geoFenceMap"
                :campaign-id="''"
                :is-create-mode="true"
                map-id="geo-fence-map-targeting"
                @fences-updated="onGeoFencesUpdated"
                @recency-updated="onRecencyUpdated"
                @leaflet-unavailable="onLeafletUnavailable"
              />
            </div>
          </div>
          
          <div v-else class="default-geo-target-info">
            <div class="alert alert-success" style="margin-bottom: 0; padding: 12px; border-left: 4px solid #67C23A;">
              <i class="fas fa-check-circle"></i>
              <strong>Default Targeting:</strong> Campaign will use the default geographic targeting for all available locations.
            </div>
          </div>
          
          <!-- Geo Targeting Agreement Checkbox -->
          <div class="col-sm-12 col-md-12 col-lg-12 mt-3 p-0">
            <div 
              class="alert geo-targeting-agreement-box"
              :class="{ 'agreement-checked': geoTargetingAgreement }"
              style="margin-bottom: 0; padding: 12px; border-left: 4px solid #ff9800; background: #fffbf0;"
            >
              <div style="display: flex; align-items: center; gap: 10px;">
                <el-checkbox 
                  v-model="geoTargetingAgreement"
                  style="flex-shrink: 0;"
                >
                </el-checkbox>
                <i 
                  class="fas fa-info-circle" 
                  style="font-size: 16px; color: #ff9800; flex-shrink: 0;"
                ></i>
                <span style="font-size: 13px; line-height: 1.5; color: #856404;">
                  I understand this Geo Targeting mode <strong>cannot be changed</strong> after the campaign starts.
                </span>
              </div>
            </div>
          </div>
        </div>
        <!-- End Geo Fences Section -->

        <!-- audiance section -->
        <h4 class="col-sm-12 col-md-12 col-lg-12 font-weight-600 m-0 text-dark my-4" style="font-size: 20px;">
          Addressable Audiences
          <span class="text-black-50" style="font-size: 14px;">(minimum 50 contacts required)</span>
          <span v-if="totalCombinedAudience > 0" class="text-black-50" style="font-size: 14px;">(Selected
            audience: {{
              totalCombinedAudience }})</span>
        </h4>
        <div class="col-sm-12 col-md-12 col-lg-12">
          <div style="display: flex; flex-direction: column;">
            <label>Select Audience from Existing Campaigns</label>
            <el-select multiple id="select-from-campaigns"
              class="select__form__client w-100 select-info select-fullwidth campaign-audiance-dropdown" size="large"
              placeholder="Choose from available campaigns" v-model="SelectedCampaignsAudience"
              label="Select Audience from Existing Campaigns" :popper-append-to-body="true">
              <el-option v-for="option in filteredCampaignOptionsByProducts" :value="option.id"
                :label="String((option.leadspeek_api_id != '') ? option.campaign_name + ' (' + (option.leadspeek_type == 'b2b' ? $global.globalModulNameLink.b2b.name : option.leadspeek_type == 'enhance' ? $global.globalModulNameLink.enhance.name : option.leadspeek_type == 'locator' ?  $global.globalModulNameLink.locator.name : option.leadspeek_type == 'local' ? $global.globalModulNameLink.local.name:option.leadspeek_type ) + ' )' +' ('+ option.total_leads + ')': option.campaign_name)"
                :key="option.id">
              </el-option>
            </el-select>
          </div>
        </div>

        <div class="col-sm-12 col-md-12 col-lg-12 mt-4">
          <div class="d-flex align-items-center justify-content-between">
            <span class="font-weight-600 text-dark" style="
    font-size: 16px;
">Local Audience List</span>
            <el-button @click="modals.uploadAudiance = true" class="upload-button" icon="el-icon-upload2" plain>Upload
              Local
              List</el-button>
          </div>
          <UserLocalAudiance 
          ref="userLocalAudienceAdd" 
          :user-id="ClientUserID"
          :selected-audience-ids="selectedAudience"
          @selection-changed="onAudienceSelected"
          ></UserLocalAudiance>
        </div>
        <!-- end audiance section  -->
        <!-- ini adalah budget -->
        <div v-if="false" class="col-sm-12 col-md-12 col-lg-12 d-flex flex-wrap flex-md-nowrap" style="gap:16px;">
          <div class="w-100">
            <div class="d-flex">
              <label for="max-bid-input">Max Bid</label>
              <el-popover
                placement="top"
                :width="300"
                trigger="hover"
                effect="light"
                :open-delay="300"
              >
                <div class="tooltip-content">
                  <p>The maximum amount you are willing to pay for an impression.</p>
                  <p>The max bid is set at the campaign level.</p>
                </div>
                <template #reference>
                  <i
                    class="fa fa-question-circle text-black-50"
                    style="cursor: pointer; margin-left: 12px;"
                  ></i>
                </template>
              </el-popover>
            </div>
            <base-input 
              id="max-bid-input" 
              class="campaign-cost-input"
              :class="{'error-input-price-simplifi': simplifiErrorInput.addCampaign.maxBid}"
              label="" type="text" placeholder="0.00" addon-left-icon="fas fa-dollar-sign" v-model="campaign.maxBid"
              maxLength="20"
              @copy.prevent @cut.prevent @paste.prevent
              @input="onSimplifiPriceInput('addCampaign', 'maxBid', $event)"
              @keydown="restrictInput"
              @keyup="validateMinimumInput('keyup','addCampaign','maxBid')" 
              @blur="validateMinimumInput('blur','addCampaign','maxBid')">
              <template #addonRight>
                <span class="input-group-text">CPM</span>
              </template>
            </base-input>
            <span v-if="simplifiErrorInput.addCampaign.maxBid" v-html="simplifiErrorInput.addCampaign.maxBid" class="error-message-price-simplifi"></span>
          </div>
          <div class="w-100">
            <label for="total-budget-input">Monthly Budget</label>
            <base-input 
              id="total-budget-input" 
              class="campaign-cost-input" 
              label="" type="text" placeholder="0.00" addon-left-icon="fas fa-dollar-sign" v-model="campaign.totalBudget"
              maxLength="20"
              @copy.prevent @cut.prevent @paste.prevent
              @input="onBudgetInput('totalBudget', $event)" 
              @keydown="restrictInput"
              @keyup="validateMinimumInput('keyup','addCampaign','monthlyBudget')" 
              @blur="validateMinimumInput('blur','addCampaign','monthlyBudget')">
            </base-input>
          </div>
        </div>
        <div v-if="false" class="col-sm-12 col-md-12 col-lg-12 d-flex flex-wrap flex-md-nowrap mt-2" style="gap:16px;">
          <div class="w-100">
            <div class="d-flex">
              <label for="max-bid-input">Daily Budget</label>
              <el-popover
                  placement="top"
                  :width="320"
                  trigger="hover"
                  effect="light"
                  :open-delay="300"
                  >
                    <div class="tooltip-content">
                      <p>The maximum dollar amount that your campaign should spend in a day.</p>
                      <p>If a Daily Budget is not provided, your campaign will spend its Total or Monthly Budget as quickly as possible, regardless of the campaign's end date.</p>
                      <p>Best practices recommend that you include a Daily Budget.</p>
                    </div>
                    <template #reference>
                      <i
                        class="fa fa-question-circle text-black-50"
                        style="cursor: pointer; margin-left: 12px;"
                      ></i>
                    </template>
              </el-popover>
            </div>
            <base-input 
              id="max-bid-input" 
              class="campaign-cost-input" 
              :class="{'error-input-price-simplifi': simplifiErrorInput.addCampaign.dailyBudget}"
              label="" type="text" placeholder="0.00" addon-left-icon="fas fa-dollar-sign" v-model="campaign.dailyBudget"
              maxLength="20"
              @copy.prevent @cut.prevent @paste.prevent
              @input="onBudgetInput('dailyBudget', $event)" 
              @keydown="restrictInput"
              @keyup="validateMinimumInput('keyup','addCampaign','dailyBudget')"
              @blur="validateMinimumInput('blur','addCampaign','dailyBudget')">
            </base-input>
            <span v-if="simplifiErrorInput.addCampaign.dailyBudget" v-html="simplifiErrorInput.addCampaign.dailyBudget" class="error-message-price-simplifi"></span>
          </div>
          <div class="w-100">
            <div class="d-flex">
              <label for="goal-select">Goal</label>
              <el-popover
                placement="top"
                :width="320"
                trigger="hover"
                effect="light"
                :open-delay="300"
                >
                <div class="tooltip-content">
                  <p>The goal of your current Campaign. The selected Goal dictates how the campaign will be optimized.</p>
                  <div class="tooltip-definitions">
                    <strong>CPC</strong>: Cost Per Click<br />
                    <strong>CTR</strong>: Click-Through Rate<br />
                    <strong>CPA</strong>: Cost Per Acquisition
                  </div>
                </div>
                <template #reference>
                  <i
                    class="fa fa-question-circle text-black-50"
                    style="cursor: pointer; margin-left: 12px;"
                  ></i>
                </template>
              </el-popover>
            </div>
            <div class="d-flex" style="gap: 12px;">
              <base-input v-if="campaignGoal.goal != 'none'" :value="campaignGoal.value" @input="validateGoalValue($event, 'create')" id="total-budget-input" class="campaign-cost-input w-100"
                label="" type="text" placeholder="0.00" maxLength="20"
                @keydown="restrictInput" @blur="formatGoalValue('create')"
                :addon-left-icon="campaignGoal.goal != 'ctr' ? 'fas fa-dollar-sign' : ''"
                :addon-right-icon="campaignGoal.goal == 'ctr' ? 'fa-solid fa-percent' : ''">
              </base-input>
              <el-select class="select__form__client w-100" size="large" placeholder="1" v-model="campaignGoal.goal" @change="campaignGoalChange">
                <el-option v-for="option in campaignGoal.options" :value="option.id" :label="(option.value == null || option.value === false) ? '' : String(option.value)"
                  :key="option.id">
                </el-option>
              </el-select>
            </div>
          </div>
        </div>
        <div v-if="false && $store.getters.userData.user_type != 'client'" class="col-sm-12 col-md-12 col-lg-12 d-flex flex-wrap flex-md-nowrap mt-2" style="gap:16px;">
          <div class="w-50 pr-2">
            <div class="d-flex">
              <label for="goal-select">Agency Profit Margin</label>
              <el-popover
                placement="top"
                :width="300"
                trigger="hover"
                effect="light"
                :open-delay="300">
                <div class="tooltip-content">
                  <p>This percentage is your agency's profit.</p>
                  <p>It will be deducted from the client's monthly ad budget, and the remainder will be spent on ads.</p>
                </div>
                <template #reference>
                  <i class="fa fa-question-circle text-black-50" style="cursor: pointer; margin-left: 12px;"></i>
                </template>
              </el-popover>
            </div>
            <div class="d-flex" style="gap: 12px;">
              <el-select class="select__form__client w-100" size="large" placeholder="Agency Profit Margin Percentage" v-model="agencyMarkup.selected">
                <el-option v-for="markup in agencyMarkup.list" :value="markup.value" :label="(markup.text == null || markup.text === false) ? '' : String(markup.text)"
                  :key="markup.value">
                </el-option>
              </el-select>
            </div>
          </div>
        </div>
        <!-- ini adalah budget -->
        
        <!-- Divider -->
        <div class="col-sm-12 col-md-12 col-lg-12 my-4">
          <hr style="border: 0; border-top: 2px solid #e0e0e0; margin: 0;">
        </div>
        
        <!-- Conversions section -->
        <h4 class="col-sm-12 col-md-12 col-lg-12 font-weight-600 m-0 text-dark my-4" style="font-size: 20px;">
          Conversions
        </h4>
        <div class="col-sm-12 col-md-12 col-lg-12">
          <!-- Site Conversion -->
          <div v-if="isLocalModuleActive" class="col-sm-12 col-md-12 col-lg-12 mb-4">
            <div class="d-flex align-items-center mb-3">
              <el-tooltip
                :content="getSiteConversionTooltipMessage()"
                placement="top"
                :disabled="SelectedCampaignsAudience.length > 0 && hasLocalCampaignInSelected"
                effect="light">
                <el-switch
                  v-model="enableSiteConversion"
                  active-text="Site Conversion"
                  inactive-text=""
                  :disabled="SelectedCampaignsAudience.length === 0 || !hasLocalCampaignInSelected"
                  @change="toggleSiteConversion">
                </el-switch>
              </el-tooltip>
              <span class="ml-3 text-dark" style="font-size: 14px;">
                Enable site conversion tracking
              </span>
              <el-popover placement="top" :width="400" trigger="hover">
                <div class="tooltip-content">
                  <p>An online conversion tracked by a Simpli.fi tag. Site Conversions occur when a user, after receiving an ad, completes a specific action on the advertiser's website within the set attribution window.</p>
                </div>
                <template #reference>
                  <i class="fa fa-question-circle text-black-50" style="cursor: pointer; margin-left: 8px;"></i>
                </template>
              </el-popover>
            </div>
            <div v-if="enableSiteConversion" class="mt-3">
              <label class="mb-2">Select Conversion Types</label>
              <div style="position: relative;">
                <el-select 
                  ref="conversionTypesSelectCreate"
                  multiple
                  class="select__form__client w-100 select-info select-fullwidth" 
                  size="large"
                  :placeholder="loadingConversionTypes ? 'Loading conversion types...' : 'Choose conversion types'" 
                  v-model="selectedConversionTypes"
                  :loading="false"
                  :disabled="false"
                  @visible-change="handleConversionTypesVisibleChange">
                  <!-- Show skeleton loader while loading and no data -->
                  <template v-if="loadingConversionTypes && conversionTypes.length === 0">
                    <el-option 
                      v-for="n in 4" 
                      :key="`skeleton-${n}`"
                      :value="null"
                      :label="`Loading...`"
                      disabled
                      style="opacity: 0.6; cursor: not-allowed;">
                      <span style="display: flex; align-items: center; width: 100%;">
                        <i class="el-icon-loading" style="margin-right: 8px; animation: rotating 1s linear infinite; color: #409EFF;"></i>
                        <span style="flex: 1; background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%); background-size: 200% 100%; animation: shimmer 1.5s infinite; height: 16px; border-radius: 4px; max-width: 150px;"></span>
                      </span>
                    </el-option>
                  </template>
                  <!-- Show actual conversion types -->
                  <el-option 
                    v-for="type in conversionTypes" 
                    :value="type.id" 
                    :label="(type.name == null || type.name === false) ? '' : String(type.name)"
                    :key="`conversion-type-create-${type.id}`">
                    <span style="display: flex; align-items: center;">
                      <span>{{ type.name }}</span>
                      <i v-if="loadingConversionTypes && conversionTypes.length > 0" class="el-icon-loading" style="margin-left: auto; font-size: 12px; color: #409EFF; animation: rotating 1s linear infinite;"></i>
                    </span>
                  </el-option>
                </el-select>
              </div>
              <small v-if="loadingConversionTypes && conversionTypes.length === 0" class="text-muted d-block mt-2" style="opacity: 0.7;">
                <i class="el-icon-loading" style="animation: rotating 1s linear infinite; margin-right: 4px;"></i>
                Loading conversion types from API...
              </small>
              <small v-else-if="!loadingConversionTypes" class="text-muted d-block mt-2">
                Select one or more conversion types to track (e.g., Purchase/Sale)
              </small>
              <small v-if="conversionTypes.length === 0 && !loadingConversionTypes" class="text-warning d-block mt-1">
                No conversion types available. Please try refreshing.
              </small>
            </div>
          </div>
          
          <!-- Geo Conversion -->
          <div class="col-sm-12 col-md-12 col-lg-12">
            <div class="d-flex align-items-center mb-3">
              <el-switch
                v-model="enableGeoConversion"
                active-text="Geo Conversion"
                inactive-text=""
                @change="toggleGeoConversion">
              </el-switch>
              <span class="ml-3 text-dark" style="font-size: 14px;">
                Enable geo conversion tracking
              </span>
              <el-popover placement="top" :width="400" trigger="hover">
                <div class="tooltip-content">
                  <p>A conversion that occurs after a user is served an ad and then visits a Conversion Zone within the set attribution window. Review Simpli.fi's Ad Content Policy or contact your Client Success representative to see if Geo-Fencing restrictions apply to your campaign.</p>
                </div>
                <template #reference>
                  <i class="fa fa-question-circle text-black-50" style="cursor: pointer; margin-left: 8px;"></i>
                </template>
              </el-popover>
            </div>
            <div v-if="enableGeoConversion" class="mt-3">
              <div class="alert alert-info" style="margin-bottom: 15px; padding: 12px; border-left: 4px solid #409EFF; background: #e1f3ff; border-radius: 4px; color: #303133;">
                <i class="fas fa-info-circle" style="color: #409EFF; margin-right: 8px;"></i>
                <strong style="color: #303133;">Note:</strong> <span style="color: #606266;">Draw polygons on the map to define your geo conversion fences. Maximum 12 points per polygon. All fences created here will be used for conversion tracking.</span>
              </div>
              <div style="border: 1px solid #e0e0e0; border-radius: 8px; padding: 0; background: #fff; box-shadow: 0 2px 4px rgba(0,0,0,0.1); overflow: hidden;">
                <GeoFenceMap 
                  ref="geoConversionMap"
                  :campaign-id="''"
                  :is-create-mode="true"
                  :is-conversion-mode="true"
                  map-id="geo-fence-map-conversion"
                  @fences-updated="onGeoConversionFencesUpdated"
                  @leaflet-unavailable="onLeafletUnavailable"
                />
              </div>
            </div>
          </div>
        </div>
        <!-- end conversions section  -->
        
        <!-- CPA Settings -->
        <div class="col-sm-12 col-md-12 col-lg-12 mt-4">
          <h4 class="col-sm-12 col-md-12 col-lg-12 font-weight-600 m-0 text-dark my-4" style="font-size: 20px;">
            CPA Settings
            <span v-if="campaignGoal.goal !== 'cpa'" style="font-size: 13px; font-weight: normal; color: #999; margin-left: 8px;">
               (Enabled only when Goal is CPA)
            </span>
            <el-popover placement="top" :width="400" trigger="hover">
              <div class="tooltip-content">
                <p>Assign a weighted value to your viewthrough or clickthrough conversions. By default, viewthrough and clickthrough conversions are assigned an equal value of 100%.</p>
              </div>
              <template #reference>
                <i class="fa fa-question-circle text-black-50" style="cursor: pointer; margin-left: 8px;"></i>
              </template>
            </el-popover>
          </h4>
          <div class="row">
            <div class="col-sm-12 col-md-6 col-lg-6">
              <div class="form-group has-label">
                <label>Viewthrough Percentage</label>
                <el-tooltip
                  :content="campaignGoal.goal !== 'cpa' ? 'Please select CPA as campaign goal in General Info to enable CPA Settings' : ''"
                  placement="top"
                  :disabled="campaignGoal.goal === 'cpa'"
                  effect="light">
                  <base-input
                    type="number"
                    v-model.number="cpaViewThruPercentage"
                    :min="0"
                    :max="100"
                    step="0.1"
                    placeholder="100"
                    class="conversion-settings-input mb-0 pb-0"
                    :class="{ 'custom-disabled-input': campaignGoal.goal !== 'cpa' }"
                    :disabled="campaignGoal.goal !== 'cpa'"
                    @blur="validateCpaViewThruPercentage"
                  >
                    <template #addonRight>
                      <span class="input-group-text">%</span>
                    </template>
                  </base-input>
                </el-tooltip>
                <small class="text-muted">Max: 100%</small>
              </div>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-6">
              <div class="form-group has-label">
                <label>Clickthrough Percentage</label>
                <el-tooltip
                  :content="campaignGoal.goal !== 'cpa' ? 'Please select CPA as campaign goal in General Info to enable CPA Settings' : ''"
                  placement="top"
                  :disabled="campaignGoal.goal === 'cpa'"
                  effect="light">
                  <base-input
                    type="number"
                    v-model.number="cpaClickThruPercentage"
                    :min="0"
                    :max="100"
                    step="0.1"
                    placeholder="100"
                    class="conversion-settings-input mb-0 pb-0"
                    :class="{ 'custom-disabled-input': campaignGoal.goal !== 'cpa' }"
                    :disabled="campaignGoal.goal !== 'cpa'"
                    @blur="validateCpaClickThruPercentage"
                  >
                    <template #addonRight>
                      <span class="input-group-text">%</span>
                    </template>
                  </base-input>
                </el-tooltip>
                <small class="text-muted">Max: 100%</small>
              </div>
            </div>
          </div>
        </div>
        
        <!-- Attribution Settings -->
        <div class="col-sm-12 col-md-12 col-lg-12 mt-4">
          <h4 class="col-sm-12 col-md-12 col-lg-12 font-weight-600 m-0 text-dark my-4" style="font-size: 20px;">
            Attribution Settings
            <el-popover
              placement="top"
              :width="400"
              trigger="hover"
            >
              <div class="tooltip-content">
                <p>The amount of time a conversion will be tracked after an ad is served. The maximum amount of time a conversion can be tracked is 30 days.</p>
              </div>
              <template #reference>
                <i class="fa fa-question-circle text-black-50" style="cursor: pointer; margin-left: 8px;"></i>
              </template>
            </el-popover>
          </h4>
          <div class="row">
            <div class="col-sm-12 col-md-6 col-lg-6">
              <div class="form-group has-label">
                <label>View Attribution Window</label>
                <base-input
                  type="number"
                  v-model.number="viewAttributionWindow"
                  :min="1"
                  :max="30"
                  placeholder="30"
                  class="conversion-settings-input mb-0 pb-0"
                  @blur="validateViewAttributionWindow"
                >
                  <template #addonRight>
                    <span class="input-group-text">days</span>
                  </template>
                </base-input>
                <small class="text-muted">Max: 30 days</small>
              </div>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-6">
              <div class="form-group has-label">
                <label>Click Attribution Window</label>
                <base-input
                  type="number"
                  v-model.number="clickAttributionWindow"
                  :min="1"
                  :max="30"
                  placeholder="30"
                  class="conversion-settings-input mb-0 pb-0"
                  @blur="validateClickAttributionWindow"
                >
                  <template #addonRight>
                    <span class="input-group-text">days</span>
                  </template>
                </base-input>
                <small class="text-muted">Max: 30 days</small>
              </div>
            </div>
          </div>
        </div>
        
        <!-- Divider -->
        <div class="col-sm-12 col-md-12 col-lg-12 my-4">
          <hr style="border: 0; border-top: 2px solid #e0e0e0; margin: 0;">
        </div>
        
        <!-- Inventory section -->
        <h4 class="col-sm-12 col-md-12 col-lg-12 font-weight-600 m-0 text-dark my-4" style="font-size: 20px;">
          Inventory
        </h4>
        <h4 class="col-sm-12 col-md-12 col-lg-12 font-weight-600 m-0 text-dark my-4" style="font-size: 20px;">
          Device Type
        </h4>
       <div class="col-sm-12 col-md-12 col-lg-12">
          <!-- Main Device Types -->
          <div class="row mb-3">
            <!-- Desktop, Mobile, Tablet -->
            <div v-for="item in (deviceTypes || []).filter(dt => dt.name !== 'Connected TV' && !dt.name.startsWith('Connected TV - '))" :key="item.name" class="col-6 col-sm-4 col-md-3 d-flex align-items-start mb-2">
              <el-checkbox 
                class="checkbox-advanced-information" 
                :label="(item.name == null || item.name === false) ? '' : String(item.name)" 
                v-model="item.val"
              >
                <span>{{ item.name }}</span>
                
              </el-checkbox>
            </div>
            
            <!-- Connected TV -->
            <div v-for="item in (deviceTypes || []).filter(dt => dt.name === 'Connected TV')" :key="item.name" class="col-6 col-sm-4 col-md-3 d-flex align-items-start mb-2">
              <el-checkbox 
                class="checkbox-advanced-information" 
                :label="(item.name == null || item.name === false) ? '' : String(item.name)" 
                v-model="item.val"
              >
                <span>{{ item.name }}</span>
              </el-checkbox>
              <el-popover
                effect="light"
                :open-delay="300"
                placement="top"
                width="400"
                trigger="hover"
              >
                <template>
                  <div style="text-align: left; overflow-wrap: break-word; max-width: 380px;">
                    <div style="line-height: 1.5; word-break: normal;">
                      A device type that allows you to target large screen devices,
                      such as Smart TVs or devices that can connect to a TV,
                      including streaming boxes, media streaming devices,
                      and gaming consoles.
                    </div>
                    <div style="margin-top: 12px;"><strong>Targeted devices:</strong></div>
                    <div style="margin-top: 8px; line-height: 1.6; word-break: normal;">
                      Amazon, MBX, Nvidia, Tivo, Apple, Mecool, Opera, Toshiba,
                      Beelink, Microsoft, Panasonic, Tronsmart, Bqeel, Minix, Philips, Vizio,
                      Dooh TV, Mozilla, Roku, Xiaomi, Google, MStar, Samsung, Xlintek,
                      Hisense, MXQ, Sanyo, LG, Nexbox, Sharp, Logitech, Nintendo, Sony
                    </div>
                  </div>
                </template>
                <template #reference>
                  <i
                    class="fa fa-question-circle text-black-50"
                    style="cursor: pointer; margin-left: 12px;"
                  ></i>
                </template>
              </el-popover>
            </div>
          </div>
        </div>
        
        <!-- Divider -->
        <div class="col-sm-12 col-md-12 col-lg-12 my-4">
          <hr style="border: 0; border-top: 2px solid #e0e0e0; margin: 0;">
        </div>
        
        <!-- Ads section -->
        <h4 class="col-sm-12 col-md-12 col-lg-12 font-weight-600 m-0 text-dark my-4" style="font-size: 20px;">
          ADs
        </h4>
        <div class="col-sm-12 col-md-12 col-lg-12">
          <div style="display: flex; flex-direction: column;">
            <label>Media Type</label>
            <el-select 
              :key="`media-type-select-${selectedMediaType}`"
              id="select-from-campaigns"
              class="select__form__client w-100 select-info select-fullwidth campaign-audiance-dropdown" 
              size="large"
              placeholder="Select Media type" 
              :value="selectedMediaType" 
              label="Media Type" 
              @change="onMediaTypeChange">
              <el-option v-for="option in mediaTypes" :value="option.id" :label="(option.value == null || option.value === false) ? '' : String(option.value)" :key="option.id">
              </el-option>
            </el-select>
          </div>
        </div>

        <div class="col-sm-12 col-md-12 col-lg-12 mt-4">
            <div class="inserted-media-list">
              <span v-if="false" class="title">Inserted Media List</span>

              <div class="input-wrapper">
                <base-input
                  label="Ad Click Destination URL"
                  type="text"
                  v-model="campaign.destinationURL"
                  placeholder="e.g., https://www.example.com/"
                  :maxlength="255"
                  class="mb-0 pb-0 w-100"
                />

                <el-button
                  @click="openMediaSelectAdd"
                  class="upload-button"
                  icon="el-icon-upload2"
                  plain
                >
                  Select Media
                </el-button>
              </div>
              
              <!-- Minimum Recommended Sizes Section (Display only) -->
              <div v-if="selectedMediaType !== 'video'" class="recommended-sizes-section mt-4 mb-3">
                <div class="recommended-sizes-header">
                  <i class="el-icon-star-on" style="color: #409EFF; margin-right: 8px;"></i>
                  <span class="recommended-sizes-title">Minimum Recommended Sizes</span>
                </div>
                <div class="recommended-sizes-description">
                  <span>For optimal display performance and compatibility across all advertising platforms</span>
                </div>
                <div class="recommended-sizes-grid">
                  <span class="size-badge">300×250</span>
                  <span class="size-badge">728×90</span>
                  <span class="size-badge">160×600</span>
                  <span class="size-badge">300×600</span>
                  <span class="size-badge">320×50</span>
                  <span class="size-badge">300×50</span>
                  <span class="size-badge">970×250</span>
                  <span class="size-badge">250×250</span>
                  <span class="size-badge">200×200</span>
                </div>
              </div>
              
              <!-- Video Requirements Section (Video campaign only) -->
              <div v-if="selectedMediaType === 'video'" class="recommended-sizes-section mt-4 mb-3">
                <div class="recommended-sizes-header">
                  <i class="el-icon-video-camera" style="color: #409EFF; margin-right: 8px;"></i>
                  <span class="recommended-sizes-title">Video Requirements</span>
                </div>
                <div class="recommended-sizes-description">
                  <span>Video dimensions are flexible, but must meet minimum requirements</span>
                </div>
                <div class="recommended-sizes-grid">
                  <span class="size-badge" style="background: #f0f9ff; border-color: #409EFF; color: #409EFF; font-weight: 600;">
                    Minimum: 768×576
                  </span>
                  <span class="size-badge" style="background: #f0f9ff; border-color: #67C23A; color: #67C23A; font-weight: 600;">
                    Preferred: 1920×1080
                  </span>
                  <span class="size-badge" style="background: #f0f9ff; border-color: #67C23A; color: #67C23A; font-weight: 600;">
                    Preferred: 1920×1200
                  </span>
                  <span class="size-badge" style="background: #f0f9ff; border-color: #909399; color: #909399;">
                    Aspect Ratio: 16:9
                  </span>
                </div>
              </div>
            </div>
            
          <media-list class="mt-3" 
          :masterDestinationURL="campaign.destinationURL"
          :tableData="selectedMediaList"
          @remove-media="onRemoveMedia"
          @update-media-data="onMediaListUpdated"
          @media-selection-changed="onMediaListSelectionChanged"
          mode="add"
          ref="mediaList"
          ></media-list>
          <div style="font-size: 14px;">
            <!-- <span><strong>Note: </strong>Only .jpg, .png or .gif formats supported for display ad</span></br> -->
            <!-- <span>Supported dimentions are 250x250, 300x250, 300x600, 970x250</span> -->
          </div>
        </div>
        <!-- ads section end -->

      </div>
      <!-- step 1 -->

      <!-- step 2 -->
      <div v-if="stepCreateCampaignActive == 2" class="row">
        <h4 class="col-sm-12 col-md-12 col-lg-12 font-weight-600 m-0 text-dark mb-4" style="font-size: 20px;">
          Budget Information
        </h4>
        
        <div class="col-sm-12 col-md-12 col-lg-12 d-flex flex-wrap flex-md-nowrap" style="gap:16px;">
          <div class="w-100">
            <div class="d-flex">
              <label for="max-bid-input">Max Bid</label>
              <el-popover
                placement="top"
                :width="300"
                trigger="hover"
                effect="light"
                :open-delay="300"
              >
                <div class="tooltip-content">
                  <p>The maximum amount you are willing to pay for an impression.</p>
                  <p>The max bid is set at the campaign level.</p>
                </div>
                <template #reference>
                  <i
                    class="fa fa-question-circle text-black-50"
                    style="cursor: pointer; margin-left: 12px;"
                  ></i>
                </template>
              </el-popover>
            </div>
            <base-input 
              id="max-bid-input" 
              class="campaign-cost-input"
              :class="{'error-input-price-simplifi': simplifiErrorInput.addCampaign.maxBid}"
              label="" type="text" placeholder="0.00" addon-left-icon="fas fa-dollar-sign" v-model="campaign.maxBid"
              maxLength="20"
              @copy.prevent @cut.prevent @paste.prevent
              @input="onSimplifiPriceInput('addCampaign', 'maxBid', $event)"
              @keydown="restrictInput"
              @keyup="validateMinimumInput('keyup','addCampaign','maxBid')" 
              @blur="validateMinimumInput('blur','addCampaign','maxBid')">
              <template #addonRight>
                <span class="input-group-text">CPM</span>
              </template>
            </base-input>
            <span v-if="simplifiErrorInput.addCampaign.maxBid" v-html="simplifiErrorInput.addCampaign.maxBid" class="error-message-price-simplifi"></span>
          </div>
          <div class="w-100">
            <label for="total-budget-input">Monthly Budget</label>
            <base-input 
              id="total-budget-input" 
              class="campaign-cost-input" 
              label="" type="text" placeholder="0.00" addon-left-icon="fas fa-dollar-sign" v-model="campaign.totalBudget"
              maxLength="20"
              @copy.prevent @cut.prevent @paste.prevent
              @input="onBudgetInput('totalBudget', $event)" 
              @keydown="restrictInput"
              @keyup="validateMinimumInput('keyup','addCampaign','monthlyBudget')" 
              @blur="validateMinimumInput('blur','addCampaign','monthlyBudget')">
            </base-input>
          </div>
        </div>
        <div class="col-sm-12 col-md-12 col-lg-12 d-flex flex-wrap flex-md-nowrap mt-2" style="gap:16px;">
          <div class="w-100">
            <div class="d-flex">
              <label for="max-bid-input">Daily Budget</label>
              <el-popover
                  placement="top"
                  :width="320"
                  trigger="hover"
                  effect="light"
                  :open-delay="300"
                  >
                    <div class="tooltip-content">
                      <p>The maximum dollar amount that your campaign should spend in a day.</p>
                      <p>If a Daily Budget is not provided, your campaign will spend its Total or Monthly Budget as quickly as possible, regardless of the campaign's end date.</p>
                      <p>Best practices recommend that you include a Daily Budget.</p>
                    </div>
                    <template #reference>
                      <i
                        class="fa fa-question-circle text-black-50"
                        style="cursor: pointer; margin-left: 12px;"
                      ></i>
                    </template>
              </el-popover>
            </div>
            <base-input 
              id="max-bid-input" 
              class="campaign-cost-input" 
              :class="{'error-input-price-simplifi': simplifiErrorInput.addCampaign.dailyBudget}"
              label="" type="text" placeholder="0.00" addon-left-icon="fas fa-dollar-sign" v-model="campaign.dailyBudget"
              maxLength="20"
              @copy.prevent @cut.prevent @paste.prevent
              @input="onBudgetInput('dailyBudget', $event)" 
              @keydown="restrictInput"
              @keyup="validateMinimumInput('keyup','addCampaign','dailyBudget')"
              @blur="validateMinimumInput('blur','addCampaign','dailyBudget')">
            </base-input>
            <span v-if="simplifiErrorInput.addCampaign.dailyBudget" v-html="simplifiErrorInput.addCampaign.dailyBudget" class="error-message-price-simplifi"></span>
          </div>
          <div class="w-100">
            <div class="d-flex">
              <label for="goal-select">Goal</label>
              <el-popover
                placement="top"
                :width="320"
                trigger="hover"
                effect="light"
                :open-delay="300"
                >
                <div class="tooltip-content">
                  <p>The goal of your current Campaign. The selected Goal dictates how the campaign will be optimized.</p>
                  <div class="tooltip-definitions">
                    <strong>CPC</strong>: Cost Per Click<br />
                    <strong>CTR</strong>: Click-Through Rate<br />
                    <strong>CPA</strong>: Cost Per Acquisition
                  </div>
                </div>
                <template #reference>
                  <i
                    class="fa fa-question-circle text-black-50"
                    style="cursor: pointer; margin-left: 12px;"
                  ></i>
                </template>
              </el-popover>
            </div>
            <div class="d-flex" style="gap: 12px;">
              <base-input v-if="campaignGoal.goal != 'none'" :value="campaignGoal.value" @input="validateGoalValue($event, 'create')" id="total-budget-input" class="campaign-cost-input w-100"
                label="" type="text" placeholder="0.00" maxLength="20"
                @keydown="restrictInput" @blur="formatGoalValue('create')"
                :addon-left-icon="campaignGoal.goal != 'ctr' ? 'fas fa-dollar-sign' : ''"
                :addon-right-icon="campaignGoal.goal == 'ctr' ? 'fa-solid fa-percent' : ''">
              </base-input>
              <el-select class="select__form__client w-100" size="large" placeholder="1" v-model="campaignGoal.goal" @change="campaignGoalChange">
                <el-option v-for="option in campaignGoal.options" :value="option.id" :label="(option.value == null || option.value === false) ? '' : String(option.value)"
                  :key="option.id">
                </el-option>
              </el-select>
            </div>
          </div>
        </div>
        <div v-if="$store.getters.userData.user_type != 'client'" class="col-sm-12 col-md-12 col-lg-12 d-flex flex-wrap flex-md-nowrap mt-2" style="gap:16px;">
          <div class="w-100 pr-2">
            <div class="d-flex">
              <label for="goal-select">Agency Profit Margin</label>
              <el-popover
                placement="top"
                :width="300"
                trigger="hover"
                effect="light"
                :open-delay="300">
                <div class="tooltip-content">
                  <p>This percentage is your agency's profit.</p>
                  <p>It will be deducted from the client's monthly ad budget, and the remainder will be spent on ads.</p>
                </div>
                <template #reference>
                  <i class="fa fa-question-circle text-black-50" style="cursor: pointer; margin-left: 12px;"></i>
                </template>
              </el-popover>
            </div>
            <div class="d-flex" style="gap: 12px;">
              <el-select placeholder="0%" class="select__form__client w-100" size="large" v-model="agencyMarkup.selected" :disabled="agencyMarkup.coversCost" @change="profitcalculation('add_campaign')">
                <el-option v-for="markup in agencyMarkup.list" :value="markup.value" :label="(markup.text == null || markup.text === false) ? '' : String(markup.text)" :key="markup.value"/>
              </el-select>
              <el-checkbox v-model="agencyMarkup.coversCost" size="large">
                Client costs covered by Agency
              </el-checkbox>
            </div>
          </div>
        </div>

        <div style="border:solid 1px;opacity:0.5;margin-top:30px;margin-left:10px;width:100%">&nbsp;</div>

        <div class="col-12 mx-1" style="margin-top: 10px;">
          <div class="row d-flex justify-content-between">
            <!-- budget calclations -->
             <div class="col-12 col-md-4 col-lg-4 pt-2 d-flex flex-column align-items-start"> <!-- NEW -->
              <div class="d-flex flex-column">
                <small>1. Client Monthly Cost (Add Campaign) : </small>
                <small class="ml-2">(Monthly Budget) : <strong>${{ campaign.totalBudget }}</strong></small>
              </div>
            </div>
            <!-- budget calclations -->
          
            <!-- client calculations -->
            <div v-if="$store.getters.userData.user_type != 'client'" class="col-12 col-md-4 col-lg-4 pt-2 d-flex flex-column align-items-center"> <!-- NEW -->
              <div class="d-flex flex-column mb-2">
                <small>1. Agency Profit (Add Campaign) : </small>
                <small class="ml-2">(Monthly Budget x Agency Profit Margin%) : </small>
                <small class="ml-2">(${{ campaign.totalBudget }} x {{ agencyMarkup.selected }}%) : <strong>${{ formatPrice(LeadspeekProfitAgency) }}</strong></small>
              </div>
            </div>
            <!-- client calculations -->
  
            <!-- agency calculations -->
            <div v-if="$store.getters.userData.user_type != 'client'" class="col-12 col-md-4 col-lg-4 pt-2 d-flex flex-column align-items-end"> <!-- NEW -->
              <div class="d-flex flex-column mb-2">
                <small>1. Client Monthly Ad Budget (Add Campaign): </small>
                <small class="ml-2">(Monthly Budget - Agency Profit) : </small>
                <small class="ml-2">(${{ campaign.totalBudget }} - {{ formatPrice(LeadspeekProfitAgency) }}) : <strong>${{ formatPrice(LeadspeekCostAgency) }}</strong></small>
              </div>
            </div>
            <!-- agency calculations -->
          </div>
        </div>
      </div>
      <!-- step 2 -->

      <template slot="footer">
        <div class="align-items-center col-lg-12 col-md-12 col-sm-12 d-flex flex-row-reverse flex-wrap" style="gap:8px">
          <base-button v-if="$global.menuLeadsPeek_update && stepCreateCampaignActive == 1" size="sm" :id="'btnNext'" style="height:40px" @click="nextStepCreateCampaign()">
            Next
          </base-button>
          <base-button v-else-if="$global.menuLeadsPeek_update && stepCreateCampaignActive == 2" size="sm" :id="'btnSave'" style="height:40px" @click="ProcessAddEditClient('')">
            Save
          </base-button>
          <base-button v-if="$global.menuLeadsPeek_update && stepCreateCampaignActive == 2" size="sm" :id="'btnPrevious'" style="height:40px" @click="previousStepCreateCampaign()">
            Previous
          </base-button>
          <base-button :id="'btnCancel'" size="sm" style="height:40px" @click="CancelAddEditClient('')">
            Cancel
          </base-button>
        </div>
      </template>
    </modal>
    <!-- create campaign modal end -->

    <!-- edit campaign modal start-->
    <modal :show.sync="modals.editCampaign" id="editCampaign" bodyClasses="create-campaign-modal-body"
      footerClasses="border-top p-2">
      <div slot="header" class="border-bottom pb-3 w-100">
        <h3 class="title title-up">Edit Campaign #{{ selectedRowData.leadspeek_api_id }}</h3>
      </div>

      <div class="row">
        <h4 class="col-sm-12 col-md-12 col-lg-12 font-weight-600 m-0 text-dark mb-4" style="font-size: 20px;">
          Client Info
        </h4>
        <div class="col-sm-12 col-md-12 col-lg-12"
          style="cursor: not-allowed;">
          <base-input class="disabled" label="Client Name" type="text" placeholder="Select Client Name"
            v-model="this.selectedRowData.company_name">
          </base-input>
        </div>

        <div class="col-sm-12 col-md-12 col-lg-12"
          style="cursor: not-allowed;">
          <base-input class="disabled" label="Contact Name" type="text" placeholder="Input Client Contact Name"
            v-model="selectedRowData.name">
          </base-input>
        </div>
        <div class="col-sm-6 col-md-6 col-lg-6"
          style="cursor: not-allowed;">
          <base-input class="disabled" label="Email" type="email" placeholder="Input Client Email"
            v-model="selectedRowData.email">
          </base-input>
        </div>
        <div class="col-sm-6 col-md-6 col-lg-6"
          style="cursor: not-allowed;">
          <base-input class="disabled" label="Phone Number" type="text" placeholder="Input Client Phone"
            v-model="selectedRowData.phonenum">
          </base-input>
        </div>
        
        <!-- Divider -->
        <div class="col-sm-12 col-md-12 col-lg-12 my-4">
          <hr style="border: 0; border-top: 2px solid #e0e0e0; margin: 0;">
        </div>
        
        <h4 class="col-sm-12 col-md-12 col-lg-12 font-weight-600 m-0 text-dark my-4" style="font-size: 20px;">
          General Info
        </h4>
        <div class="col-sm-12 col-md-12 col-lg-12 form-group has-label pull-left">
          <base-input label="Campaign Name" type="text" placeholder="e.g., Summer 2024 Launch"
            v-model="selectedRowData.campaign_name" :maxlength="255" class="mb-0 pb-0">
          </base-input>
          <small id="err_campaignname" style="display:none;color:#942434 !important;">
            * Campaign Name is required
          </small>
        </div>
        <div class="col-sm-12 col-md-12 col-lg-12 pull-left mt-2">
          <div class="d-flex">
            <label for="frequency-capping-input">Frequency Capping</label>
            <el-tooltip
              content="<span>A campaign Feature that allows you to limit, or cap,<br> the number of impressions a device is served within a certain timeframe.<br>The timeframe can range from 1 to 24 hours</span>"
              effect="light" :open-delay="300" placement="top">
              <template #content><span>A campaign Feature that allows you to limit, or cap,<br />
                  the number of impressions a device is served within a certain
                  timeframe.<br />The timeframe can range from 1 to 24
                  hours</span></template>
              <div class="text-center">
                <i class="fa fa-question-circle text-black-50" style="cursor: pointer; margin-left: 12px;"></i>
              </div>
            </el-tooltip>
          </div>

          <div class="m-0 d-flex flex-wrap align-items-center" style="gap: 8px;">
            <base-input id="frequency-capping-input" label="" type="text" placeholder="e.g., 5"
              v-model="selectedRowData.frequency_capping_impressions" :maxlength="2" class="mb-0 pb-0 w-25" @keydown="event => restrictInput(event, 'integer')">
            </base-input>
            <span class="text-black-50" style="font-size: small;">imps/per</span>
            <el-select class="select__form__client" size="large" placeholder="1" v-model="selectedRowData.frequency_capping_hours">
              <el-option v-for="option in frequencyCapping.hoursOptions" :value="option.id" :label="(option.val == null || option.val === false) ? '' : String(option.val)"
                :key="option.id">
              </el-option>
            </el-select>
            <span class="text-black-50" style="font-size: small;">hours</span>
          </div>

          <small id="err_frequencycapping" style="display:none;color:#942434 !important;">
            * frequency capping required
          </small>
        </div>

        <!-- Divider -->
        <div class="col-sm-12 col-md-12 col-lg-12 my-4">
          <hr style="border: 0; border-top: 2px solid #e0e0e0; margin: 0;">
        </div>

        <!-- Targeting Settings section -->
        <h4 class="col-sm-12 col-md-12 col-lg-12 font-weight-600 m-0 text-dark my-4" style="font-size: 20px;">
          Targeting Settings
        </h4>
        
        <!-- Geo Fence Section -->
        <h4 class="col-sm-12 col-md-12 col-lg-12 font-weight-600 m-0 text-dark my-4" style="font-size: 20px;">
          Geo Targeting
        </h4>
        <div class="col-sm-12 col-md-12 col-lg-12">
          <div class="d-flex flex-column flex-md-row align-items-start align-items-md-center mb-3">
            <div class="mb-2 mb-md-0 flex-shrink-0">
              <el-switch
                v-model="editUseGeoFence"
                active-text="Use Geo Fences"
                inactive-text="Use Default Targeting"
                :disabled="!leafletAvailable || !isSelectedCampaignDraft">
              </el-switch>
            </div>

            <div
              v-if="isSelectedCampaignDraft"
              class="d-flex align-items-start w-100 ml-md-3"
              style="max-width: 600px; padding: 10px 12px; background: #d1ecf1; border: 1px solid #17a2b8; border-radius: 6px; box-shadow: 0 2px 4px rgba(0,0,0,0.05);"
            >
              <i class="fas fa-info-circle" style="color: #17a2b8; font-size: 16px; margin-right: 10px; margin-top: 2px; flex-shrink: 0;"></i>
              <div style="font-size: 13px; line-height: 1.5; color: #0c5460;">
                <strong style="color: #0c5460; font-weight: 600;">Note:</strong>
                <span style="color: #0c5460;"> You can still change the Geo Targeting mode (Default vs Geo Fences) while this campaign is in Draft. Once the campaign starts running, this mode will be locked.</span>
              </div>
            </div>

            <div
              v-if="!isSelectedCampaignDraft"
              class="d-flex align-items-start w-100 ml-md-3"
              style="max-width: 600px; padding: 10px 12px; background: #f8d7da; border: 1px solid #dc3545; border-radius: 6px; box-shadow: 0 2px 4px rgba(0,0,0,0.05);"
            >
              <i class="fas fa-lock" style="color: #dc3545; font-size: 16px; margin-right: 10px; margin-top: 2px; flex-shrink: 0;"></i>
              <div style="font-size: 13px; line-height: 1.5; color: #721c24;">
                <strong style="color: #721c24; font-weight: 600;">Locked:</strong>
                <span style="color: #721c24;"> The Geo Targeting mode (Default vs Geo Fences) cannot be changed because this campaign has already run. To use a different Geo Targeting mode, please create a new campaign manually.</span>
              </div>
            </div>
          </div>
          
          <div v-if="editUseGeoFence" class="geo-fence-section">
            <div class="alert alert-info d-flex align-items-start" style="margin-bottom: 15px; padding: 12px; border-left: 4px solid #303133; background: #e1f3ff; border-radius: 4px;">
              <i class="fas fa-info-circle flex-shrink-0" style="color: #303133; margin-right: 8px; margin-top: 3px;"></i>
              <div style="font-size: 13px; line-height: 1.5;">
                <strong style="color: #303133;">Note:</strong> <span style="color: #606266;">Draw polygons on the map to define your geo fences. Maximum 12 points per polygon. Geo fences will be saved after campaign update.</span>
              </div>
            </div>
            
            <GeoFenceMap 
              ref="editGeoFenceMap"
              :campaign-id="selectedRowData.leadspeek_api_id"
              :is-create-mode="false"
              :is-draft-campaign="isSelectedCampaignDraft"
              map-id="geo-fence-map-edit-targeting"
              @fences-updated="onEditGeoFencesUpdated"
              @recency-updated="onEditRecencyUpdated"
              @leaflet-unavailable="onLeafletUnavailable">
            </GeoFenceMap>
          </div>
        </div>

        <!-- audiance section -->
        <h4 class="col-sm-12 col-md-12 col-lg-12 font-weight-600 m-0 text-dark my-4" style="font-size: 20px;">
          Addressable Audiences
          <span class="text-black-50" style="font-size: 14px;">(minimum 50 contacts required)</span>
          <span v-if="totalCombinedAudience > 0" class="text-black-50" style="font-size: 14px;">(Selected
            audience: {{
              totalCombinedAudience }})</span>
        </h4>
        <div class="col-sm-12 col-md-12 col-lg-12">
          <div
            v-if="isAddressableAudienceLocked"
            class="d-flex align-items-start w-100 mb-3"
            style="max-width: 600px; padding: 10px 12px; background: #f8d7da; border: 1px solid #dc3545; border-radius: 6px; box-shadow: 0 2px 4px rgba(0,0,0,0.05);"
          >
            <i class="fas fa-lock" style="color: #dc3545; font-size: 16px; margin-right: 10px; margin-top: 2px; flex-shrink: 0;"></i>
            <div style="font-size: 13px; line-height: 1.5; color: #721c24;">
              <strong style="color: #721c24; font-weight: 600;">Locked:</strong>
              <span style="color: #721c24;"> Addressable audiences cannot be added because this campaign has already run in Geo Optimized mode (without audience). To use audience targeting, please create a new campaign.</span>
            </div>
          </div>

          <div style="display: flex; flex-direction: column;">
            <label>Select Audience from Existing Campaigns</label>
            <el-select multiple id="select-from-campaigns"
              class="select__form__client w-100 select-info select-fullwidth campaign-audiance-dropdown" size="large"
              placeholder="Choose from available campaigns" v-model="selectedRowData.simplifi_selected_campaign"
              :disabled="isAddressableAudienceLocked"
              label="Select Audience from Existing Campaigns" :popper-append-to-body="true">
              <el-option v-for="option in filteredCampaignOptionsByProducts" :value="option.id"
                :label="String((option.leadspeek_api_id != '') ? option.campaign_name + ' (' + (option.leadspeek_type == 'b2b' ? $global.globalModulNameLink.b2b.name : option.leadspeek_type == 'enhance' ? $global.globalModulNameLink.enhance.name : option.leadspeek_type == 'locator' ?  $global.globalModulNameLink.locator.name : option.leadspeek_type == 'local' ? $global.globalModulNameLink.local.name:option.leadspeek_type ) + ' )' +' ('+ option.total_leads + ')': option.campaign_name)"
                :key="option.id">
              </el-option>
            </el-select>
          </div>
        </div>

        <div class="col-sm-12 col-md-12 col-lg-12 mt-4">
          <div class="d-flex align-items-center justify-content-between">
            <span class="font-weight-600 text-dark" style="
    font-size: 16px;
">Local Audience List</span>
            <el-button @click="modals.uploadAudiance = true" class="upload-button" icon="el-icon-upload2" :disabled="isAddressableAudienceLocked" plain>Upload
              Local
              List</el-button>
          </div>
          <UserLocalAudiance
          ref="userLocalAudienceEdit"
          :user-id="selectedRowData.user_id"
          :selected-audience-ids="selectedRowData.simplifi_selected_audience"
          :disabled="isAddressableAudienceLocked"
          @selection-changed="onAudienceSelected"
          ></UserLocalAudiance>
        </div>
        <!-- end audiance section  -->
        <!-- <h4 class="col-sm-12 col-md-12 col-lg-12 font-weight-600 m-0 text-dark my-4" style="font-size: 20px;">
          Budget
        </h4>
        <div class="col-sm-12 col-md-12 col-lg-12 d-flex flex-wrap flex-md-nowrap" style="gap:16px;">
          <div class="w-100">
            <div class="d-flex">
              <label for="max-bid-input">Max Bid</label>
              <el-tooltip
                content="<span>The maximum amount you are willing to pay for an <br> impression. The max bid is set at the campaign <br>level.</span>"
                effect="light" :open-delay="300" placement="top">
                <template #content><span>The maximum amount you are willing to pay for an <br />
                    impression. The max bid is set at the campaign
                    <br />level.</span></template>
                <div class="text-center">
                  <i class="fa fa-question-circle text-black-50" style="cursor: pointer; margin-left: 12px;"></i>
                </div>
              </el-tooltip>
            </div>
            <base-input id="max-bid-input" class="campaign-cost-input" label="" type="text" placeholder="0.00"
              addon-left-icon="fas fa-dollar-sign" v-model="selectedRowData.max_bid" @copy.prevent @cut.prevent @paste.prevent
              @keydown="restrictInput">
              <template #addonRight>
                <span class="input-group-text">CPM</span>
              </template>
            </base-input>
          </div>
          <div class="w-100">
            <label for="total-budget-input">Monthly Budget</label>
            <base-input id="total-budget-input" class="campaign-cost-input" label="" type="text" placeholder="0.00"
              addon-left-icon="fas fa-dollar-sign" v-model="selectedRowData.monthly_budget"
              @input="onBudgetInput('totalBudgetEdit', $event)" @copy.prevent @cut.prevent @paste.prevent
              @keydown="restrictInput">
            </base-input>
          </div>
        </div>
        <div class="col-sm-12 col-md-12 col-lg-12 d-flex flex-wrap flex-md-nowrap mt-2" style="gap:16px;">
          <div class="w-100">
            <div class="d-flex">
              <label for="max-bid-input">Daily Budget</label>
              <el-tooltip
                content="<span>The maximum dollar amount that your campaign <br> should spend in a day.<br> If a Daily Budget is not provided, your campaign will <br> spend its Total or Monthly Budget as quickly as <br> possible, regardless of the campaign’s end date. <br>Best practices recommend that you include a Daily Budget</span>"
                effect="light" :open-delay="300" placement="top">
                <template #content><span>The maximum dollar amount that your campaign <br />
                    should spend in a day.<br />
                    If a Daily Budget is not provided, your campaign will <br />
                    spend its Total or Monthly Budget as quickly as <br />
                    possible, regardless of the campaign’s end date. <br />Best
                    practices recommend that you include a Daily Budget</span></template>
                <div class="text-center">
                  <i class="fa fa-question-circle text-black-50" style="cursor: pointer; margin-left: 12px;"></i>
                </div>
              </el-tooltip>
            </div>
            <base-input id="max-bid-input" class="campaign-cost-input" label="" type="text" placeholder="0.00"
              addon-left-icon="fas fa-dollar-sign" v-model="selectedRowData.daily_budget"
              @input="onBudgetInput('dailyBudgetEdit', $event)" @copy.prevent @cut.prevent @paste.prevent
              @keydown="restrictInput">
            </base-input>
          </div>
          <div class="w-100">
            <div class="d-flex">
              <label for="goal-select">Goal</label>
              <el-tooltip
                content="<span>The goal of your current Campaign.<br>The selected Goal dictates how the campaign will be optimized</span><br>CPC:Cost Per Click<br>CTR:Click-Through Rate<br>CPA:Cost Per Acquisition"
                effect="light" :open-delay="300" placement="top">
                <template #content><span>The goal of your current Campaign.<br>The selected Goal dictates how the
                    campaign will be optimized</span><br>CPC:Cost Per Click<br>CTR:Click-Through Rate<br>CPA:Cost Per
                  Acquisition</template>
                <div class="text-center">
                  <i class="fa fa-question-circle text-black-50" style="cursor: pointer; margin-left: 12px;"></i>
                </div>
              </el-tooltip>
            </div>
            <div class="d-flex" style="gap: 12px;">
              <base-input v-if="selectedRowData.goal_type != 'none'" :value="selectedRowData.goal_value" @input="validateGoalValue($event, 'edit')" id="total-budget-input" class="campaign-cost-input w-100"
                label="" type="text" placeholder="0.00" maxLength="20"
                @keydown="restrictInput" @blur="formatGoalValue('edit')"
                :addon-left-icon="selectedRowData.goal_type != 'ctr' ? 'fas fa-dollar-sign' : ''"
                :addon-right-icon="selectedRowData.goal_type == 'ctr' ? 'fa-solid fa-percent' : ''">
              </base-input>
              <el-select class="select__form__client w-100" size="large" placeholder="1" v-model="selectedRowData.goal_type" @change="campaignGoalChange">
                <el-option v-for="option in campaignGoal.options" :value="option.id" :label="(option.value == null || option.value === false) ? '' : String(option.value)"
                  :key="option.id">
                </el-option>
              </el-select>
            </div>
          </div>
        </div>
        <div class="col-sm-12 col-md-12 col-lg-12 d-flex flex-wrap flex-md-nowrap mt-2" style="gap:16px;">
          <div class="w-50 pr-2">
            <div class="d-flex">
              <label for="goal-select">Agency Profit Margin</label>
            </div>
            <div class="d-flex" style="gap: 12px;">
              <el-select class="select__form__client w-100" size="large" placeholder="Agency Profit Margin Percentage" v-model="selectedRowData.agency_markup">
                <el-option v-for="markup in agencyMarkup.list" :value="markup.value" :label="(markup.text == null || markup.text === false) ? '' : String(markup.text)"
                  :key="markup.value">
                </el-option>
              </el-select>
            </div>
          </div>
        </div> -->
        
        <!-- Divider -->
        <div class="col-sm-12 col-md-12 col-lg-12 my-4">
          <hr style="border: 0; border-top: 2px solid #e0e0e0; margin: 0;">
        </div>
        
        <!-- Conversions section -->
        <h4 class="col-sm-12 col-md-12 col-lg-12 font-weight-600 m-0 text-dark my-4" style="font-size: 20px;">
          Conversions
        </h4>
          <div class="col-sm-12 col-md-12 col-lg-12">

          <!-- Site Conversion -->
          <div v-if="isLocalModuleActive" class="col-sm-12 col-md-12 col-lg-12 mb-4">
            <div class="d-flex align-items-center mb-3">
              <el-tooltip
                :content="getSiteConversionTooltipMessage(true)"
                placement="top"
                :disabled="!loadingEditConversionState && selectedRowData.simplifi_selected_campaign && selectedRowData.simplifi_selected_campaign.length > 0 && hasLocalCampaignInSelected"
                effect="light">
                <el-switch
                  v-model="editEnableSiteConversion"
                  active-text="Site Conversion"
                  inactive-text=""
                  :disabled="loadingEditConversionState || !selectedRowData.simplifi_selected_campaign || selectedRowData.simplifi_selected_campaign.length === 0 || !hasLocalCampaignInSelected"
                  @change="toggleSiteConversion">
                </el-switch>
              </el-tooltip>
              <span class="ml-3 text-dark" style="font-size: 14px;">
                Enable site conversion tracking
              </span>
              <el-popover placement="top" :width="400" trigger="hover">
                <div class="tooltip-content">
                  <p>An online conversion tracked by a Simpli.fi tag. Site Conversions occur when a user, after receiving an ad, completes a specific action on the advertiser's website within the set attribution window.</p>
                </div>
                <template #reference>
                  <i class="fa fa-question-circle text-black-50" style="cursor: pointer; margin-left: 8px;"></i>
                </template>
              </el-popover>
            </div>
            <!-- Loading state for conversion section in edit form -->
            <div v-if="loadingEditConversionState" class="d-flex align-items-center mt-1" style="font-size: 13px; color: #909399;">
              <i class="el-icon-loading mr-2" style="font-size: 16px;"></i>
              <span>Loading site conversion data...</span>
            </div>
            <div v-if="editEnableSiteConversion" class="mt-3">
              <label class="mb-2">Select Conversion Types</label>
              <div style="position: relative;">
                <el-select 
                  ref="conversionTypesSelectEdit"
                  multiple
                  class="select__form__client w-100 select-info select-fullwidth" 
                  size="large"
                  :placeholder="loadingConversionTypes ? 'Loading conversion types...' : 'Choose conversion types'" 
                  v-model="editSelectedConversionTypes"
                  :loading="false"
                  :disabled="false"
                  @visible-change="handleConversionTypesVisibleChange">
                  <!-- Show skeleton loader while loading and no data -->
                  <template v-if="loadingConversionTypes && conversionTypes.length === 0">
                    <el-option 
                      v-for="n in 4" 
                      :key="`skeleton-edit-${n}`"
                      :value="null"
                      :label="`Loading...`"
                      disabled
                      style="opacity: 0.6; cursor: not-allowed;">
                      <span style="display: flex; align-items: center; width: 100%;">
                        <i class="el-icon-loading" style="margin-right: 8px; animation: rotating 1s linear infinite; color: #409EFF;"></i>
                        <span style="flex: 1; background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%); background-size: 200% 100%; animation: shimmer 1.5s infinite; height: 16px; border-radius: 4px; max-width: 150px;"></span>
                      </span>
                    </el-option>
                  </template>
                  <!-- Show actual conversion types -->
                  <el-option 
                    v-for="type in conversionTypes" 
                    :value="type.id" 
                    :label="(type.name == null || type.name === false) ? '' : String(type.name)"
                    :key="`conversion-type-${type.id}`">
                    <span style="display: flex; align-items: center;">
                      <span>{{ type.name }}</span>
                      <i v-if="loadingConversionTypes && conversionTypes.length > 0" class="el-icon-loading" style="margin-left: auto; font-size: 12px; color: #409EFF; animation: rotating 1s linear infinite;"></i>
                    </span>
                  </el-option>
                </el-select>
              </div>
              <small v-if="loadingConversionTypes && conversionTypes.length === 0" class="text-muted d-block mt-2" style="opacity: 0.7;">
                <i class="el-icon-loading" style="animation: rotating 1s linear infinite; margin-right: 4px;"></i>
                Loading conversion types from API...
              </small>
              <small v-else-if="!loadingConversionTypes" class="text-muted d-block mt-2">
                Select one or more conversion types to track (e.g., Purchase/Sale)
              </small>
              <small v-if="conversionTypes.length === 0 && !loadingConversionTypes" class="text-warning d-block mt-1">
                No conversion types available. Please try refreshing.
              </small>
            </div>
          </div>
          
          <!-- Geo Conversion -->
          <div class="col-sm-12 col-md-12 col-lg-12">
            <div class="d-flex align-items-center mb-3">
              <el-switch
                v-model="editEnableGeoConversion"
                active-text="Geo Conversion"
                inactive-text=""
                :disabled="loadingGeoConversionState"
                @change="toggleGeoConversion">
              </el-switch>
              <span class="ml-3 text-dark" style="font-size: 14px;">
                Enable geo conversion tracking
              </span>
              <el-popover placement="top" :width="400" trigger="hover">
                <div class="tooltip-content">
                  <p>A conversion that occurs after a user is served an ad and then visits a Conversion Zone within the set attribution window. Review Simpli.fi's Ad Content Policy or contact your Client Success representative to see if Geo-Fencing restrictions apply to your campaign.</p>
                </div>
                <template #reference>
                  <i class="fa fa-question-circle text-black-50" style="cursor: pointer; margin-left: 8px;"></i>
                </template>
              </el-popover>
            </div>
            <!-- Loading state for geo conversion section in edit form -->
            <div v-if="loadingGeoConversionState" class="d-flex align-items-center mt-1" style="font-size: 13px; color: #909399;">
              <i class="el-icon-loading mr-2" style="font-size: 16px;"></i>
              <span>Loading geo conversion data...</span>
            </div>
            <div v-if="editEnableGeoConversion" class="mt-3">
              <div class="alert alert-info" style="margin-bottom: 15px; padding: 12px; border-left: 4px solid #303133; background: #e1f3ff; border-radius: 4px;">
                <i class="fas fa-info-circle" style="color: #303133; margin-right: 8px;"></i>
                <strong style="color: #303133;">Note:</strong> <span style="color: #606266;">Draw polygons on the map to define your geo conversion fences. Maximum 12 points per polygon. All fences created here will be used for conversion tracking.</span>
              </div>
              <GeoFenceMap 
                ref="editGeoConversionMap"
                :campaign-id="selectedRowData.leadspeek_api_id"
                :is-create-mode="false"
                :is-draft-campaign="isSelectedCampaignDraft"
                :is-conversion-mode="true"
                map-id="geo-fence-map-edit-conversion"
                @fences-updated="onEditGeoConversionFencesUpdated"
                @leaflet-unavailable="onLeafletUnavailable">
              </GeoFenceMap>
            </div>
          </div>
        </div>
        <!-- end conversions section  -->
        
        <!-- CPA Settings -->
        <div class="col-sm-12 col-md-12 col-lg-12 mt-4">
          <h4 class="col-sm-12 col-md-12 col-lg-12 font-weight-600 m-0 text-dark my-4" style="font-size: 20px;">
            CPA Settings
            <span v-if="selectedRowData.goal_type !== 'cpa'" style="font-size: 13px; font-weight: normal; color: #999; margin-left: 8px;">
               (Enabled only when Goal is CPA)
            </span>
            <el-popover placement="top" :width="400" trigger="hover">
              <div class="tooltip-content">
                <p>Assign a weighted value to your viewthrough or clickthrough conversions. By default, viewthrough and clickthrough conversions are assigned an equal value of 100%.</p>
              </div>
              <template #reference>
                <i class="fa fa-question-circle text-black-50" style="cursor: pointer; margin-left: 8px;"></i>
              </template>
            </el-popover>
          </h4>
          <div class="row">
            <div class="col-sm-12 col-md-6 col-lg-6">
              <div class="form-group has-label">
                <label>Viewthrough Percentage</label>
                <el-tooltip
                  :content="selectedRowData.goal_type !== 'cpa' ? 'Please select CPA as campaign goal in General Info to enable CPA Settings' : ''"
                  placement="top"
                  :disabled="selectedRowData.goal_type === 'cpa'"
                  effect="light">
                  <base-input
                    type="number"
                    v-model.number="editCpaViewThruPercentage"
                    :min="0"
                    :max="100"
                    step="0.1"
                    placeholder="100"
                    class="conversion-settings-input mb-0 pb-0"
                    :class="{ 'custom-disabled-input': selectedRowData.goal_type !== 'cpa' }"
                    :disabled="selectedRowData.goal_type !== 'cpa'"
                    @blur="validateEditCpaViewThruPercentage"
                  >
                    <template #addonRight>
                      <span class="input-group-text">%</span>
                    </template>
                  </base-input>
                </el-tooltip>
                <small class="text-muted">Max: 100%</small>
              </div>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-6">
              <div class="form-group has-label">
                <label>Clickthrough Percentage</label>
                <el-tooltip
                  :content="selectedRowData.goal_type !== 'cpa' ? 'Please select CPA as campaign goal in General Info to enable CPA Settings' : ''"
                  placement="top"
                  :disabled="selectedRowData.goal_type === 'cpa'"
                  effect="light">
                  <base-input
                    type="number"
                    v-model.number="editCpaClickThruPercentage"
                    :min="0"
                    :max="100"
                    step="0.1"
                    placeholder="100"
                    class="conversion-settings-input mb-0 pb-0"
                    :class="{ 'custom-disabled-input': selectedRowData.goal_type !== 'cpa' }"
                    :disabled="selectedRowData.goal_type !== 'cpa'"
                    @blur="validateEditCpaClickThruPercentage"
                  >
                    <template #addonRight>
                      <span class="input-group-text">%</span>
                    </template>
                  </base-input>
                </el-tooltip>
                <small class="text-muted">Max: 100%</small>
              </div>
            </div>
          </div>
        </div>
        
        <!-- Attribution Settings -->
        <div class="col-sm-12 col-md-12 col-lg-12 mt-4">
          <h4 class="col-sm-12 col-md-12 col-lg-12 font-weight-600 m-0 text-dark my-4" style="font-size: 20px;">
            Attribution Settings
            <el-popover
              placement="top"
              :width="400"
              trigger="hover"
            >
              <div class="tooltip-content">
                <p>The amount of time a conversion will be tracked after an ad is served. The maximum amount of time a conversion can be tracked is 30 days.</p>
              </div>
              <template #reference>
                <i class="fa fa-question-circle text-black-50" style="cursor: pointer; margin-left: 8px;"></i>
              </template>
            </el-popover>
          </h4>
          <div class="row">
            <div class="col-sm-12 col-md-6 col-lg-6">
              <div class="form-group has-label">
                <label>View Attribution Window</label>
                <base-input
                  type="number"
                  v-model.number="editViewAttributionWindow"
                  :min="1"
                  :max="30"
                  placeholder="30"
                  class="conversion-settings-input mb-0 pb-0"
                  @blur="validateEditViewAttributionWindow"
                >
                  <template #addonRight>
                    <span class="input-group-text">days</span>
                  </template>
                </base-input>
                <small class="text-muted">Max: 30 days</small>
              </div>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-6">
              <div class="form-group has-label">
                <label>Click Attribution Window</label>
                <base-input
                  type="number"
                  v-model.number="editClickAttributionWindow"
                  :min="1"
                  :max="30"
                  placeholder="30"
                  class="conversion-settings-input mb-0 pb-0"
                  @blur="validateEditClickAttributionWindow"
                >
                  <template #addonRight>
                    <span class="input-group-text">days</span>
                  </template>
                </base-input>
                <small class="text-muted">Max: 30 days</small>
              </div>
            </div>
          </div>
        </div>
        
        <!-- Divider -->
        <div class="col-sm-12 col-md-12 col-lg-12 my-4">
          <hr style="border: 0; border-top: 2px solid #e0e0e0; margin: 0;">
        </div>
        
        <!-- Inventory section -->
        <h4 class="col-sm-12 col-md-12 col-lg-12 font-weight-600 m-0 text-dark my-4" style="font-size: 20px;">
          Inventory
        </h4>
        <h4 class="col-sm-12 col-md-12 col-lg-12 font-weight-600 m-0 text-dark my-4" style="font-size: 20px;">
          Device Type
        </h4>
        <div class="col-sm-12 col-md-12 col-lg-12">
          <!-- Main Device Types -->
          <div class="row mb-3">
            <!-- Desktop, Mobile, Tablet -->
            <div v-for="item in (selectedRowData.device_types || []).filter(dt => dt.name !== 'Connected TV' && dt.name !== 'Connected Tv')" :key="item.name" class="col-6 col-sm-4 col-md-3 d-flex align-items-start mb-2">
              <el-checkbox 
                class="checkbox-advanced-information" 
                :label="(item.name == null || item.name === false) ? '' : String(item.name)" 
                v-model="item.val"
              >
                <span>{{ item.name }}</span>
              </el-checkbox>
            </div>
            
            <!-- Connected TV -->
            <div v-for="item in (selectedRowData.device_types || []).filter(dt => dt.name === 'Connected TV' || dt.name === 'Connected Tv')" :key="item.name" class="col-6 col-sm-4 col-md-3 d-flex align-items-start mb-2">
              <el-checkbox 
                class="checkbox-advanced-information" 
                :label="(item.name == null || item.name === false) ? '' : String(item.name)" 
                v-model="item.val"
              >
                <span>{{ item.name }}</span>
              </el-checkbox>
              <el-popover
                effect="light"
                :open-delay="300"
                placement="top"
                width="400"
                trigger="hover"
              >
                <template>
                  <div style="text-align: left; overflow-wrap: break-word; max-width: 380px;">
                    <div style="line-height: 1.5; word-break: normal;">
                      A device type that allows you to target large screen devices,
                      such as Smart TVs or devices that can connect to a TV,
                      including streaming boxes, media streaming devices,
                      and gaming consoles.
                    </div>
                    <div style="margin-top: 12px;"><strong>Targeted devices:</strong></div>
                    <div style="margin-top: 8px; line-height: 1.6; word-break: normal;">
                      Amazon, MBX, Nvidia, Tivo, Apple, Mecool, Opera, Toshiba,
                      Beelink, Microsoft, Panasonic, Tronsmart, Bqeel, Minix, Philips, Vizio,
                      Dooh TV, Mozilla, Roku, Xiaomi, Google, MStar, Samsung, Xlintek,
                      Hisense, MXQ, Sanyo, LG, Nexbox, Sharp, Logitech, Nintendo, Sony
                    </div>
                  </div>
                </template>
                <template #reference>
                  <i
                    class="fa fa-question-circle text-black-50"
                    style="cursor: pointer; margin-left: 12px;"
                  ></i>
                </template>
              </el-popover>
            </div>
          </div>
        </div>
        
        <!-- Divider -->
        <div class="col-sm-12 col-md-12 col-lg-12 my-4">
          <hr style="border: 0; border-top: 2px solid #e0e0e0; margin: 0;">
        </div>
        
        <!-- Ads section -->
        <h4 class="col-sm-12 col-md-12 col-lg-12 font-weight-600 m-0 text-dark my-4" style="font-size: 20px;">
          ADs
        </h4>
        <div class="col-sm-12 col-md-12 col-lg-12">
          <div style="display: flex; flex-direction: column;">
            <label>Media Type</label>
            <el-select 
              :key="`media-type-select-${selectedMediaType}`"
              id="select-from-campaigns"
              class="select__form__client w-100 select-info select-fullwidth campaign-audiance-dropdown" 
              size="large"
              placeholder="Select Media type" 
              :value="selectedMediaType" 
              label="Media Type" 
              @change="onMediaTypeChange">
              <el-option v-for="option in mediaTypes" :value="option.id" :label="(option.value == null || option.value === false) ? '' : String(option.value)" :key="option.id">
              </el-option>
            </el-select>
          </div>
        </div>

        <div class="col-sm-12 col-md-12 col-lg-12 mt-4">
            <div class="inserted-media-list">
              <span v-if="false" class="title">Inserted Media List</span>

              <div class="input-wrapper">
                <base-input
                  label="Ad Click Destination URL"
                  type="text"
                  v-model="selectedRowData.destination_url"
                  placeholder="e.g., https://www.example.com/"
                  :maxlength="255"
                  class="mb-0 pb-0 w-100"
                />

                <el-button
                  @click="openMediaSelectEdit"
                  class="upload-button"
                  icon="el-icon-upload2"
                  plain
                >
                  Select Media
                </el-button>
              </div>
              
              <!-- Minimum Recommended Sizes Section (Display only) -->
              <div v-if="selectedMediaType !== 'video'" class="recommended-sizes-section mt-4 mb-3">
                <div class="recommended-sizes-header">
                  <i class="el-icon-star-on" style="color: #409EFF; margin-right: 8px;"></i>
                  <span class="recommended-sizes-title">Minimum Recommended Sizes</span>
                </div>
                <div class="recommended-sizes-description">
                  <span>For optimal display performance and compatibility across all advertising platforms</span>
                </div>
                <div class="recommended-sizes-grid">
                  <span class="size-badge">300×250</span>
                  <span class="size-badge">728×90</span>
                  <span class="size-badge">160×600</span>
                  <span class="size-badge">300×600</span>
                  <span class="size-badge">320×50</span>
                  <span class="size-badge">300×50</span>
                  <span class="size-badge">970×250</span>
                  <span class="size-badge">250×250</span>
                  <span class="size-badge">200×200</span>
                </div>
              </div>
              
              <!-- Video Requirements Section (Video campaign only) -->
              <div v-if="selectedMediaType === 'video'" class="recommended-sizes-section mt-4 mb-3">
                <div class="recommended-sizes-header">
                  <i class="el-icon-video-camera" style="color: #409EFF; margin-right: 8px;"></i>
                  <span class="recommended-sizes-title">Video Requirements</span>
                </div>
                <div class="recommended-sizes-description">
                  <span>Video dimensions are flexible, but must meet minimum requirements</span>
                </div>
                <div class="recommended-sizes-grid">
                  <span class="size-badge" style="background: #f0f9ff; border-color: #409EFF; color: #409EFF; font-weight: 600;">
                    Minimum: 768×576
                  </span>
                  <span class="size-badge" style="background: #f0f9ff; border-color: #67C23A; color: #67C23A; font-weight: 600;">
                    Preferred: 1920×1080
                  </span>
                  <span class="size-badge" style="background: #f0f9ff; border-color: #67C23A; color: #67C23A; font-weight: 600;">
                    Preferred: 1920×1200
                  </span>
                  <span class="size-badge" style="background: #f0f9ff; border-color: #909399; color: #909399;">
                    Aspect Ratio: 16:9
                  </span>
                </div>
              </div>
            </div>
          <media-list class="mt-3" 
          :masterDestinationURL="selectedRowData.destination_url"
          :tableData="selectedEditMediaList"
          :selected-media-ids="selectedRowData.simplifi_selected_media"
          @remove-media="onRemoveMedia"
          @update-media-data="onMediaListUpdated"
          @media-selection-changed="onMediaListSelectionChanged"
          :campaign-id="selectedRowData.leadspeek_api_id"
          mode="edit"
          ref="editMediaList"
          ></media-list>
          <div style="font-size: 14px;">
            <!-- <span><strong>Note: </strong>Only .jpg, .png or .gif formats supported for display ad</span></br> -->
            <!-- <span>Supported dimentions are 250x250, 300x250, 300x600, 970x250</span> -->
          </div>
        </div>
        <!-- ads section end -->

      </div>
      <template slot="footer">
        <div class="align-items-center col-lg-12 col-md-12 col-sm-12 d-flex flex-row-reverse flex-wrap" style="gap:8px">
          <base-button
            v-if="$global.menuLeadsPeek_update"
            size="sm"
            :id="'btnSave' + (selectedRowData.id != null ? selectedRowData.id : '')"
            :disabled="isProcessingEdit || !isEditCampaignSaveReady"
            :title="!isEditCampaignSaveReady && modals.editCampaign ? 'Campaign data is incomplete. Close and open Edit again after the list has finished loading.' : ''"
            style="height:40px"
            @click="ProcessAddEditClient(selectedRowData)"
          >
            <span v-if="isProcessingEdit">Processing <i class="fas fa-spinner fa-spin ml-1"></i></span>
            <span v-else>Save</span>
          </base-button>
          <base-button size="sm" style="height:40px" @click="CancelAddEditClient(selectedRowData.company_name)">
            Cancel
          </base-button>
        </div>
      </template>
    </modal>
    <!-- edit campaign modal start-->

    <!-- Modal Setting Markup -->
    <modal id="modalSetPrice" :show.sync="modals.pricesetup" headerClasses="justify-content-center" modalContentClasses="">
      <h4 slot="header" class="title title-up-price-setup title-up">
         Campaign Financials For: <span style="color:#000000">{{ LeadspeekCompany }}</span>
         <span style="color:#666666; display: block; font-size: 0.9em; margin-top: 4px;">
            {{ LeadspeekCompanyName }}
         </span>
      </h4>

      <div>
        <div class="client-payment-simplifi-setup">
          <div class="d-flex flex-wrap flex-md-nowrap" style="gap:16px;">
            <div class='w-100'>
                <div class="d-flex">
                  <label for="max-bid-input">Max Bid</label>
                  <el-popover
                    placement="top"
                    :width="300"
                    trigger="hover"
                    effect="light"
                    :open-delay="300">
                    <div class="tooltip-content">
                      <p>The maximum amount you are willing to pay for an impression.</p>
                      <p>The max bid is set at the campaign level.</p>
                    </div>
                    <template #reference>
                      <i class="fa fa-question-circle text-black-50" style="cursor: pointer; margin-left: 12px;"></i>
                    </template>
                  </el-popover>
                </div>
                <base-input 
                  id="max-bid-input" 
                  class="campaign-cost-input"
                  :class="{'error-input-price-simplifi': simplifiErrorInput.financialCampaign.maxBid}"
                  label="" 
                  type="text" 
                  placeholder="0.00"
                  maxLength="20"
                  addon-left-icon="fas fa-dollar-sign"
                  v-model="LeadspeekMaxBid"
                  @input="onSimplifiPriceInput('financialCampaign', 'maxBid', $event)"
                  @keydown="restrictInput" 
                  @keyup="validateMinimumInput('keyup','financialCampaign','maxBid')" 
                  @blur="validateMinimumInput('blur','financialCampaign','maxBid')"
                  @copy.prevent @cut.prevent @paste.prevent>
                  <template #addonRight>
                    <span class="input-group-text">CPM</span>
                  </template>
                </base-input>
                <span v-if="simplifiErrorInput.financialCampaign.maxBid" v-html="simplifiErrorInput.financialCampaign.maxBid" class="error-message-price-simplifi"></span>
            </div>

            <div class='w-100'>
              <label for="total-budget-input">Monthly Budget</label>
              <base-input 
                id="total-budget-input" 
                class="campaign-cost-input" 
                label="" 
                type="text" 
                placeholder="0.00"
                maxLength="20"
                addon-left-icon="fas fa-dollar-sign" 
                v-model="LeadspeekMonthlyBudget"
                @input="onBudgetInput('totalBudget', $event, 'financial')"
                @keydown="onBudgetFieldKeydown($event, 'totalBudget', 'financial')"
                @keyup="validateMinimumInput('keyup','financialCampaign','monthlyBudget')" 
                @blur="validateMinimumInput('blur','financialCampaign','monthlyBudget', $event)"
                @copy.prevent @cut.prevent @paste.prevent>
              </base-input>
            </div>
          </div>
          
          <div class="d-flex flex-wrap flex-md-nowrap" style="gap:16px;">
            <div class='w-100'>
              <div class="d-flex">
                <label for="max-bid-input">Daily Budget</label>
                <el-popover
                  placement="top"
                  :width="320"
                  trigger="hover"
                  effect="light"
                  :open-delay="300"
                  >
                  <div class="tooltip-content">
                    <p>The maximum dollar amount that your campaign should spend in a day.</p>
                    <p>If a Daily Budget is not provided, your campaign will spend its Total or Monthly Budget as quickly as possible, regardless of the campaign's end date.</p>
                    <p>Best practices recommend that you include a Daily Budget.</p>
                  </div>
                  <template #reference>
                    <i class="fa fa-question-circle text-black-50" style="cursor: pointer; margin-left: 12px;"></i>
                  </template>
                </el-popover>
              </div>
              <base-input 
                id="max-bid-input" 
                class="campaign-cost-input" 
                :class="{'error-input-price-simplifi': simplifiErrorInput.financialCampaign.dailyBudget}"
                label="" 
                type="text" 
                placeholder="0.00"
                maxLength="20"
                addon-left-icon="fas fa-dollar-sign" 
                v-model="LeadspeekDailyBudget"
                @input="onBudgetInput('dailyBudget', $event, 'financial')"
                @keydown="onBudgetFieldKeydown($event, 'dailyBudget', 'financial')"
                @keyup="validateMinimumInput('keyup','financialCampaign','dailyBudget')" 
                @blur="validateMinimumInput('blur','financialCampaign','dailyBudget', $event)"
                @copy.prevent @cut.prevent @paste.prevent>
              </base-input>
              <span v-if="simplifiErrorInput.financialCampaign.dailyBudget" v-html="simplifiErrorInput.financialCampaign.dailyBudget" class="error-message-price-simplifi"></span>
            </div>

            <div class='w-100'>
              <div class="d-flex">
                <label for="goal-select">Goal</label>
                <el-popover
                  placement="top"
                  :width="320"
                  trigger="hover"
                  effect="light"
                  :open-delay="300"
                  >
                  <div class="tooltip-content">
                    <p>The goal of your current Campaign. The selected Goal dictates how the campaign will be optimized.</p>
                    <div class="tooltip-definitions">
                      <strong>CPC</strong>: Cost Per Click<br />
                      <strong>CTR</strong>: Click-Through Rate<br />
                      <strong>CPA</strong>: Cost Per Acquisition
                    </div>
                  </div>
                  <template #reference>
                    <i class="fa fa-question-circle text-black-50" style="cursor: pointer; margin-left: 12px;"></i>
                  </template>
                </el-popover>
              </div>
              <div class="d-flex" style="gap: 12px;">
                <base-input v-if="LeadspeekGoalType != 'none'" :value="LeadspeekGoalValue" @input="validateGoalValue($event, 'financial')" id="total-budget-input" class="campaign-cost-input w-100"
                  label="" type="text" placeholder="0.00" maxLength="20"
                  @keydown="restrictInput" @blur="formatGoalValue('financial')"
                  :addon-left-icon="LeadspeekGoalType != 'ctr' ? 'fas fa-dollar-sign' : ''"
                  :addon-right-icon="LeadspeekGoalType == 'ctr' ? 'fa-solid fa-percent' : ''">
                </base-input>
                <el-select class="select__form__client w-100" size="large" placeholder="1" v-model="LeadspeekGoalType" @change="campaignGoalChange('financial')">
                  <el-option v-for="option in campaignGoal.options" :value="option.id" :label="(option.value == null || option.value === false) ? '' : String(option.value)"
                    :key="option.id">
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>

            <div v-if="$store.getters.userData.user_type != 'client'" class="w-100">
              <div class="row mx-0">
                <div class="col-12 px-0">
                  <div class="d-flex align-items-center mb-2">
                    <label for="goal-select" class="mb-0">Agency Profit Margin</label>
                    <el-popover
                      placement="top"
                      :width="300"
                      trigger="hover"
                      effect="light"
                      :open-delay="300">
                      <div class="tooltip-content">
                        <p>This percentage is your agency's profit.</p>
                        <p>It will be deducted from the client's monthly ad budget, and the remainder will be spent on ads.</p>
                      </div>
                      <template #reference>
                        <i class="fa fa-question-circle text-black-50" style="cursor: pointer; margin-left: 12px;"></i>
                      </template>
                    </el-popover>
                  </div>
                  <div class="d-flex flex-column flex-md-row align-items-start align-items-md-center" style="gap: 12px;">
                    <div class="w-100" style="max-width: 400px;">
                      <el-select 
                        class="select__form__client w-100" 
                        size="large" 
                        placeholder="Agency Profit Margin Percentage" 
                        v-model="LeadspeekAgencyMarkup" 
                        :disabled="LeadspeekAgencyCoversCost" 
                        @change="profitcalculation">
                        <el-option v-for="markup in agencyMarkup.list" :value="markup.value" :label="(markup.text == null || markup.text === false) ? '' : String(markup.text)" :key="markup.value">
                        </el-option>
                      </el-select>
                    </div>
                    <div class="w-100 w-md-auto mt-2 mt-md-0">
                      <el-checkbox v-model="LeadspeekAgencyCoversCost" size="large" class="m-0">
                        <span class="text-wrap">Client costs covered by Agency</span>
                      </el-checkbox>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        <div style="border:solid 1px;opacity:0.5;margin-top:24px;margin-left:-4px;width:100%">&nbsp;</div>

        <!-- budget infomation -->
        <div class="row d-flex flex-column pt-2 pl-2 pr-3" style="gap: 16px; font-size: 13px;">
          <div class="col-12 mt-1 d-flex justify-content-center">
            <p class="text-center client-payment-modal-form-label" style="color:#222a42; font-size: 16px; font-weight: 700">Budget Information</p>
          </div>

          <el-tabs class="tabs-simplifi" type="border-card" v-model="budgetInformationType">
            <el-tab-pane name="current_budget">
              <span slot="label">Current Budget</span>
              
              <div class="col-12">
                <div class="d-flex" style="gap: 105px;">
                  <div class="d-flex flex-column">
                    <span>Start Date</span>
                    <span class="font-weight-bolder">{{ LeadspekStartDate }}</span> 
                  </div>
                  <div class="d-flex flex-column">
                    <span>End Date</span>
                    <span class="font-weight-bolder">{{ LeadspeekEndDate }}</span>
                  </div>
                </div>
              </div>

              <div class="col-12 mt-4">
                <div class="d-flex mt-1" style="gap: 113px;">
                  <div class="d-flex flex-column">
                    <span>Daily Spend</span>
                    <div class="font-weight-bolder" style="margin-top: -1px;">
                      <span class="mr-1" style="font-size: 15px;">$</span> 
                      <span v-if="LeadspeekIsBudgetPaid">{{ LeadspeekTotalDaily }}</span> 
                      <span v-else>{{ LeadspeekDailyBudget }}</span> 
                    </div>
                  </div>
                  <div class="d-flex flex-column">
                    <span>Amount Spent</span>
                    <div class="font-weight-bolder" style="margin-top: -1px;">
                      <span class="mr-1" style="font-size: 15px;">$</span> 
                      <span>{{ LeadspeekTotalSpend }}</span> 
                    </div>
                  </div>
                  <div class="d-flex flex-column">
                    <span>Amount Remaining</span>
                    <div class="font-weight-bolder" style="margin-top: -1px;">
                      <span class="mr-1" style="font-size: 15px;">$</span> 
                      <span v-if="prevBudgetVisible">{{ formatPrice(LeadspeekDailyBudget * LeadspeekRemainingDays) }}</span>
                      <span v-else>{{ LeadspeekTotalRemaining }}</span>
                    </div>
                  </div>
                  <div class="d-flex flex-column">
                    <span>Total Budget</span>
                    <div class="font-weight-bolder" style="margin-top: -1px;">
                      <span class="mr-1" style="font-size: 15px;">$</span> 
                      <span v-if="prevBudgetVisible">{{ formatPrice(Number(LeadspeekDailyBudget * LeadspeekRemainingDays) + Number(LeadspeekTotalSpend)) }}</span>
                      <span v-else-if="LeadspeekIsBudgetPaid">{{ LeadspeekTotalBudget }}</span>
                      <span v-else>{{ LeadspeekMonthlyBudget }}</span> 
                    </div>
                  </div>
                </div>
                <div v-if="LeadspeekIsBudgetPaid">
                  <small style="font-size: 11px; white-space: normal; word-break: break-word; font-weight: 600;">{{ LeadspeekWordingChangeBudget1 }}</small>
                </div>
              </div>

              <div class="col-12 mt-4 mb-2" v-if="(LeadspeekIsBudgetPaid && prevBudgetVisible)">
                <div class="previous-spend-financial-container shadow">
                  <div class="d-flex previous-spend-financial-value">
                    <div class="d-flex flex-column">
                      <span>Previous Daily</span>
                      <div class="font-weight-bolder">
                        <span class="mr-1" style="font-size: 15px;">$</span> 
                        <span>{{ LeadspeekPreviousDaily }}</span> 
                      </div>
                    </div>

                    <div class="d-flex flex-column">
                      <span>Previous Spend</span>
                      <div class="font-weight-bolder">
                        <span class="mr-1" style="font-size: 15px;">$</span> 
                        <span>{{ LeadspeekTotalSpend }}</span> 
                      </div>
                    </div>

                    <div class="d-flex flex-column" style="margin-left: 3px;">
                      <span>Previous Remaining</span>
                      <div class="font-weight-bolder">
                        <span class="mr-1" style="font-size: 15px;">$</span> 
                        <span>{{ LeadspeekPreviousRemaining }}</span> 
                      </div>
                    </div>
                    <div class="d-flex flex-column" style="margin-left: 3px;">
                      <span>Previous Campaign Budget</span>
                      <div class="font-weight-bolder">
                        <span class="mr-1" style="font-size: 15px;">$</span> 
                        <span>{{ LeadspeekPreviousBudget }}</span> 
                      </div>
                    </div>
                  </div>
                </div>
                
                <div>
                  <small style="font-size: 11px; white-space: normal; word-break: break-word; font-weight: 600;">
                    *With a previous remaining budget of 
                    <span class="font-weight-bolder">${{ LeadspeekPreviousRemaining }}</span> 
                    and a new daily budget of 
                    <span class="font-weight-bolder">${{ LeadspeekDailyBudget }}</span> 
                    from 
                    <span class="font-weight-bolder">{{ LeadspeekNowDate }} (today)</span> 
                    to 
                    <span class="font-weight-bolder">{{ LeadspeekEndDate }} (end date)</span>
                    &mdash; 
                    <span class="font-weight-bolder">{{ LeadspeekRemainingDays }} (days)</span>
                    in total &mdash; the calculation is:
                  </small>
                </div>

                <div style="margin-top: -4px; padding-left: 4px;" class="row d-flex justify-content-between">
                  <!-- budget calculations -->
                  <div v-if="false" class="col-12 col-md-4 col-lg-4 pt-2 d-flex flex-column" style="gap: 4px; font-size: 15px;"> <!-- OLD -->
                    <small style="margin-bottom: 2px; font-size: 12px;">Budget Calculations</small>
                    <div>
                      <small>1. Max Bid is <strong>${{ LeadspeekMaxBid }} CPM</strong></small>
                    </div>
                    <div>
                      <small>2. Monthly Budget is <strong>${{ LeadspeekMonthlyBudget }}</strong></small>
                    </div>
                    <div>
                      <small>3. Daily Budget is <strong>${{ LeadspeekDailyBudget }}</strong></small>
                    </div>
                    <div>
                      <small>
                        4. Goal is
                        <strong v-if="LeadspeekGoalType == 'none'">None</strong>
                        <strong v-else-if="LeadspeekGoalType == 'ctr'" >{{ LeadspeekGoalValue }}% {{ LeadspeekGoalType.toUpperCase() }}</strong>
                        <strong v-else>${{ LeadspeekGoalValue }} {{ LeadspeekGoalType.toUpperCase() }}</strong>
                      </small>
                    </div>
                    <div>
                      <small>5. Agency Profit Margin is <strong>{{ LeadspeekAgencyMarkup }}%</strong></small>
                    </div>
                    <div>
                      <small>6. Remaining Days Is  <strong>{{ LeadspeekRemainingDays }}</strong></small>
                    </div>
                  </div>

                  <div class="col-12 col-md-4 col-lg-4 pt-2 d-flex flex-column" style="gap: 4px; font-size: 15px;"> <!-- NEW -->
                    <div>
                      <small style="margin-left: 2px;">1. Remaining Days Is  <strong>{{ LeadspeekRemainingDays }}</strong></small>
                    </div>
                    <div>
                      <small>2. Previous Remaining Is <strong>${{ LeadspeekPreviousRemaining }}</strong></small>
                    </div>
                    <div class="d-flex flex-column">
                      <small>3. Cost Total Budget For {{ LeadspeekRemainingDays }} Days</small>
                      <small class="ml-2">(Daily Spend x Remaining Days) : </small>
                      <small class="ml-2">(${{ LeadspeekDailyBudget }} x {{ LeadspeekRemainingDays }} days) : <strong>${{ LeadspeekTotalBudgetByRemainingDays }}</strong></small> 
                    </div>
                    <div class="d-flex flex-column">
                      <small>4. Client Monthly Cost : </small>
                      <small class="ml-2">(Total Budget - Previous Remaining) : </small>
                      <small class="ml-2">(${{ LeadspeekTotalBudgetByRemainingDays }} - ${{ LeadspeekPreviousRemaining }}) : <strong>${{ LeadspeekCostClientByRemainingDays }}</strong></small>
                    </div>
                  </div>
                  <!-- budget calculations -->

                  <!-- client calculation -->
                  <div v-if="false" class="col-12 col-md-4 col-lg-4 pt-2 d-flex flex-column" style="gap: 4px; font-size: 15px;"> <!-- OLD -->
                    <small style="margin-bottom: 2px; font-size: 12px;">Client Calculations</small>
                    <div>
                      <small>1. Previous Remaining Is <strong>${{ LeadspeekPreviousRemaining }}</strong></small>
                    </div>
                    <div class="d-flex flex-column">
                      <small>2. Cost Total Budget For {{ LeadspeekRemainingDays }} Days</small>
                      <small class="ml-2">(Daily Budget x Remaining Days) : </small>
                      <small class="ml-2">(${{ LeadspeekDailyBudget }} x {{ LeadspeekRemainingDays }} days) : <strong>${{ LeadspeekTotalBudgetByRemainingDays }}</strong></small> 
                    </div>
                    <div class="d-flex flex-column">
                      <small>3. Cost client is : </small>
                      <small class="ml-2">(Mothly Budget - Previous Remaining) : </small>
                      <small class="ml-2">(${{ LeadspeekTotalBudgetByRemainingDays }} - ${{ LeadspeekPreviousRemaining }}) : <strong>${{ LeadspeekCostClientByRemainingDays }}</strong></small>
                    </div>
                  </div>

                  <div v-if="$store.getters.userData.user_type != 'client'" class="col-12 col-md-4 col-lg-4 pt-2 d-flex flex-column" style="gap: 4px; font-size: 15px;"> <!-- NEW -->
                    <div class="d-flex flex-column">
                      <small>1. Agency Profit : </small>
                      <small class="ml-2">(Client Monthly Cost x Agency Profit Margin%) : </small>
                      <small class="ml-2">(${{ LeadspeekCostClientByRemainingDays }} x {{ LeadspeekAgencyMarkup }}%) : <strong>${{ LeadspeekProfitAgencyByRemainingDays }}</strong></small>
                    </div>
                  </div>
                  <!-- client calculation -->

                  <!-- agency calculation -->
                  <div v-if="false" class="col-12 col-md-4 col-lg-4 pt-2 d-flex flex-column" style="gap: 4px; font-size: 15px;"> <!-- OLD -->
                    <small style="margin-bottom: 2px; font-size: 12px;">Agency Calculations</small>
                    <div class="d-flex flex-column">
                      <small>1. Profit agency is : </small>
                      <small class="ml-2">(Cost Client x Agency Profit Margin%) : </small>
                      <small class="ml-2">(${{ LeadspeekCostClientByRemainingDays }} x {{ LeadspeekAgencyMarkup }}%) : <strong>${{ LeadspeekProfitAgencyByRemainingDays }}</strong></small>
                    </div>
                    <div class="d-flex flex-column">
                      <small>2. Cost agency is : </small>
                      <small class="ml-2">(Cost Client - Profit Agency) :</small>
                      <small class="ml-2">(${{ LeadspeekCostClientByRemainingDays }} - {{ LeadspeekProfitAgencyByRemainingDays }}) : <strong>${{ LeadspeekCostAgencyByRemainingDays }}</strong></small>
                    </div>
                  </div>

                  <div v-if="$store.getters.userData.user_type != 'client'" class="col-12 col-md-4 col-lg-4 pt-2 d-flex flex-column" style="gap: 4px; font-size: 15px;"> <!-- NEW -->
                    <div class="d-flex flex-column">
                      <small>1. Client Monthly Ad Budget :</small>
                      <small class="ml-2">(Client Monthly Cost - Agency Profit) :</small>
                      <small class="ml-2">(${{ LeadspeekCostClientByRemainingDays }} - {{ LeadspeekProfitAgencyByRemainingDays }}) : <strong>${{ LeadspeekCostAgencyByRemainingDays }}</strong></small>
                    </div>
                  </div>
                  <!-- agency calculation -->
                </div>
              </div>
            </el-tab-pane>

            <el-tab-pane name="history_budget">
              <span slot="label">Budget History</span>
              <div style="margin-top: 4px; overflow-y: auto; max-height: 370px;" v-if="budgetHistory.length > 0">
                <div v-for="(item) in budgetHistory" :key="item.id" style="padding: 0 10px;">
                  <div style="display: flex; flex-direction: column; gap: 2px; font-weight: 600;">
                    <div>
                      <span style="display: inline-block; width: 95px;">Start Date</span>
                      <span style="margin-right: 8px;">:</span>
                      <span>{{ item.start_date }}</span>
                    </div>
                    <div>
                      <span style="display: inline-block; width: 95px;">End Date</span>
                      <span style="margin-right: 8px;">:</span>
                      <span>{{ item.end_date }}</span>
                    </div>
                    <div>
                      <span style="display: inline-block; width: 95px;">Daily Budget</span>
                      <span style="margin-right: 8px;">:</span>
                      <span>
                        <span style="font-size: 14px; margin-right: 1px;">$</span> 
                        <span>{{ item.daily_budget }}</span>
                      </span>
                    </div>
                    <div>
                      <span style="display: inline-block; width: 95px;">Total Spend</span>
                      <span style="margin-right: 8px;">:</span>
                      <span>
                        <span style="font-size: 14px; margin-right: 1px;">$</span> 
                        <span>{{ item.total_spend }}</span>
                      </span>
                    </div>
                    <div>
                      <span style="display: inline-block; width: 95px;">Total Budget</span>
                      <span style="margin-right: 8px;">:</span>
                      <span>
                        <span style="font-size: 14px; margin-right: 1px;">$</span> 
                        <span>{{ item.total_budget }}</span>
                      </span>
                    </div>
                  </div>
                  <div style="border-top: 1px solid #ccc; margin: 10px 0;"></div>
                </div>
              </div>
              <div style="height: 117.5px; display: flex; justify-content: center; align-items: center; font-size: 14px;" v-else>
                <p>No budget history available.</p>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
        <!-- budget infomation -->

        <div style="border:solid 1px;opacity:0.5;margin-top:24px;margin-left:-4px;width:100%">&nbsp;</div>

        <div class="row d-flex justify-content-between">
          <!-- budget calculations -->
          <div v-if="false" class="col-12 col-md-4 col-lg-4 pt-2 d-flex flex-column"> <!-- OLD -->
            <small style="margin-bottom: 2px; font-size: 12px;">Budget Calculations</small>
            <div>
              <small>1. Max Bid is <strong>${{ LeadspeekMaxBid }} CPM</strong></small>
            </div>
            <div>
              <small>2. Monthly Budget is <strong>${{ LeadspeekMonthlyBudget }}</strong></small>
            </div>
            <div>
              <small>3. Daily Budget is <strong>${{ LeadspeekDailyBudget }}</strong></small>
            </div>
            <div>
              <small>
                4. Goal is
                <strong v-if="LeadspeekGoalType == 'none'">None</strong>
                <strong v-else-if="LeadspeekGoalType == 'ctr'" >{{ LeadspeekGoalValue }}% {{ LeadspeekGoalType.toUpperCase() }}</strong>
                <strong v-else>${{ LeadspeekGoalValue }} {{ LeadspeekGoalType.toUpperCase() }}</strong>
              </small>
            </div>
            <div>
              <small>5. Agency Profit Margin is <strong>{{ LeadspeekAgencyMarkup }}%</strong></small>
            </div>
          </div>

          <div class="col-12 col-md-4 col-lg-4 pt-2 d-flex flex-column"> <!-- NEW -->
            <div class="d-flex flex-column">
              <small>1. Client Monthly Cost : </small>
              <small class="ml-2">(Monthly Budget) : <strong>${{ LeadspeekMonthlyBudget }}</strong></small>
            </div>
          </div>
          <!-- budget calculations -->

          <!-- client calculations -->
          <div v-if="false" class="col-12 col-md-4 col-lg-4 pt-2 d-flex flex-column"> <!-- OLD -->
            <small style="margin-bottom: 2px; font-size: 12px;" class="calculations-divider">Client Calculations</small>

            <div class="d-flex flex-column">
              <small>1. Cost client is : </small>
              <small class="ml-2">(Monthly Budget) : <strong>${{ LeadspeekMonthlyBudget }}</strong></small>
            </div>
          </div>

          <div v-if="$store.getters.userData.user_type != 'client'" class="col-12 col-md-4 col-lg-4 pt-2 d-flex flex-column"> <!-- NEW -->
            <div class="d-flex flex-column mb-2">
              <small>1. Agency Profit : </small>
              <small class="ml-2">(Monthly Budget x Agency Profit Margin%) : </small>
              <small class="ml-2">(${{ LeadspeekMonthlyBudget }} x {{ LeadspeekAgencyMarkup }}%) : <strong>${{ formatPrice(LeadspeekProfitAgency) }}</strong></small>
            </div>
          </div>
          <!-- client calculations -->

          <!-- agency calculations -->
          <div v-if="false" class="col-12 col-md-4 col-lg-4 pt-2 d-flex flex-column"> <!-- OLD -->
            <small style="margin-bottom: 2px; font-size: 12px;" class="calculations-divider">Agency Calculations</small>

            <div class="d-flex flex-column mb-2">
              <small>1. Profit agency is : </small>
              <small class="ml-2">(Monthly Budget x Agency Profit Margin%) : </small>
              <small class="ml-2">(${{ LeadspeekMonthlyBudget }} x {{ LeadspeekAgencyMarkup }}%) : <strong>${{ formatPrice(LeadspeekProfitAgency) }}</strong></small>
            </div>

            <div class="d-flex flex-column mb-2">
              <small>2. Cost agency is : </small>
              <small class="ml-2">(Monthly Budget - Profit Agency) : </small>
              <small class="ml-2">(${{ LeadspeekMonthlyBudget }} - {{ formatPrice(LeadspeekProfitAgency) }}) : <strong>${{ formatPrice(LeadspeekCostAgency) }}</strong></small>
            </div>
          </div>

          <div v-if="$store.getters.userData.user_type != 'client'" class="col-12 col-md-4 col-lg-4 pt-2 d-flex flex-column"> <!-- NEW -->
            <div class="d-flex flex-column mb-2">
              <small>1. Client Monthly Ad Budget : </small>
              <small class="ml-2">(Monthly Budget - Agency Profit) : </small>
              <small class="ml-2">(${{ LeadspeekMonthlyBudget }} - {{ formatPrice(LeadspeekProfitAgency) }}) : <strong>${{ formatPrice(LeadspeekCostAgency) }}</strong></small>
            </div>
          </div>
          <!-- agency calculations -->
        </div>
      </div>

      <template slot="footer">
       <div class="container text-center pb-4 mx-4">
        <base-button @click.native="setModuleCost()" :disabled="isLoadingModuleCost" class="mr-2">
          Ok, Set It Up! <i v-if="isLoadingModuleCost" class="fas fa-spinner fa-spin ml-1" style="font-size: 16px;"></i>
        </base-button>
        
        <base-button @click="modals.pricesetup = false">
          Cancel
        </base-button>
       </div>
      </template>
    </modal>
    <!-- Modal Setting Markup -->

    <!-- Modal Campaign Details -->
    <modal :show.sync="modals.campaignDetails" body-classes="campaign-details-modal-body p-5" modal-classes="modal-xl" header-classes="pb-0">
      <template v-if="selectedCampaignDetails.id">
        <div class="details-header">
          <div class="details-header-left">
            <h3 class="title title-up mb-0">{{ selectedCampaignDetails.campaign_name }}</h3>
            <span class="text-muted">ID: {{ selectedCampaignDetails.leadspeek_api_id }}</span>
          </div>
          <div class="details-header-right">
            <div class="campaign-card-title-info-wrapper" @click.stop>
              <div class="align-items-center d-flex flex-wrap" style="gap:16px">
                <div v-if="
                  selectedCampaignDetails.disabled == 'F' && selectedCampaignDetails.active_user == 'T' && selectedCampaignDetails.campaign_never_started == 'F'
                " class="campaign-card-status-badge" style="background:rgb(0, 81, 97);color:white">
                  <span>Running</span>
                </div>
                <div v-if="
                  selectedCampaignDetails.disabled == 'T' && selectedCampaignDetails.active_user == 'T' && selectedCampaignDetails.campaign_never_started == 'F'
                " class="campaign-card-status-badge" style="background:#fdae61">
                  <span>Paused</span>
                </div>
                <div v-if="selectedCampaignDetails.active_user == 'F' && selectedCampaignDetails.campaign_never_started == 'F'" class="campaign-card-status-badge"
                  style="background:rgb(147, 2, 30);color:white">
                  <span>Stopped</span>
                </div>
                <div v-if="
                  selectedCampaignDetails.campaign_never_started == 'T' &&
                  selectedCampaignDetails.active_user == 'F' &&
                  selectedCampaignDetails.total_leads == '0'
                " class="campaign-card-status-badge" style="background:rgb(88, 92, 102);color:white;padding-left: 1rem;padding-right: 1rem;">
                  <span>Draft</span>
                </div>
                <div v-if="selectedCampaignDetails.audience_status != 'finish'" class="campaign-card-status-badge" style="background:rgb(88, 92, 102);color:white;padding-left:0.7rem;padding-right:0.7rem;">
                  <span v-if="selectedCampaignDetails.audience_status == 'error'">Audience Processing Failed</span>
                  <span v-else >Pending Processing Audience <i class="fas fa-spinner fa-spin ml-1" style="font-size: 13px;"></i></span>
                </div>
                <div v-if="selectedCampaignDetails.ads_upload_status && selectedCampaignDetails.ads_upload_status != 'finish' && selectedCampaignDetails.ads_upload_status != null" class="campaign-card-status-badge" style="background:rgb(88, 92, 102);color:white;padding-left:0.7rem;padding-right:0.7rem;">
                  <span v-if="selectedCampaignDetails.ads_upload_status == 'error'">Ads Upload Failed</span>
                  <span v-else>Pending Processing Ads <i class="fas fa-spinner fa-spin ml-1" style="font-size: 13px;"></i></span>
                </div>
                <div v-if="(externalData[selectedCampaignDetails.leadspeek_api_id] && externalData[selectedCampaignDetails.leadspeek_api_id].status && (externalData[selectedCampaignDetails.leadspeek_api_id].status == 'Pending' || externalData[selectedCampaignDetails.leadspeek_api_id].status == 'pending')) ? true : false" class="campaign-card-status-badge" style="background:rgb(88, 92, 102);color:white;padding-left:0.7rem;padding-right:0.7rem;">
                  <span >Pending Review</span>
                </div>
              </div>
            </div>
            <!-- <base-button size="sm" type="neutral"><i class="fas fa-pause"></i></base-button>
            <base-button size="sm" type="neutral"><i class="fas fa-stop"></i></base-button> -->
            <el-dropdown trigger="click">
              <base-button size="sm" type="neutral" class="el-dropdown-toggle">
                <i class="fas fa-ellipsis-v"></i>
              </base-button>
              <el-dropdown-menu slot="dropdown">
                <!-- <el-dropdown-item>Edit Campaign</el-dropdown-item> -->
                <div @click.stop="downloadCampaignReport(selectedCampaignDetails.id, selectedCampaignDetails)">
                  <el-dropdown-item>Download Report</el-dropdown-item>
                </div>
                <div @click.stop="duplicateCampaign(selectedCampaignDetails.id, selectedCampaignDetails)">
                  <el-dropdown-item>Duplicate</el-dropdown-item>
                </div>
                <div @click.stop="archiveCampaign(selectedCampaignDetails.id, selectedCampaignDetails)">
                  <el-dropdown-item>Archive</el-dropdown-item>
                </div>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>

        <div class="details-metrics">
          <div class="metric-item">
            <label>Campaign Schedule</label>
              <template v-if="isDetailsLoading">
                <span><i  class="fas fa-spinner fa-spin"></i></span>
              </template>
              <template v-else>
                <span >{{ detailedStats.start_date }} - {{ detailedStats.end_date }}</span>
              </template>
          </div>
          <div class="metric-item">
            <label>Max Bid</label>
            <span>${{ selectedCampaignDetails.max_bid }} CPM</span>
          </div>
          <div class="metric-item">
            <label>Goal</label>
            <span v-if="selectedCampaignDetails.goal_type && selectedCampaignDetails.goal_type !== 'none'">
                <template v-if="selectedCampaignDetails.goal_type === 'ctr'">
                    {{ formatPercentage(selectedCampaignDetails.goal_value) }} CTR
                </template>
                <template v-else>
                    ${{ formatPrice(selectedCampaignDetails.goal_value) }} {{ selectedCampaignDetails.goal_type.toUpperCase() }}
                </template>
            </span>
            <span v-else>
              -
            </span>
          </div>
        </div>

        <div class="details-content row">
          <!-- <div class="col-lg-8">
            <div>
              <p class="text-center text-muted" style="font-size: 1.2rem; font-weight: 500;">
                  [Placeholder untuk Grafik Performa]<br>
                  <small>Integrasikan library chart di sini</small>
              </p>
            </div>
          </div> -->
          <div class="col-lg-12">
            <div class="summary-box">
              <el-select v-model="detailsDateFilter.range" placeholder="Select Date Range" @change="fetchCampaignDetails" class="w-100 mb-2">
                <el-option
                  v-for="item in detailsDateFilter.options"
                  :key="item.value"
                  :label="(item.label == null || item.label === false) ? '' : String(item.label)"
                  :value="item.value">
                </el-option>
              </el-select>
              
              <el-date-picker
                v-if="detailsDateFilter.range === 'Custom Date Range'"
                v-model="detailsDateFilter.customDates"
                type="daterange"
                range-separator="to"
                start-placeholder="Start date"
                end-placeholder="End date"
                value-format="yyyy-MM-dd"
                @change="fetchCampaignDetails"
                class="w-100 mb-3">
              </el-date-picker>
              <div v-if="isDetailsLoading" class="text-center p-5">
                  <i class="fas fa-spinner fa-spin fa-2x"></i>
              </div>
              <div v-else>
                  <div class="summary-item"><span>Total Spend</span> <strong>${{ formatPrice(detailedStats.total_spend) }}</strong></div>
                  <div class="summary-item"><span>Total Impressions</span> <strong>{{ detailedStats.impressions }}</strong></div>
                  <div class="summary-item"><span>Clicks</span> <strong>{{ detailedStats.clicks }}</strong></div>
                  <div class="summary-item"><span>Actions</span> <strong>{{ detailedStats.weighted_actions }}</strong></div>
                  <hr class="my-3" />
                  <div class="summary-item"><span>CPM</span> <strong>${{ formatPrice(detailedStats.cpm) }}</strong></div>
                  <div class="summary-item"><span>CTR</span> <strong>{{ formatPercentage(detailedStats.ctr) }}</strong></div>
                  <div class="summary-item"><span>CPC</span> <strong>${{ formatPrice(detailedStats.cpc) }}</strong></div>
                  <!-- <div class="summary-item"><span>VCR</span> <strong>--</strong></div> -->
                  <div class="summary-item"><span>CPA</span> <strong>${{ formatPrice(detailedStats.cpa) }}</strong></div>
              </div>
            </div>
          </div>
          <!-- <div class="col-lg-12 p-4">
            <el-tabs value="ads">
              <el-tab-pane label="Overview" name="overview">
                <div class="p-4 text-center text-muted">Konten Overview akan ditampilkan di sini.</div>
              </el-tab-pane>
              <el-tab-pane label="Ads" name="ads">
                <el-table :data="adsTableData" style="width: 100%">
                  <el-table-column prop="id" label="ID"></el-table-column>
                  <el-table-column prop="name" label="Name"></el-table-column>
                  <el-table-column prop="size" label="Ad Size"></el-table-column>
                  <el-table-column prop="imps" label="Imps"></el-table-column>
                  <el-table-column prop="clicks" label="Clicks"></el-table-column>
                  <el-table-column prop="ctr" label="CTR"></el-table-column>
                  <el-table-column prop="cpm" label="CPM"></el-table-column>
                  <el-table-column prop="spend" label="Spend"></el-table-column>
                </el-table>
              </el-tab-pane>
            </el-tabs>
          </div> -->
        </div>

        <template slot="footer">
          <div class="col-12 d-flex flex-row-reverse pb-3 pr-5">
            <base-button simple size="sm" style="height:40px; margin-top: -2rem;" @click="modals.campaignDetails = false">
              Cancel
            </base-button>
          </div>
        </template>
      </template>
    </modal>
    <!-- Modal Campaign Details -->

    <add-local-audiance :CompanyNamedisabled="CompanyNamedisabled" :companySelected="selectsCompany.companySelected"
      :companyList="selectsCompany.companyList" v-model="modals.uploadAudiance" @upload-finished="onUploadAudienceFinished"></add-local-audiance>
    <media-select 
      v-if="selectsCompany.companyList.length > 0"
      :CompanyNamedisabled="CompanyNamedisabled" 
      :companySelected="selectsCompany.companySelected"
      :companyList="selectsCompany.companyList" 
      :activeDimensionFilter="mediaSelectDimensionFilter"
      :campaignMediaType="selectedMediaType"
      v-model="modals.mediaSelect" 
       @selected-media="onMediaSelected"
       ref="mediaSelect"
      ></media-select>
  </div>
</template>

<script>
import {
  DatePicker,
  Table,
  TableColumn,
  Select,
  Option,
  Checkbox,
  Tabs,
  TabPane,
  Badge,
  Switch,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  CollapseItem,
  Collapse,
  RadioGroup,
  Radio,
  Button,
  Steps,
  Step
} from "element-ui";
import { BasePagination, BaseCheckbox, Modal, BaseRadio } from "src/components";
import { TagsInput } from "/src/components/index";
import GeoFenceMap from "@/components/GeoFenceMap.vue";
import swal from 'sweetalert2';
import {
  required,
  numeric,
  regex,
  confirmed,
  min_value
} from "vee-validate/dist/rules";
import { mapActions } from "vuex";
import { extend } from "vee-validate";
import Vue from "vue";
import { Loading, Notification, MessageBox } from "element-ui";
import SelectClientDropdown from "@/components/SelectClientDropdown.vue";
import UserLocalAudiance from "@/components/Tables/UserLocalAudiance.vue";
import AddLocalAudiance from "@/components/Modals/AddLocalAudiance.vue";
import MediaList from "@/components/Tables/MediaList.vue";
import MediaSelect from "@/components/Modals/MediaSelect.vue";


import { formatCurrencyUSD } from "@/util/formatCurrencyUSD";

Vue.use(Loading.directive);
extend("required", required);
extend("numeric", numeric);
extend("regex", regex);
extend("confirmed", confirmed);
extend("min_value", min_value);

export default {
  components: {
    Modal,
    GeoFenceMap,
    [DatePicker.name]: DatePicker,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Option.name]: Option,
    [Select.name]: Select,
    [Checkbox.name]: Checkbox,
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
    [Badge.name]: Badge,
    [Switch.name]: Switch,
    [Dropdown.name]: Dropdown,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Button.name]: Button,
    [Steps.name]: Steps,
    [Step.name]: Step,
    BasePagination,
    BaseRadio,
    BaseCheckbox,
    TagsInput,
    SelectClientDropdown,
    UserLocalAudiance,
    AddLocalAudiance,
    MediaList,
    MediaSelect
  },
  data() {
    return {
      tableData: [
        {
          id: "dummy-campaign-item",
          report_type: "GoogleSheet",
          leadspeek_type: "local",
          leadspeek_locator_zip: "",
          leadspeek_locator_desc: null,
          leadspeek_locator_keyword: "",
          leadspeek_locator_keyword_contextual: "",
          leadspeek_locator_state: "",
          leadspeek_locator_state_external: "",
          gtminstalled: "T",
          leadspeek_locator_city: "",
          leadspeek_locator_city_external: "",
          leadspeek_locator_require: "FirstName,LastName,MailingAddress,Phone",
          hide_phone: "T",
          national_targeting: "F",
          location_target: "Focus",
          start_billing_date: "2024-06-24 02:58:33",
          phoneenabled: "T",
          homeaddressenabled: "T",
          reidentification_type: "never",
          require_email: "T",
          file_url: "",
          report_sent_to:
            "harrison+clientailead@exactmatchmarketing.com\nharrison.budiman@gmail.com\nharrison@uncommonreach.com\ndaniel@exactmatchmarketing.com",
          admin_notify_to: [143, 165],
          leadspeek_api_id: "123456",
          active: "F",
          disabled: "F",
          active_user: "T",
          clientorganizationid: "123456",
          clientcampaignsid: "",
          leads_amount_notification: 500,
          total_leads: 6,
          last_lead_added: "03-22-2024",
          spreadsheet_id: "absced_dummy",
          filename: "",
          customer_payment_id: "absced_dummy",
          customer_card_id: "absced_dummy",
          company_parent: "abs",
          company_root_id: "abs",
          ongoing_leads: 0,
          last_lead_check: "22-03-2024",
          lifetime_cost: 30,
          cost_perlead: 3,
          lp_max_lead_month: 0,
          lp_min_cost_month: 2,
          paymentterm: "Prepaid",
          continual_buy_options: false,
          topupoptions: "onetime",
          leadsbuy: 50,
          stopcontinual: "F",
          platformfee: 1,
          lp_limit_startdate: "2024-06-21 00:00:00",
          lp_enddate: "",
          report_frequency_id: "5_minutes",
          lp_limit_leads: 9,
          lp_limit_freq: "day",
          user_id: 151,
          name: "Ad Campaign Client",
          email: "harrison+clientailead@exactmatchmarketing.com",
          phonenum: "(989) 898-9898",
          company_name: "Ad Campaign Client",
          company_id: "abs",
          group_company_id: "abs",
          campaign_name: "NY Realtor New",
          campaign_startdate: "0000-00-00 00:00:00",
          campaign_enddate: "",
          ori_campaign_startdate: "0000-00-00 00:00:00",
          ori_campaign_enddate: "",
          url_code: "https://test.com",
          url_code_thankyou: "",
          url_code_ads: "",
          embeddedcode_crawl: "T",
          embedded_status:
            "test.com<br/>(Make sure the domain begins with https:// or domain can not be found)",
          questionnaire_answers: '""',
          trysera: "F",
          archived: "F",
          timezone: "America/Chicago",
          applyreidentificationall: "F",
          m_paymentterm: "Weekly",
          m_platformfee: 0,
          m_lp_max_lead_month: null,
          m_lp_min_cost_month: null,
          m_cost_perlead: null,
          m_lp_limit_leads: 0,
          m_lp_limit_freq: "day",
          m_lp_limit_startdate: null,
          m_lp_enddate: null,
          sendgrid_is_active: 0,
          googlesheet_is_active: 0,
          sendgrid_action: "",
          sendgrid_list: "",
          ghl_is_active: 0,
          payment_status: "success",
          created_at: "2023-12-07T04:41:18.000000Z",
          target_nt: false,
          target_state: false,
          target_city: false,
          target_zip: false,
          selects_state: [],
          selects_citylist: [],
          selects_city: [],
          selects_citystate: [],
          selects_citystatelist: [],
          leadspeek_locator_keyword_bulk: "",
          total_cost: 18,
          yerterday_leads: 0,
          yerterday_previous_leads: 0
        }
      ],
      searchedData: [],
      err_companyselect:false,
      frequencyCapping: {
        impressions: "",
        hours: "",
        hoursOptions: []
      },
      mediaTypes: [
        // {
        //   id: "audio",
        //   value: "Audio"
        // },
        {
          id: "display",
          value: "Display"
        },
        {
          id: "video",
          value: "Video"
        },
      ],
      selectedMediaType: 'display',
      campaignGoal: {
        options: [
          {
            id: "none",
            value: "None"
          },
          {
            id: "cpc",
            value: "CPC"
          },
          {
            id: "ctr",
            value: "CTR"
          },
          {
            id: "cpa",
            value: "CPA"
          }
        ],
        goal: "none",
        value: 0,
      },
      agencyMarkup:{
        list : [
          {
            value : '0',
            text : '0%',
          },
          {
            value : 5,
            text : '5%',
          },
          {
            value : 10,
            text : '10%',
          },
          {
            value : 15,
            text : '15%',
          },
          {
            value : 20,
            text : '20%',
          },
          {
            value : 25,
            text : '25%',
          },
          {
            value : 30,
            text : '30%',
          },
          {
            value : 40,
            text : '40%',
          },
          {
            value : 50,
            text : '50%',
          },
        ],
        selected : 0,
        coversCost : false
      },
      campaign: {
        destinationURL: "",
        dailyBudget: 0,
        totalBudget: 0,
        maxBid: 0
      },
      deviceTypes: [
        {
          name: "Desktop",
          val: true,
          id: 36
        },
        {
          name: "Mobile",
          val: true,
          id: 35
        },
        {
          name: "Tablet",
          val: true,
          id: 37
        },
        {
          name: "Connected TV",
          val: false,
          id: 1
        }
      ],
      deviceTypeIdMap: {
        'Desktop': 36,
        'Mobile': 35,
        'Tablet': 37,
        'Connected TV': 1
      },
      dummyCampaignList: [
        {
          id: "123456",
          name: "Campaign First start (Site ID)"
        },
        {
          id: "1234567",
          name: "Campaign summer (Site ID)"
        },
        {
          id: "1234568",
          name: "Campaign winter (Search Leads)"
        },
        {
          id: "1234569",
          name: "Campaign TV (Business Leads)"
        }
      ],
      SelectedCampaignsAudience: [],
      pagination: {
        perPage: 10,
        currentPage: 1,
        total: 0,
        from: 0,
        to: 0
      },
      modals: {
        addEditCampaign: false,
        editCampaign: false,
        uploadAudiance: false,
        selectMedia: false,
        mediaSelect: false,
        pricesetup: false,
        campaignDetails: false,
        createConversionSegment: false,
      },
      selectedCampaignDetails: {}, 
      // adsTableData: [
      //   { id: '44253199', name: 'leadspeek_media_id_8', size: '250x250', imps: 214, clicks: 0, ctr: '0.0000%', cpm: '$5.84', spend: '$1.25' },
      // ],
      isDetailsLoading: false,
      detailedStats: {
          total_spend: 0,
          impressions: 0,
          clicks: 0,
          actions: 0,
          cpm: 0,
          ctr: 0,
          cpc: 0,
      },
      detailsDateFilter: {
          range: 'Last 7 Days',
          customDates: [],
          options: [
            { value: 'Lifetime', label: 'Lifetime' },
            { value: 'Today', label: 'Today' },
            { value: 'Yesterday', label: 'Yesterday' },
            { value: 'Last 7 Days', label: 'Last 7 Days' },
            { value: 'Previous Week', label: 'Previous Week' },
            { value: 'Month to Date', label: 'Month to Date' },
            { value: 'Last 30 Days', label: 'Last 30 Days' },
            { value: 'Previous Month', label: 'Previous Month' },
            { value: 'Quarter to Date', label: 'Quarter to Date' },
            { value: 'Last 90 Days', label: 'Last 90 Days' },
            { value: 'Year to Date', label: 'Year to Date' },
            { value: 'Custom Date Range', label: 'Custom Date Range' }
          ]
      },
      fetchingCampaignData: false,
      searchQuery: "",
      disabledaddcampaign: true,
      filterCampaignStatus: "all",
      dropdownVisible: "",
      CompanyNamedisabled: false,
      currSortBy: '',
      currOrderBy: '',
      optionCampaignStatus: [
        {
          value: "all",
          label: "All"
        },
        {
          value: "draft",
          label: "Draft"
        },
        {
          value: "play",
          label: "Running"
        },
        {
          value: "stop",
          label: "Stopped"
        }
      ],
      selectsCompany: {
        companyId: "",
        companySelected: "",
        companyList: [],
        campaignList: [],
        campaignSelected: []
      },
      companyId: "",
      ClientCompanyName: "",
      ClientFullName: "",
      ClientEmail: "",
      ClientPhone: "",
      ClientUserID: "",
      ClientCampaignName: "",
      selectedAudience: [],
      selectedMediaList: [],
      selectedAddMediaList: [],
      selectedEditMediaList: [],
      selectedRowDataOriginal: {},
      selectedRowData: {},
      popProcessingTxt: 'Please wait, adding new campaign ....',

      isLoadingModuleCost: false,
      isLoadingIconFinancials: {},
      isLoadingIconActiveCampaigns: {},

      LeadspeekFrequencyCappingImpressions: '',
      LeadspeekFrequencyCappingHours: '', 

      prevCampaignFinancial: null,
      ClientActiveID: '',
      ActiveLeadspeekID: '',
      LeadspeekUserId: '',
      LeadspeekCompany: '',
      LeadspeekCompanyName : '',
      LeadspeekMaxBid: '0',
      LeadspeekMonthlyBudget: '0',
      LeadspeekDailyBudget: '0',
      LeadspeekGoalValue: '0',
      LeadspeekGoalType: '',
      LeadspeekAgencyMarkup: 0,
      LeadspeekAgencyCoversCost: false,
      LeadspeekCostAgency: '0',
      LeadspeekProfitAgency: '0',
      LeadspeekActive: '',
      LeadspeekDisabled: '',
      LeadspeekActiveUser: '',
      LeadspeekStatus: '',

      LeadspekStartDate: '',
      LeadspeekEndDate: '',
      LeadspeekTotalDaily: '',
      LeadspeekTotalSpend: '0',
      LeadspeekTotalRemaining: '0',
      LeadspeekTotalBudget: '0',
      LeadspeekPreviousDaily: '0',
      LeadspeekPreviousRemaining: '0',
      LeadspeekPreviousBudget: '0',
      LeadspeekRemainingDays: '0',
      LeadspeekNowDate: '',
      LeadspeekWordingChangeBudget1: '',

      LeadspeekIsBudgetPaid: false,
      prevBudgetVisible: false,
      isProcessingEdit: false,
      isUpdatingAudience: false,
      loadingExternal: false,
      externalData: {},
      budgetInformationType: 'current_budget',
      budgetHistory: [
        {
          "id": 1,
          "start_date": "2025-10-16",
          "end_date": "2025-11-16",
          "daily_budget": 1,
          "total_spend": 4,
          "total_budget": 12
        }
      ],

      LeadspeekTotalBudgetByRemainingDays: '0',
      LeadspeekCostClientByRemainingDays: '0',
      LeadspeekProfitAgencyByRemainingDays: '0',
      LeadspeekCostAgencyByRemainingDays: '0',
      refreshInterval: null,
      totalSelectedAudience: 0,
      totalSelectedAudienceEdit: 0,

      simplifiPriceRule: {
        maxBid: {
          default: 12, // ini nanti akan di ambil di settingan clientdefaultprice, atau jika tidak ada ambil dari agencydefautlprice, jika tidak ada ambil dari agencydefautlprice. dan sepertinya juga ini tidak akan kepakai
          minimum: 8
        },
        dailyBudget: {
          minimum: 5
        },
      },
      simplifiErrorInput: {
        addCampaign: {
          maxBid: "",
          dailyBudget: ""
        },
        financialCampaign: {
          maxBid: "",
          dailyBudget: ""
        }
      },

      stepCreateCampaignActive: 1,
      mediaSelectDimensionFilter: 'all',
      userType: '',
      
      // Geo Fence
      useGeoFence: false,
      geoFences: [], // Array of geo fences to be sent to backend
      geoFenceRecencyId: 4, // Default: 1 month
      leafletAvailable: true, // Track if Leaflet CDN is available
      geoTargetingAgreement: false, // Agreement checkbox for geo targeting mode lock
      
      // Geo Fence (Edit Mode)
      editUseGeoFence: false,
      editGeoFences: [], // Array of geo fences untuk edit mode
      editGeoFenceRecencyId: 4, // Default: 1 month
      editGeoFencesOriginal: [], // Original geo fences untuk comparison
      editGeoFenceRecencyIdOriginal: 4, // Original recency ID untuk comparison (default: 1 month)
      userTypeOri:'',
      
      // Conversions
      enableSiteConversion: false, // For create mode
      editEnableSiteConversion: false, // For edit mode
      selectedConversionTypes: [], // For create mode
      editSelectedConversionTypes: [], // For edit mode
      conversionTypes: [], // Available conversion types (Purchase/Sale, etc.)
      loadingConversionTypes: false,
      loadingEditConversionState: false, // Loading state for conversion section in edit form
      conversionTypesDropdownOpen: false, // Track if conversion types dropdown is open
      
      // Geo Conversion (Create Mode)
      enableGeoConversion: false,
      geoConversionFences: [], // Array of ALL geo fences created (auto-selected, no checkbox needed)
      geoConversionRecencyId: 4, // Default: 1 month
      
      // Geo Conversion (Edit Mode)
      editEnableGeoConversion: false,
      editGeoConversionFences: [], // Array of ALL conversion geo fences (auto-loaded)
      editGeoConversionRecencyId: 4, // Default: 1 month
      loadingGeoConversionState: false, // Loading state for geo conversion section in edit form
      
      // CPA Settings (Create Mode)
      cpaViewThruPercentage: 100, // Default: 100%
      cpaClickThruPercentage: 100, // Default: 100%
      
      // CPA Settings (Edit Mode)
      editCpaViewThruPercentage: 100, // Default: 100%
      editCpaClickThruPercentage: 100, // Default: 100%
      
      // Attribution Settings (Create Mode)
      viewAttributionWindow: 30, // Default: 30 days
      clickAttributionWindow: 30, // Default: 30 days
      
      // Attribution Settings (Edit Mode)
      editViewAttributionWindow: 30, // Default: 30 days
      editClickAttributionWindow: 30, // Default: 30 days
    };
  },
  watch: {
  'selectedRowData.simplifi_selected_campaign': {
      handler() {
        this.$forceUpdate(); 
      },
      deep: true
  },
    // Watch stepCreateCampaignActive to restore geo map states when returning to step 1
    stepCreateCampaignActive(newStep, oldStep) {
      // When returning to step 1 from step 2, restore fences to GeoFenceMap components
      // Only restore when toggle is enabled and fences are available.
      if (newStep === 1 && oldStep === 2 && this.useGeoFence && this.geoFences && this.geoFences.length > 0) {
        // console.log('Restoring fences to step 1', {
        //   useGeoFence: this.useGeoFence,
        //   geoFencesCount: this.geoFences.length
        // });
        
        this.$nextTick(() => {
          // Use multiple attempts to ensure component is ready
          let attempts = 0;
          const maxAttempts = 10;
          const checkAndLoad = setInterval(() => {
            attempts++;
            if (this.$refs.geoFenceMap && this.$refs.geoFenceMap.map && !this.$refs.geoFenceMap.isClearing) {
              clearInterval(checkAndLoad);
              
              // Double-check: only restore if geoFences is still not empty AND useGeoFence is still true
              // (in case clearAll was called between watch trigger and this execution)
              if (this.useGeoFence && this.geoFences && this.geoFences.length > 0 && !this.$refs.geoFenceMap.isClearing) {
                // console.log('Restoring fences to map', {
                //   geoFencesCount: this.geoFences.length,
                //   isClearing: this.$refs.geoFenceMap.isClearing
                // });
                this.$refs.geoFenceMap.loadDraftFences(this.geoFences);
                // Also restore recency ID
                if (this.geoFenceRecencyId) {
                  this.$refs.geoFenceMap.recencyId = this.geoFenceRecencyId;
                  this.$refs.geoFenceMap.$emit('recency-updated', this.geoFenceRecencyId);
                }
              } else {
                // console.log('Skipping restore - conditions not met', {
                //   useGeoFence: this.useGeoFence,
                //   geoFencesCount: this.geoFences ? this.geoFences.length : 0,
                //   isClearing: this.$refs.geoFenceMap ? this.$refs.geoFenceMap.isClearing : false
                // });
              }
            } else if (attempts >= maxAttempts) {
              clearInterval(checkAndLoad);
              console.warn('GeoFenceMap component not ready after multiple attempts');
            }
          }, 200);
        });
      } else if (newStep === 1 && oldStep === 2) {
        // If returning to step 1 but no fences, ensure map is cleared
        // console.log('No fences to restore, ensuring map is clear');
        this.$nextTick(() => {
          if (this.$refs.geoFenceMap && this.$refs.geoFenceMap.map && !this.$refs.geoFenceMap.isClearing) {
            // If component exists but no fences, ensure it's cleared
            if (this.$refs.geoFenceMap.draftFences && this.$refs.geoFenceMap.draftFences.length > 0) {
              this.$refs.geoFenceMap.clearAll();
            }
          }
        });
      }

      // Keep Geo Conversion behavior consistent with Geo Targeting on Previous step.
      if (newStep === 1 && oldStep === 2 && this.enableGeoConversion && this.geoConversionFences && this.geoConversionFences.length > 0) {
        this.$nextTick(() => {
          let attempts = 0;
          const maxAttempts = 10;
          const checkAndLoadConversion = setInterval(() => {
            attempts++;
            if (this.$refs.geoConversionMap && this.$refs.geoConversionMap.map && !this.$refs.geoConversionMap.isClearing) {
              clearInterval(checkAndLoadConversion);

              if (this.enableGeoConversion && this.geoConversionFences && this.geoConversionFences.length > 0 && !this.$refs.geoConversionMap.isClearing) {
                this.$refs.geoConversionMap.loadDraftFences(this.geoConversionFences);
              }
            } else if (attempts >= maxAttempts) {
              clearInterval(checkAndLoadConversion);
              console.warn('GeoConversionMap component not ready after multiple attempts');
            }
          }, 200);
        });
      } else if (newStep === 1 && oldStep === 2) {
        this.$nextTick(() => {
          if (this.$refs.geoConversionMap && this.$refs.geoConversionMap.map && !this.$refs.geoConversionMap.isClearing) {
            if (this.$refs.geoConversionMap.draftFences && this.$refs.geoConversionMap.draftFences.length > 0) {
              this.$refs.geoConversionMap.clearAll();
            }
          }
        });
      }
    },
    useGeoFence: function(newVal) {
      // When geo fence is turned ON and audiences already selected, show overlap warning
      if (newVal === true) {
        const combinedCount = this.selectedAudience.length + this.SelectedCampaignsAudience.length;
        if (combinedCount > 0) {
          this.showTargetingOverlapWarning();
        }
      }
    },
    SelectedCampaignsAudience: function(newVal, oldVal) {
      // When campaign audience goes from 0 combined to 1+ combined with geo fence ON
      if (!this.useGeoFence) return;
      const oldCombined = (oldVal ? oldVal.length : 0) + this.selectedAudience.length;
      const newCombined = (newVal ? newVal.length : 0) + this.selectedAudience.length;
      if (oldCombined === 0 && newCombined > 0) {
        this.showTargetingOverlapWarning();
      }
    },
    editUseGeoFence: function(newVal) {
      // Edit mode: when geo fence is turned ON and audiences already selected, show overlap warning
      if (newVal === true) {
        const editLocal = this.selectedRowData && this.selectedRowData.simplifi_selected_audience ? this.selectedRowData.simplifi_selected_audience.length : 0;
        const editCampaign = this.selectedRowData && this.selectedRowData.simplifi_selected_campaign ? this.selectedRowData.simplifi_selected_campaign.length : 0;
        if (editLocal + editCampaign > 0) {
          this.showTargetingOverlapWarning();
        }
      }
    },
    'selectedRowData.simplifi_selected_campaign': function(newVal, oldVal) {
      // Edit mode: when campaign audience goes from 0 combined to 1+ combined with geo fence ON
      if (!this.editUseGeoFence) return;
      const editLocal = this.selectedRowData && this.selectedRowData.simplifi_selected_audience ? this.selectedRowData.simplifi_selected_audience.length : 0;
      const oldEditCombined = (oldVal ? oldVal.length : 0) + editLocal;
      const newEditCombined = (newVal ? newVal.length : 0) + editLocal;
      if (oldEditCombined === 0 && newEditCombined > 0) {
        this.showTargetingOverlapWarning();
      }
    },
    'selectsCompany.campaignList': {
      handler() {
        // When the campaign list becomes available (or refreshes) while the
        // edit modal is open, try pruning audiences whose product has been
        // disabled for the signed-in user.
        this.$nextTick(() => {
          this.tryPruneInactiveSelectedCampaigns();
        });
      },
      deep: false
    },
    // 'campaign.totalBudget'(val) {
    //   // Only allow numbers and .
    //   let filtered = String(val).replace(/[^\d.]/g, '');
    //   if (filtered !== String(val)) {
    //     this.campaign.totalBudget = filtered;
    //     return;
    //   }
    //   // Sync dailyBudget
    //   const num = parseFloat(filtered);
    //   if (!isNaN(num)) {
    //     this.campaign.dailyBudget = (num / 30).toFixed(2);
    //   } else {
    //     this.campaign.dailyBudget = '';
    //   }
    // },
    // 'campaign.dailyBudget'(val) {
    //   // Only allow numbers and .
    //   let filtered = String(val).replace(/[^\d.]/g, '');
    //   if (filtered !== String(val)) {
    //     this.campaign.dailyBudget = filtered;
    //     return;
    //   }
    //   // Sync totalBudget
    //   const num = parseFloat(filtered);
    //   if (!isNaN(num)) {
    //     this.campaign.totalBudget = (num * 30).toFixed(2);
    //   } else {
    //     this.campaign.totalBudget = '';
    //   }
    // }
    'agencyMarkup.coversCost'(newValue) {
      if (newValue) {
        // When checkbox is checked, force agency markup to 0%
        this.agencyMarkup.selected = '0';
        this.profitcalculation('add_campaign');
      }
    },
    'selectedRowData.agency_covers_cost'(newValue) {
      if (newValue) {
        // When checkbox is checked, force agency markup to 0%
        this.selectedRowData.agency_markup = 0;
        this.LeadspeekAgencyMarkup = 0;
        this.profitcalculation();
      }
    },
    'LeadspeekAgencyCoversCost'(newValue) {
      if (newValue) {
        // When checkbox is checked in financial form, force agency markup to 0%
        this.LeadspeekAgencyMarkup = '0';
        this.profitcalculation();
      }
    },
    'modals.uploadAudiance'(newValue, oldvalue) {
      if(oldvalue && !newValue) {
        this.addClassModalOpenInBody();
      }
    },
    'modals.mediaSelect'(newValue, oldvalue) {
      if(oldvalue && !newValue) {
        this.addClassModalOpenInBody();
      }
    },
    async 'modals.editCampaign'(newValue, oldValue) {
      if (newValue === false && oldValue === true) {
        await this.GetClientList(this.currSortBy,this.currOrderBy);
        this.clearCampaignForm();
      } else if (newValue === true && oldValue === false) {
        // Modal just opened - fetch device types and load geo fences
        // Set loading state early so loading indicator appears immediately
        if (this.selectedRowData && this.selectedRowData.simplifi_selected_campaign && this.selectedRowData.simplifi_selected_campaign.length > 0) {
          this.loadingEditConversionState = true;
        }
        // Set loading state for geo conversion
        this.loadingGeoConversionState = true;
        await this.fetchDeviceTypes();
        // Pre-load conversion types so they're available when needed
        await this.loadConversionTypes(true, true);
        this.$nextTick(async () => {
          await this.loadEditGeoFences();
          // Load conversion state for this campaign
          if (this.selectedRowData && this.selectedRowData.leadspeek_api_id) {
            try {
              await this.loadCampaignConversionState(this.selectedRowData.leadspeek_api_id);
              // Load geo conversion state
              await this.loadCampaignGeoConversionState(this.selectedRowData.leadspeek_api_id);
              // Load CPA and Attribution settings
              await this.loadCampaignCpaAndAttributionSettings();
            } finally {
              this.loadingEditConversionState = false;
              this.loadingGeoConversionState = false;
            }
          } else {
            this.loadingEditConversionState = false;
            this.loadingGeoConversionState = false;
          }
          // After backend-loaded state (including editEnableSiteConversion) is
          // fully applied, run prune so that audiences from disabled modules
          // are removed AND dependent features like Site Conversion are
          // auto-normalized in a single pass.
          this.tryPruneInactiveSelectedCampaigns();
        });
      }
    },
    async 'modals.addEditCampaign'(newValue, oldValue) {
      if (newValue === false && oldValue === true) {
        await this.GetClientList(this.currSortBy,this.currOrderBy);
        this.clearCampaignForm();
      } else if (newValue === true && oldValue === false) {
        // Modal just opened - fetch device types from API
        await this.fetchDeviceTypes();
      }
    },
    // Prevent negative values for CPA Settings (Create Mode)
    cpaViewThruPercentage(newVal) {
      if (typeof newVal === 'number' && !isNaN(newVal) && newVal < 0) {
        this.cpaViewThruPercentage = 0;
      }
    },
    cpaClickThruPercentage(newVal) {
      if (typeof newVal === 'number' && !isNaN(newVal) && newVal < 0) {
        this.cpaClickThruPercentage = 0;
      }
    },
    // Prevent negative values for Attribution Settings (Create Mode)
    viewAttributionWindow(newVal) {
      if (typeof newVal === 'number' && !isNaN(newVal) && newVal < 1) {
        this.viewAttributionWindow = 1;
      }
    },
    clickAttributionWindow(newVal) {
      if (typeof newVal === 'number' && !isNaN(newVal) && newVal < 1) {
        this.clickAttributionWindow = 1;
      }
    },
    // Prevent negative values for CPA Settings (Edit Mode)
    editCpaViewThruPercentage(newVal) {
      if (typeof newVal === 'number' && !isNaN(newVal) && newVal < 0) {
        this.editCpaViewThruPercentage = 0;
      }
    },
    editCpaClickThruPercentage(newVal) {
      if (typeof newVal === 'number' && !isNaN(newVal) && newVal < 0) {
        this.editCpaClickThruPercentage = 0;
      }
    },
    // Prevent negative values for Attribution Settings (Edit Mode)
    editViewAttributionWindow(newVal) {
      if (typeof newVal === 'number' && !isNaN(newVal) && newVal < 1) {
        this.editViewAttributionWindow = 1;
      }
    },
    editClickAttributionWindow(newVal) {
      if (typeof newVal === 'number' && !isNaN(newVal) && newVal < 1) {
        this.editClickAttributionWindow = 1;
      }
    }
  },
  computed: {
    totalCombinedAudience() {
      const campaignList = (this.selectsCompany && this.selectsCompany.campaignList) ? [...this.selectsCompany.campaignList] : [];
      const editData = this.selectedRowData ? { ...this.selectedRowData } : {};
      const isEdit = this.modals.editCampaign;

      let selectedRaw = isEdit ? (editData.simplifi_selected_campaign || [])  : (this.SelectedCampaignsAudience || []);

      let selectedIds = [];
      if (Array.isArray(selectedRaw)) {
        selectedIds = selectedRaw.map(id => Number(id));
      } else if (typeof selectedRaw === 'string' && selectedRaw.trim() !== "") {
        selectedIds = selectedRaw.split(',').map(id => Number(id.trim()));
      } else if (selectedRaw) {
        selectedIds = [Number(selectedRaw)];
      }

      selectedIds = selectedIds.filter(id => !isNaN(id));

      const totalFromExisting = campaignList.reduce((sum, item) => {
        if (selectedIds.includes(Number(item.id))) {
          return sum + (Number(item.total_leads) || 0);
        }
        return sum;
      }, 0);

      const localTotal = isEdit ? (Number(this.totalSelectedAudienceEdit) || 0) : (Number(this.totalSelectedAudience) || 0);
      return totalFromExisting + localTotal;
    },
    isMasterCompany() {
      const value = localStorage.getItem('is_master_company');
      return value === 'true';
    },
    activeProductModulesByCompany() {
      if (!this.$global) return null;

      const sidebar = this.$global.menuUserType === 'client'
        ? (this.$global.clientsidebar || {})
        : (this.$global.agencysidebar || {});

      if (!sidebar || typeof sidebar !== 'object' || Object.keys(sidebar).length === 0) {
        return null;
      }

      return sidebar;
    },
    filteredCampaignOptionsByProducts() {
      const campaignList = (this.selectsCompany && this.selectsCompany.campaignList) ? this.selectsCompany.campaignList : [];
      const activeModules = this.activeProductModulesByCompany;

      if (!activeModules) {
        return campaignList;
      }

      return campaignList.filter(campaign => {
        const campaignType = campaign && campaign.leadspeek_type ? String(campaign.leadspeek_type) : '';
        if (!campaignType) return true;
        if (!(campaignType in activeModules)) return true;
        return activeModules[campaignType] === true;
      });
    },
    isLocalModuleActive() {
      // Site Conversion requires at least one campaign with leadspeek_type === 'local'.
      // When the 'local' product module is disabled for the signed-in user (same
      // source of truth as DashboardLayout.vue), the feature is unreachable and
      // its UI should be hidden.
      const activeModules = this.activeProductModulesByCompany;
      if (!activeModules) return true; // unknown → don't hide (safe default)
      if (!('local' in activeModules)) return true;
      return activeModules.local !== false;
    },
    queriedData: {
        get() {
            let result = this.tableData;
            if (this.searchedData.length > 0) {
                result = this.searchedData;
            }
            return result;
        },
        set(value) {
            if (Array.isArray(value)) {
                if (this.searchedData.length > 0) {
                    this.searchedData = value;
                }else{
                    this.tableData = value
                }
            } else {
                console.warn('queriedData expects an array.');
            }
        }
    },
    hasLocalCampaignInSelected() {
      // Check if at least one selected campaign has leadspeek_type = 'local'
      const campaignList = this.selectsCompany.campaignList || [];
      let selectedCampaignIds = [];
      
      if (this.modals.editCampaign) {
        selectedCampaignIds = this.selectedRowData && this.selectedRowData.simplifi_selected_campaign 
          ? this.selectedRowData.simplifi_selected_campaign 
          : [];
      } else {
        selectedCampaignIds = this.SelectedCampaignsAudience || [];
      }
      
      if (selectedCampaignIds.length === 0) {
        return false;
      }
      
      const selectedCampaigns = campaignList.filter(campaign => 
        selectedCampaignIds.includes(campaign.id)
      );
      
      const localCampaigns = selectedCampaigns.filter(campaign => 
        campaign.leadspeek_type === 'local'
      );
      
      return localCampaigns.length >= 1;
    },
    localModuleName() {
      // Get module name from global (same as backend)
      return this.$global.globalModulNameLink.local.name || 'Site ID';
    },
    /** Minimal identity so Save cannot run with an empty/partial row (race after list refresh). */
    isEditCampaignSaveReady() {
      if (!this.modals || !this.modals.editCampaign) return false;
      const d = this.selectedRowData || {};
      if (d.id === undefined || d.id === null || d.id === '') return false;
      if (d.user_id === undefined || d.user_id === null || d.user_id === '') return false;
      const apiId = d.leadspeek_api_id;
      if (apiId === undefined || apiId === null) return false;
      if (typeof apiId === 'string' && apiId.trim() === '') return false;
      return true;
    },
    isSelectedCampaignDraft() {
      const c = this.selectedRowData || {};
      // Ikuti definisi existing Draft badge:
      // campaign_never_started == 'T' && active_user == 'F' && total_leads == '0'
      return (
        c.campaign_never_started === 'T' &&
        c.active_user === 'F' &&
        String(c.total_leads || '0') === '0'
      );
    },
    isAddressableAudienceLocked() {
      if (this.isSelectedCampaignDraft) return false;

      // Use snapshot from when edit opened - not live form state (unchecking must not trigger lock).
      const c = (this.selectedRowDataOriginal && this.selectedRowDataOriginal.id != null)
        ? this.selectedRowDataOriginal
        : (this.selectedRowData || {});

      const hasSelectedAudience = Array.isArray(c.simplifi_selected_audience) && c.simplifi_selected_audience.length > 0;
      const hasSelectedCampaign = Array.isArray(c.simplifi_selected_campaign) && c.simplifi_selected_campaign.length > 0;

      const isNotDraft = !(
        c.campaign_never_started === 'T' &&
        c.active_user === 'F' &&
        String(c.total_leads || '0') === '0'
      );

      // Lock local audience once campaign has already run (running/paused/stopped).
      if (isNotDraft) {
        return true;
      }

      // Selective lock: only non-draft campaigns that were geo-only when opened (no audience/campaign at open).
      return !hasSelectedAudience && !hasSelectedCampaign;
    },
  },
  async mounted() {
    // Check Leaflet availability and listen for CDN errors
    this.checkLeafletAvailability();
    window.addEventListener('leaflet-error', this.onLeafletUnavailable);
    
    const userData = this.$store.getters.userData;
    const protectAccessMenu = () => {
      // jika belom connect stripe
      if (!this.$global.stripeaccountconnected) {
        if (userData.user_type == 'client') {
          this.$router.push({ name: 'Profile Setup' });
        } else if (userData.user_type == 'userdownline' || userData.user_type == 'user')  {
          this.$router.push({ name: 'General Setting' });
        }
        return;
      }

      // jika bukan root emm
      if (this.$global.idsys != this.$global.masteridsys) {
        this.$router.push({ name: 'Profile Setup' });
        return;
      }

      if(userData.user_type == 'client') { // jika client
        const sidebar = this.$global.clientsidebar
        
        if (!sidebar['simplifi'] || !this.validateBetaFeature('simplifi_module')) {
          this.$router.push({ name: 'Profile Setup' });
          return;
        }
      } else if (userData.user_type == 'userdownline' || userData.user_type == 'user') { // jika agency
        const sidebarAgency = this.$global.agency_side_menu && this.$global.agency_side_menu.find(menu => menu.type == 'simplifi')

        if ((sidebarAgency && !sidebarAgency.status) || !this.validateBetaFeature('simplifi_module')) {
          this.$router.push({ name: 'Profile Setup' });
          return;
        }
      }
    }
    protectAccessMenu()
    this.userType = userData.user_type;

    this.getMinimumValueSimplifi();
    this.populateHoursOptions();
    this.GetCompanyGroup();
    if (userData.user_type == "client") {
      localStorage.setItem("companyGroupSelected", userData.id);
      this.companyID = userData.company_parent;
    } else {
      this.companyID = userData.company_id;
    }
    if (this.companyID) {
      this.GetCompanyList();
      this.GetClientList();
      this.checkAutoRefresh();
    }
    // this.fetchCampaignList();
    if (this.$global.globalviewmode) {
        this.userTypeOri = userData.user_type_ori;
    }

  },
  beforeDestroy() {
    // Clear interval to prevent memory leak
    this.stopAutoRefresh();
  },
  methods: {
    calculateInitialEditTotal() {
    if (this.$refs.userLocalAudienceEdit && this.$refs.userLocalAudienceEdit.tableData) {
      const selectedIds = this.selectedRowData.simplifi_selected_audience || [];
      const data = this.$refs.userLocalAudienceEdit.tableData;
      const total = data.filter(item => selectedIds.includes(item.id)).reduce((sum, item) => sum + (Number(item.total) || 0), 0);
      
      this.totalSelectedAudienceEdit = total;
    }
  },
    ... mapActions(['SimplifiGetCampaignMedia', 'SimplifiGetGeoFences', 'SimplifiGetDeviceTypes']),
    async fetchDeviceTypes() {
      try {
        // First, ensure deviceTypes only contains the main 4 types (Desktop, Mobile, Tablet, Connected TV)
        // This prevents any individual Connected TV devices from appearing
        const mainDeviceTypes = (this.deviceTypes || []).filter(dt => 
          dt.name === 'Desktop' || 
          dt.name === 'Mobile' || 
          dt.name === 'Tablet' || 
          dt.name === 'Connected TV'
        );
        
        // Preserve current values
        const currentValues = {};
        mainDeviceTypes.forEach(item => {
          currentValues[item.name] = item.val;
        });
        
        const response = await this.SimplifiGetDeviceTypes();

        // Handle response structure: response.device_types is directly an array
        if (response.result === 'success' && response.device_types && Array.isArray(response.device_types)) {
          const apiDeviceTypes = response.device_types;
          
          // Create mapping from API response
          // Map API names to our UI names and store IDs
          const nameMapping = {
            'Desktops and Laptops - All': 'Desktop',
            'Desktops and Laptops': 'Desktop',
            'Mobile - All': 'Mobile',
            'Mobile': 'Mobile',
            'Tablets - All': 'Tablet',
            'Tablets': 'Tablet',
            'Connected TV - All': 'Connected TV',
            'Connected TV': 'Connected TV',
            'CTV - All': 'Connected TV'
          };
          
          // Create ID mapping for backend
          const deviceTypeIdMap = {};
          apiDeviceTypes.forEach(dt => {
            const uiName = nameMapping[dt.name] || dt.name;
            if (uiName) {
              // Use the first matching ID for each UI name (prefer "All" versions)
              if (!deviceTypeIdMap[uiName] || dt.name.includes(' - All')) {
                deviceTypeIdMap[uiName] = dt.id;
              }
            }
          });
          
          // Store ID mapping for later use
          this.deviceTypeIdMap = deviceTypeIdMap;
          
          // Build new deviceTypes array from API
          // currentValues already set above from mainDeviceTypes
          const newDeviceTypes = [];
          const processedNames = new Set();
          
          // Process in order: Desktop, Mobile, Tablet, Connected TV
          const preferredOrder = ['Desktop', 'Mobile', 'Tablet', 'Connected TV'];
          
          preferredOrder.forEach(uiName => {
            if (!processedNames.has(uiName) && deviceTypeIdMap[uiName]) {
              newDeviceTypes.push({
                name: uiName,
                val: currentValues[uiName] !== undefined ? currentValues[uiName] : (uiName === 'Connected TV' ? false : true),
                id: deviceTypeIdMap[uiName]
              });
              processedNames.add(uiName);
            }
          });
          
          // Add any other device types from API that we haven't processed
          apiDeviceTypes.forEach(dt => {
            // Skip individual Connected TV devices (we only use "Connected TV - All")
            if (dt.name.startsWith('Connected TV - ') && dt.name !== 'Connected TV - All') {
              return; // Skip this device type
            }
            
            const uiName = nameMapping[dt.name] || dt.name;
            if (uiName && !processedNames.has(uiName)) {
              newDeviceTypes.push({
                name: uiName,
                val: currentValues[uiName] !== undefined ? currentValues[uiName] : false,
                id: dt.id
              });
              processedNames.add(uiName);
            }
          });
          
          this.deviceTypes = newDeviceTypes;
        } else {
          // If response structure is unexpected, use fallback
          console.warn('Unexpected device types response structure, using fallback', response);
          this.initializeFallbackDeviceTypes();
        }
      } catch (error) {
        console.error('[fetchDeviceTypes] Error occurred:', error);
        // Fallback: initialize with hardcoded data
        this.initializeFallbackDeviceTypes();
      }
    },
    initializeFallbackDeviceTypes() {
      // Fallback device types (complete list from API)
      const fallbackDeviceTypes = [
        {id: 1, name: 'Connected TV - All'},
        {id: 2, name: 'Connected TV - Amazon'},
        {id: 3, name: 'Connected TV - Apple'},
        {id: 4, name: 'Connected TV - Beelink'},
        {id: 5, name: 'Connected TV - Bqeel'},
        {id: 6, name: 'Connected TV - Dooh TV'},
        {id: 7, name: 'Connected TV - Google'},
        {id: 8, name: 'Connected TV - Hisense'},
        {id: 9, name: 'Connected TV - LG'},
        {id: 10, name: 'Connected TV - Logitech'},
        {id: 11, name: 'Connected TV - MBX'},
        {id: 12, name: 'Connected TV - Mecool'},
        {id: 13, name: 'Connected TV - Microsoft'},
        {id: 14, name: 'Connected TV - Minix'},
        {id: 15, name: 'Connected TV - Mozilla'},
        {id: 16, name: 'Connected TV - MStar'},
        {id: 17, name: 'Connected TV - MXQ'},
        {id: 18, name: 'Connected TV - Nexbox'},
        {id: 19, name: 'Connected TV - Nintendo'},
        {id: 20, name: 'Connected TV - Nvidia'},
        {id: 21, name: 'Connected TV - Opera'},
        {id: 22, name: 'Connected TV - Panasonic'},
        {id: 23, name: 'Connected TV - Philips'},
        {id: 24, name: 'Connected TV - Roku'},
        {id: 25, name: 'Connected TV - Samsung'},
        {id: 26, name: 'Connected TV - Sanyo'},
        {id: 27, name: 'Connected TV - Sharp'},
        {id: 28, name: 'Connected TV - Sony'},
        {id: 29, name: 'Connected TV - Tivo'},
        {id: 30, name: 'Connected TV - Toshiba'},
        {id: 31, name: 'Connected TV - Tronsmart'},
        {id: 32, name: 'Connected TV - Vizio'},
        {id: 33, name: 'Connected TV - Xiaomi'},
        {id: 34, name: 'Connected TV - Xlintek'},
        {id: 35, name: 'Mobile - All'},
        {id: 36, name: 'Desktops and Laptops - All'},
        {id: 37, name: 'Tablets - All'}
      ];
      
      // Create mapping
      const nameMapping = {
        'Desktops and Laptops - All': 'Desktop',
        'Mobile - All': 'Mobile',
        'Tablets - All': 'Tablet',
        'Connected TV - All': 'Connected TV'
      };
      
      // Create ID mapping
      const deviceTypeIdMap = {
        'Desktop': 36,
        'Mobile': 35,
        'Tablet': 37,
        'Connected TV': 1
      };
      this.deviceTypeIdMap = deviceTypeIdMap;
      
      // Update deviceTypes array with current values preserved
      const currentValues = {};
      this.deviceTypes.forEach(item => {
        currentValues[item.name] = item.val;
      });
      
      // Build deviceTypes array
      const newDeviceTypes = [
        {
          name: 'Desktop',
          val: currentValues['Desktop'] !== undefined ? currentValues['Desktop'] : true,
          id: 36
        },
        {
          name: 'Mobile',
          val: currentValues['Mobile'] !== undefined ? currentValues['Mobile'] : true,
          id: 35
        },
        {
          name: 'Tablet',
          val: currentValues['Tablet'] !== undefined ? currentValues['Tablet'] : true,
          id: 37
        },
        {
          name: 'Connected TV',
          val: currentValues['Connected TV'] !== undefined ? currentValues['Connected TV'] : false,
          id: 1
        }
      ];
      
      this.deviceTypes = newDeviceTypes;
    },
    getSelectedDeviceTypeIds() {
      // Get all selected device type IDs (main device types only)
      // Backend will automatically fetch and add all Connected TV sub-devices if Connected TV is selected
      const selectedIds = [];
      
      this.deviceTypes.forEach(item => {
        if (item.val && item.id) {
          selectedIds.push(item.id);
        }
      });
      
      return selectedIds;
    },
    async showCampaignDetails(campaign) {
      this.selectedCampaignDetails = { ...campaign };
      
      this.detailsDateFilter.range = 'Last 7 Days';
      this.detailsDateFilter.customDates = [];
      this.detailedStats = { total_spend: 0, impressions: 0, clicks: 0, actions: 0, cpm: 0, ctr: 0, cpc: 0 };
      
      this.modals.campaignDetails = true;

      await this.fetchCampaignDetails();
    },
    addClassModalOpenInBody() {
      this.$nextTick(() => {
        document.body.classList.add('modal-open')
      })
    },
    getMinimumValueSimplifi() {
      this
      .$store
      .dispatch('getMinimumValueSimplifi', {
        idsys: this.$global.idsys
      })
      .then(response => {
        // console.log('getMinimumValuesSimplifi', { response });
        this.simplifiPriceRule.maxBid.minimum = response.data.maxBid.minimum;
        this.simplifiPriceRule.dailyBudget.minimum = response.data.dailyBudget.minimum;
      })
      .catch(error => {
        this.$notify({ type: 'danger', message: 'Something Went Wrong At Get Minimum Values Simplifi', icon: 'fas fa-bug' });
      })
    },
    resetStepCreateCampaign() {
      this.stepCreateCampaignActive = 1;
    },
    nextStepCreateCampaign() {
      this.ProcessAddEditClient('', 'validation_request');
    },
    previousStepCreateCampaign() {
      if (this.stepCreateCampaignActive > 1) {
        this.stepCreateCampaignActive--;
        this.addClassModalOpenInBody();
        // Restore logic is now handled by watch on stepCreateCampaignActive
      }
    },
    onBudgetFieldKeydown(event, field, type = '') {
      if (event.key === 'Tab' && event.target) {
        this.onBudgetInput(field, event.target.value, type);
      }
      this.restrictInput(event);
    },
    validateMinimumInput(event,from,type, domEvent = null) {
      const handlers = {
        keyup: {
          addCampaign: {
            maxBid: () => {
              this.simplifiErrorInput.addCampaign.maxBid = (Number(this.campaign.maxBid) < Number(this.simplifiPriceRule.maxBid.minimum)) ?
                                                           (`*Max Bid Minimum $${this.simplifiPriceRule.maxBid.minimum}`) :
                                                           (``) ;
            },
            dailyBudget: () => {
              this.simplifiErrorInput.addCampaign.dailyBudget = (Number(this.campaign.dailyBudget) < Number(this.simplifiPriceRule.dailyBudget.minimum)) ?
                                                                (`*Daily Budget Minimum $${this.simplifiPriceRule.dailyBudget.minimum}`) :
                                                                (``) ;
            },
            monthlyBudget: () => {
              this.validateMinimumInput('keyup','addCampaign','dailyBudget')
            }
          },
          financialCampaign: {
            maxBid: () => {
              this.simplifiErrorInput.financialCampaign.maxBid = (Number(this.LeadspeekMaxBid) < Number(this.simplifiPriceRule.maxBid.minimum)) ?
                                                                 (`*Max Bid Minimum $${this.simplifiPriceRule.maxBid.minimum}`) :
                                                                 (``) ;
            },
            dailyBudget: () => {
              this.simplifiErrorInput.financialCampaign.dailyBudget = (Number(this.LeadspeekDailyBudget) < Number(this.simplifiPriceRule.dailyBudget.minimum)) ?
                                                                      (`*Daily Budget Minimum $${this.simplifiPriceRule.dailyBudget.minimum}`) :
                                                                      (``) ;
            },
            monthlyBudget: () => {
              this.validateMinimumInput('keyup','financialCampaign','dailyBudget')
            }
          },
        },
        blur: {
          addCampaign: {
            maxBid: () => {
              this.simplifiErrorInput.addCampaign.maxBid = "";
              this.campaign.maxBid = (Number(this.campaign.maxBid) < Number(this.simplifiPriceRule.maxBid.minimum)) ?  
                                     (this.simplifiPriceRule.maxBid.minimum) :
                                     (this.campaign.maxBid);
              this.campaign.maxBid = this.formatSimplifiPrice(this.campaign.maxBid);
            },
            dailyBudget: () => {
              this.simplifiErrorInput.addCampaign.dailyBudget = "";
              this.campaign.dailyBudget = (Number(this.campaign.dailyBudget) < Number(this.simplifiPriceRule.dailyBudget.minimum)) ?  
                                          (this.simplifiPriceRule.dailyBudget.minimum) :
                                          (this.campaign.dailyBudget);
              this.campaign.dailyBudget = this.formatSimplifiPrice(this.campaign.dailyBudget);
              this.onBudgetInput('dailyBudget', this.campaign.dailyBudget)
            },
            monthlyBudget: () => {
              this.simplifiErrorInput.addCampaign.dailyBudget = "";
              if (Number(this.campaign.dailyBudget) < Number(this.simplifiPriceRule.dailyBudget.minimum)) {
                this.campaign.dailyBudget = this.simplifiPriceRule.dailyBudget.minimum
                this.onBudgetInput('dailyBudget', this.campaign.dailyBudget)
              }
            }
          },
          financialCampaign: {
            maxBid: () => {
              this.simplifiErrorInput.financialCampaign.maxBid = "";
              this.LeadspeekMaxBid = (Number(this.LeadspeekMaxBid) < Number(this.simplifiPriceRule.maxBid.minimum)) ?  
                                     (this.simplifiPriceRule.maxBid.minimum) :
                                     (this.LeadspeekMaxBid);
              this.LeadspeekMaxBid = this.formatSimplifiPrice(this.LeadspeekMaxBid);
            },
            dailyBudget: () => {
              this.simplifiErrorInput.financialCampaign.dailyBudget = "";
              this.LeadspeekDailyBudget = (Number(this.LeadspeekDailyBudget) < Number(this.simplifiPriceRule.dailyBudget.minimum)) ?  
                                          (this.simplifiPriceRule.dailyBudget.minimum) :
                                          (this.LeadspeekDailyBudget);
              this.LeadspeekDailyBudget = this.formatSimplifiPrice(this.LeadspeekDailyBudget);
              this.onBudgetInput('dailyBudget', this.LeadspeekDailyBudget, 'financial')
            },
            monthlyBudget: () => {
              this.simplifiErrorInput.financialCampaign.dailyBudget = "";
              const rawValue = domEvent && domEvent.target
                ? domEvent.target.value
                : this.LeadspeekMonthlyBudget;
              this.onBudgetInput('totalBudget', rawValue, 'financial');
              if (Number(this.LeadspeekDailyBudget) < Number(this.simplifiPriceRule.dailyBudget.minimum)) {
                this.LeadspeekDailyBudget = this.simplifiPriceRule.dailyBudget.minimum;
                this.onBudgetInput('dailyBudget', this.LeadspeekDailyBudget, 'financial');
              }
            }
          },
        }
      };

      if (handlers[event] && handlers[event][from] && handlers[event][from][type]) {
        handlers[event][from][type]();
      }
    },
    restrictInput(event,inputType) {
      const input = event.target.value;
      // Allow backspace, arrow keys, and other non-character keys
      const char = event.key;
      if (['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab'].includes(char)) {
        return; 
      }

      if (inputType == 'integer') {
        if (!/^\d$/.test(char)) {
          event.preventDefault();
        }
      }

      if (inputType != 'integer' && /[0-9]/.test(char)) {
        const intPart = (input || '').split('.')[0];
        if (intPart.length >= 12) {
          event.preventDefault();
          return;
        }
      }

      if (inputType != 'integer' && (input || '').length >= 20) {
        event.preventDefault();
        return;
      }

      // Check if the character is not a number
      if (!char.match(/[0-9]/) && char !== '.') {
        event.preventDefault();
      }

      // Allow only one period
      if (char === '.' && input.includes('.')) {
        event.preventDefault();
      }
    },
    hasProgressCampaign() {
      return this.queriedData.some(c => 
        (c.audience_status === 'progress' || c.audience_status === null) ||
        (c.ads_upload_status === 'progress')
      );
    },
    startAutoRefresh() {
      if (!this.refreshInterval) {
        this.refreshInterval = setInterval(() => {
          if (!this.modals.mediaSelect && !this.modals.addEditCampaign && !this.modals.editCampaign) {
            this.GetClientList(this.currSortBy,this.currOrderBy,this.searchQuery);
          }
        }, 60000);
      }
    },
    stopAutoRefresh() {
      if (this.refreshInterval) {
        clearInterval(this.refreshInterval);
        this.refreshInterval = null;
      }
    },
    checkAutoRefresh() {
      if (this.hasProgressCampaign()) {
        this.startAutoRefresh();
      } else {
        this.stopAutoRefresh();
      }
    },
    validateBetaFeature(type) {
      if(type == 'simplifi_module') {
        if(!this.$global.betaFeature.simplifi_module.is_beta || this.$global.betaFeature.simplifi_module.apply_to_all_agency || this.$global.isBeta) {
          return true;
        } else {
          return false;
        }
      }
      return true;
    },
    async fetchSimplifiData(){
      this.loadingExternal = true
      const ids = this.queriedData.map(c => c.id)
      await this.$store.dispatch("SimplifiGetCampaignStats", {data:{
        campaign_ids: ids,
      }})
      .then(
        response => {
          // console.log(response);
          if (response.result == 'success') {
            this.externalData = response.campaign_stats
          }
          this.loadingExternal = false
        },
        error => {
          console.log(error);
          this.loadingExternal = false
        }
      );
    },
    async downloadCampaignReport(){
      if (!this.selectedCampaignDetails.id) {
          return;
      }

      const payload = {
          campaign_id: this.selectedCampaignDetails.id,
          date_range: this.detailsDateFilter.range,
          client_now_date: this.getTodayDateString(),
      };

      if (this.detailsDateFilter.range === 'Custom Date Range' && this.detailsDateFilter.customDates) {
          payload.start_date = this.detailsDateFilter.customDates[0];
          payload.end_date = this.detailsDateFilter.customDates[1];
      }

      await this.$store.dispatch("SimplifiCampaignReport", {data:payload})
      .then(
        response => {
          if (response.result == 'success') {
              Notification({
                  message: `
                    <p style="color: #000; font-size: 20px; font-weight: bold;">
                    <i class="el-icon-loading" style="margin-right: 10px;"></i> Preparing report...
                    </p>
                    <p style="color: #000; font-size: 14px; margin-top: 10px;">
                      We're now preparing your report. after ready, your report will be sent to your email.
                    </p>
                  `,
                  duration: 5000,
                  dangerouslyUseHTMLString: true,
              });      

          }else {
            Notification({ 
              message: `
                <p style="display: flex; align-items: center; color: #000; font-size: 14px; font-weight: bold;">
                  <i class="el-notification__icon el-icon-error" style="margin-right: 10px;"></i> 
                  <span style="font-size: 16px; font-family: 'Poppins', sans-serif;">Error</span>
                </p>
                <p style="color: #000; font-size: 14px; margin-top: 10px; font-family: 'Poppins', sans-serif;">
                  ${message || 'Server might be busy please try again later.'}
                </p>
              `,
              duration: 5000,
              dangerouslyUseHTMLString: true,
            })
          }
        },)
      .catch(error => {
        Notification({ 
          message: `
            <p style="display: flex; align-items: center; color: #000; font-size: 14px; font-weight: bold;">
              <i class="el-notification__icon el-icon-error" style="margin-right: 10px;"></i> 
              <span style="font-size: 16px; font-family: 'Poppins', sans-serif;">Error</span>
            </p>
            <p style="color: #000; font-size: 14px; margin-top: 10px; font-family: 'Poppins', sans-serif;">
              ${error.message || 'Server might be busy please try again later.'}
            </p>
          `,
          duration: 5000,
          dangerouslyUseHTMLString: true,
        })
      });
    },
    async fetchCampaignDetails(){
      if (!this.selectedCampaignDetails.id || this.isDetailsLoading) {
          return;
      }
      
      this.isDetailsLoading = true;

      const payload = {
          campaign_id: this.selectedCampaignDetails.id,
          date_range: this.detailsDateFilter.range,
          client_now_date: this.getTodayDateString(),
      };

      if (this.detailsDateFilter.range === 'Custom Date Range' && this.detailsDateFilter.customDates) {
          payload.start_date = this.detailsDateFilter.customDates[0];
          payload.end_date = this.detailsDateFilter.customDates[1];
      }

      await this.$store.dispatch("SimplifiGetCampaignDetails", {data:payload})
      .then(
        response => {
          if (response.result == 'success') {
              this.detailedStats = response.campaign_details;
          }else {
              this.$notify({ type: 'danger', message: response.message || 'Failed to fetch campaign details.' });
              this.detailedStats = {};
          }
          this.isDetailsLoading = false;
        },
        error => {
          this.$notify({ type: 'danger', message: error.message || 'Failed to fetch campaign details.' });
          this.detailedStats = {};
          this.isDetailsLoading = false;
        }
      );
    },
    getTodayDateString() {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const day = String(today.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    },
    clearCampaignForm() {
      this.ClientUserID = '';
      this.ClientCampaignName = '';
      this.selectsCompany.companySelected = '';
      this.ClientFullName = '';
      this.ClientEmail = '';
      this.ClientPhone = '';

      this.frequencyCapping = {
        impressions: "",
        hours: "",
        hoursOptions: this.frequencyCapping.hoursOptions
      };
      this.campaign = {
        destinationURL: "",
        dailyBudget: 0.00,
        totalBudget: 0.00,
        maxBid: 0.00
      };
      this.campaignGoal = {
        ...this.campaignGoal, 
        goal: "none",
        value: 0,
      };
      this.agencyMarkup.selected = 0;
      this.agencyMarkup.coversCost = false;

      this.SelectedCampaignsAudience = [];
      this.selectedAudience = [];
      this.$nextTick(() => {
        this.selectedMediaList = [];
      })
      this.selectedAddMediaList = [];
      this.selectedEditMediaList = [];
      this.selectedMediaType = 'display';
      
      // Reset Conversions
      this.enableSiteConversion = false;
      this.editEnableSiteConversion = false;
      this.selectedConversionTypes = [];
      this.editSelectedConversionTypes = [];
      
      // Reset Geo Conversion
      this.enableGeoConversion = false;
      this.editEnableGeoConversion = false;
      this.geoConversionFences = [];
      this.editGeoConversionFences = [];
      this.geoConversionRecencyId = 4; // Reset to default: 1 month
      this.editGeoConversionRecencyId = 4; // Reset to default: 1 month
      this.loadingGeoConversionState = false;
      
      // Reset CPA Settings
      this.cpaViewThruPercentage = 100;
      this.cpaClickThruPercentage = 100;
      this.editCpaViewThruPercentage = 100;
      this.editCpaClickThruPercentage = 100;
      
      // Reset Attribution Settings
      this.viewAttributionWindow = 30;
      this.clickAttributionWindow = 30;
      this.editViewAttributionWindow = 30;
      this.editClickAttributionWindow = 30;
      if (this.$refs.geoConversionMap) {
        this.$refs.geoConversionMap.clearAll();
      }
      if (this.$refs.editGeoConversionMap) {
        this.$refs.editGeoConversionMap.clearAll();
      }

      this.deviceTypes.forEach(item => {
        if (item.name === "Connected TV") {
          item.val = false;
        } else {
          item.val = true;
        }
      });

      this.selectedRowData = {};
      this.selectedRowDataOriginal = {};
      
      // Reset Geo Fence
      this.useGeoFence = false;
      this.geoFences = [];
      this.geoFenceRecencyId = 4; // Reset to default: 1 month
      this.geoTargetingAgreement = false; // Reset agreement checkbox
      this.leafletAvailable = true; // Reset on form clear
      if (this.$refs.geoFenceMap) {
        this.$refs.geoFenceMap.clearAll();
      }
      
      // Reset edit mode geo fence
      this.editUseGeoFence = false;
    },
    // Validation methods for CPA and Attribution Settings (on blur)
    validateCpaViewThruPercentage() {
      // Convert to number first to handle string inputs like "--21"
      const numValue = Number(this.cpaViewThruPercentage);
      if (isNaN(numValue) || numValue < 0) {
        // Return to default value (100) when invalid
        this.cpaViewThruPercentage = 100;
      } else if (numValue > 100) {
        this.cpaViewThruPercentage = 100;
      } else {
        // Ensure it's a valid number (not string)
        this.cpaViewThruPercentage = numValue;
      }
    },
    validateCpaClickThruPercentage() {
      // Convert to number first to handle string inputs like "--21"
      const numValue = Number(this.cpaClickThruPercentage);
      if (isNaN(numValue) || numValue < 0) {
        // Return to default value (100) when invalid
        this.cpaClickThruPercentage = 100;
      } else if (numValue > 100) {
        this.cpaClickThruPercentage = 100;
      } else {
        // Ensure it's a valid number (not string)
        this.cpaClickThruPercentage = numValue;
      }
    },
    validateViewAttributionWindow() {
      // Convert to number first to handle string inputs like "--21"
      const numValue = Number(this.viewAttributionWindow);
      if (isNaN(numValue) || numValue < 1) {
        // Return to default value (30) when invalid
        this.viewAttributionWindow = 30;
      } else if (numValue > 30) {
        this.viewAttributionWindow = 30;
      } else {
        // Ensure it's a valid number (not string)
        this.viewAttributionWindow = numValue;
      }
    },
    validateClickAttributionWindow() {
      // Convert to number first to handle string inputs like "--21"
      const numValue = Number(this.clickAttributionWindow);
      if (isNaN(numValue) || numValue < 1) {
        // Return to default value (30) when invalid
        this.clickAttributionWindow = 30;
      } else if (numValue > 30) {
        this.clickAttributionWindow = 30;
      } else {
        // Ensure it's a valid number (not string)
        this.clickAttributionWindow = numValue;
      }
    },
    validateEditCpaViewThruPercentage() {
      // Convert to number first to handle string inputs like "--21"
      const numValue = Number(this.editCpaViewThruPercentage);
      if (isNaN(numValue) || numValue < 0) {
        // Return to default value (100) when invalid
        this.editCpaViewThruPercentage = 100;
      } else if (numValue > 100) {
        this.editCpaViewThruPercentage = 100;
      } else {
        // Ensure it's a valid number (not string)
        this.editCpaViewThruPercentage = numValue;
      }
    },
    validateEditCpaClickThruPercentage() {
      // Convert to number first to handle string inputs like "--21"
      const numValue = Number(this.editCpaClickThruPercentage);
      if (isNaN(numValue) || numValue < 0) {
        // Return to default value (100) when invalid
        this.editCpaClickThruPercentage = 100;
      } else if (numValue > 100) {
        this.editCpaClickThruPercentage = 100;
      } else {
        // Ensure it's a valid number (not string)
        this.editCpaClickThruPercentage = numValue;
      }
    },
    validateEditViewAttributionWindow() {
      // Convert to number first to handle string inputs like "--21"
      const numValue = Number(this.editViewAttributionWindow);
      if (isNaN(numValue) || numValue < 1) {
        // Return to default value (30) when invalid
        this.editViewAttributionWindow = 30;
      } else if (numValue > 30) {
        this.editViewAttributionWindow = 30;
      } else {
        // Ensure it's a valid number (not string)
        this.editViewAttributionWindow = numValue;
      }
    },
    validateEditClickAttributionWindow() {
      // Convert to number first to handle string inputs like "--21"
      const numValue = Number(this.editClickAttributionWindow);
      if (isNaN(numValue) || numValue < 1) {
        // Return to default value (30) when invalid
        this.editClickAttributionWindow = 30;
      } else if (numValue > 30) {
        this.editClickAttributionWindow = 30;
      } else {
        // Ensure it's a valid number (not string)
        this.editClickAttributionWindow = numValue;
      }
      this.editGeoFences = [];
      this.editGeoFenceRecencyId = 4; // Reset to default: 1 month
      this.editGeoFencesOriginal = [];
      this.editGeoFenceRecencyIdOriginal = 4; // Reset to default: 1 month
      if (this.$refs.editGeoFenceMap) {
        this.$refs.editGeoFenceMap.clearAll();
      }
    },
    onGeoFencesUpdated(fences) {
      // Update geoFences data from component (create mode)
      // Auto-save immediately - every change on map is automatically updated
      const fencesArray = fences || [];
      
      // CRITICAL: If fences is empty array, always clear geoFences
      // This ensures clearAll() always works correctly
      if (Array.isArray(fencesArray) && fencesArray.length === 0) {
        this.geoFences = [];
        this.useGeoFence = false;
        // console.log('onGeoFencesUpdated: Cleared all fences (empty array received)');
        return;
      }
      
      this.geoFences = JSON.parse(JSON.stringify(fencesArray)); // Deep copy
      
      // console.log('onGeoFencesUpdated called', {
      //   fencesCount: fencesArray.length,
      //   geoFencesCount: this.geoFences.length,
      //   useGeoFence: this.useGeoFence
      // });
      
      // Auto-toggle: Enable useGeoFence if fences exist
      if (fencesArray.length > 0 && !this.useGeoFence) {
        this.useGeoFence = true;
      }
      
      // Auto-toggle: Disable useGeoFence if all fences are deleted
      if (fencesArray.length === 0 && this.useGeoFence) {
        this.useGeoFence = false;
      }
    },
    onRecencyUpdated(recencyId) {
      // Update recency ID from component (create mode)
      // Ensure recency is never null - default to 4 (1 month)
      this.geoFenceRecencyId = recencyId || 4;
    },
    showTargetingOverlapWarning() {
      // Delay to let any open dropdown close before showing the modal
      const self = this;
      setTimeout(function() {
      // Skip if campaign modal was closed during the delay
      if (!self.modals.addEditCampaign && !self.modals.editCampaign) return;
      MessageBox.alert(
        '<div style="text-align: left; padding: 4px 0;">' +
          '<p style="margin: 0 0 16px 0; color: #606266; font-size: 14px; line-height: 1.7;">' +
            'You\'re using <strong>Addressable Audiences</strong> and <strong>Geo-Fencing</strong> in the same campaign.' +
          '</p>' +
          '<p style="margin: 0 0 16px 0; color: #606266; font-size: 14px; line-height: 1.7;">' +
            'When combined, these targets work as an <strong>AND condition</strong> — only contacts who are both in your audience list and within your geo-fenced locations will be reached.' +
          '</p>' +
          '<p style="margin: 0 0 20px 0; color: #606266; font-size: 14px; line-height: 1.7;">' +
            'This can significantly <strong>limit your reach</strong> and may reduce campaign performance.' +
          '</p>' +
          '<div style="background: #F4F7FE; border-radius: 6px; padding: 12px 14px;">' +
            '<p style="margin: 0; color: #303133; font-size: 13px; line-height: 1.6;">' +
              '<strong>Best practice:</strong> Create separate campaigns for each targeting method to maximize reach and results.' +
            '</p>' +
          '</div>' +
        '</div>',
        'Targeting Overlap Detected',
        {
          confirmButtonText: 'Got It',
          type: 'warning',
          dangerouslyUseHTMLString: true,
          customClass: 'targeting-overlap-msgbox'
        }
      ).catch(function() {});
      }, 300);
    },
    onEditGeoFencesUpdated(fences) {
      // Update geoFences data from component (edit mode)
      // Auto-save immediately - every change on map is automatically updated
      this.editGeoFences = JSON.parse(JSON.stringify(fences || [])); // Deep copy
      // console.log('onEditGeoFencesUpdated called (auto-save):', {
      //   fencesCount: fences ? fences.length : 0,
      //   editGeoFencesCount: this.editGeoFences.length,
      //   fences: fences
      // });
      
      // Only allow auto-toggle for draft campaigns
      // For non-draft campaigns, geo-targeting mode is locked and cannot be changed
      const isDraft = this.isSelectedCampaignDraft;
      
      // Auto-toggle: Enable editUseGeoFence if fences exist (only for draft campaigns)
      if (isDraft && fences && fences.length > 0 && !this.editUseGeoFence) {
        this.editUseGeoFence = true;
      }
      
      // Auto-toggle: Disable editUseGeoFence if all fences are deleted (only for draft campaigns)
      // For non-draft campaigns, keep editUseGeoFence as true even if all fences are deleted
      // The backend will handle validation and prevent saving without fences
      if (isDraft && (!fences || fences.length === 0) && this.editUseGeoFence) {
        this.editUseGeoFence = false;
      }
    },
    onEditRecencyUpdated(recencyId) {
      // Update recency ID from component (edit mode)
      // Ensure recency is never null - default to 4 (1 month)
      this.editGeoFenceRecencyId = recencyId || 4;
    },
    onGeoConversionRecencyUpdated(recencyId) {
      // Update recency ID from component (create mode) for geo conversion
      // Ensure recency is never null - default to 4 (1 month)
      this.geoConversionRecencyId = recencyId || 4;
    },
    onEditGeoConversionRecencyUpdated(recencyId) {
      // Update recency ID from component (edit mode) for geo conversion
      // Ensure recency is never null - default to 4 (1 month)
      this.editGeoConversionRecencyId = recencyId || 4;
    },
    onLeafletUnavailable() {
      // Leaflet CDN not available - automatically use default location
      console.warn('Leaflet CDN not available - automatically using default location');
      this.leafletAvailable = false;
      // Ensure useGeoFence is false so campaign uses default location (ID 8180)
      this.useGeoFence = false;
      this.editUseGeoFence = false;
      this.geoFences = [];
      this.editGeoFences = [];
      this.geoFenceRecencyId = 4; // Reset to default: 1 month
      this.editGeoFenceRecencyId = 4; // Reset to default: 1 month
    },
    checkLeafletAvailability() {
      // Check if Leaflet is available on component mount
      if (typeof window.L === 'undefined') {
        // Wait a bit for CDN to load, then check again
        setTimeout(() => {
          if (typeof window.L === 'undefined') {
            console.warn('Leaflet CDN not available - using default location');
            this.onLeafletUnavailable();
          }
        }, 2000);
      }
    },
    // CONVERSION METHODS
    getSiteConversionTooltipMessage(isEditMode = false) {
      const localModuleName = this.localModuleName;
      
      if (isEditMode) {
        if (this.loadingEditConversionState) {
          return 'Loading site conversion data...';
        }
        if (!this.selectedRowData.simplifi_selected_campaign || this.selectedRowData.simplifi_selected_campaign.length === 0) {
          return `Please select at least one campaign with type "${localModuleName}" from "Select Audience from Existing Campaigns" to enable site conversion tracking.`;
        }
        if (!this.hasLocalCampaignInSelected) {
          return `Site Conversion requires at least one campaign with type "${localModuleName}" to be selected from "Select Audience from Existing Campaigns".`;
        }
      } else {
        if (this.SelectedCampaignsAudience.length === 0) {
          return `Please select at least one campaign with type "${localModuleName}" from "Select Audience from Existing Campaigns" to enable site conversion tracking.`;
        }
        if (!this.hasLocalCampaignInSelected) {
          return `Site Conversion requires at least one campaign with type "${localModuleName}" to be selected from "Select Audience from Existing Campaigns".`;
        }
      }
      return '';
    },
    toggleSiteConversion(newValue) {
      // Reset conversion types when toggle is turned off
      if (!newValue) {
        if (this.modals.editCampaign) {
          this.editSelectedConversionTypes = [];
        } else {
          this.selectedConversionTypes = [];
        }
      } else {
        // Validate: at least one selected campaign must have leadspeek_type = 'local'
        if (!this.hasLocalCampaignInSelected) {
          // Prevent enabling and show error message
          if (this.modals.editCampaign) {
            this.editEnableSiteConversion = false;
          } else {
            this.enableSiteConversion = false;
          }
          
          const localModuleName = this.localModuleName;
          this.$notify({
            type: 'danger',
            message: `Site Conversion requires at least one campaign with type "${localModuleName}" to be selected from "Select Audience from Existing Campaigns".`,
            icon: 'fas fa-exclamation-triangle',
            duration: 5000
          });
        }
      }
    },
    toggleGeoConversion(newValue) {
      // Reset geo conversion fences when toggle is turned off
      if (!newValue) {
        if (this.modals.editCampaign) {
          this.editGeoConversionFences = [];
          if (this.$refs.editGeoConversionMap) {
            this.$refs.editGeoConversionMap.clearAll();
          }
        } else {
          this.geoConversionFences = [];
          if (this.$refs.geoConversionMap) {
            this.$refs.geoConversionMap.clearAll();
          }
        }
      }
    },
    onGeoConversionFencesUpdated(fences) {
      // Update geoConversionFences data from component (create mode)
      // Auto-save immediately - every change on map is automatically updated
      const fencesArray = fences || [];
      
      // CRITICAL: If fences is empty array, always clear geoConversionFences
      if (Array.isArray(fencesArray) && fencesArray.length === 0) {
        this.geoConversionFences = [];
        this.enableGeoConversion = false;
        return;
      }
      
      this.geoConversionFences = JSON.parse(JSON.stringify(fencesArray)); // Deep copy
      
      // Auto-toggle: Enable enableGeoConversion if fences exist
      if (fencesArray.length > 0 && !this.enableGeoConversion) {
        this.enableGeoConversion = true;
      }
      
      // Auto-toggle: Disable enableGeoConversion if all fences are deleted
      if (fencesArray.length === 0 && this.enableGeoConversion) {
        this.enableGeoConversion = false;
      }
    },
    onEditGeoConversionFencesUpdated(fences) {
      // Update editGeoConversionFences data from component (edit mode)
      // Auto-save immediately - every change on map is automatically updated
      const fencesArray = fences || [];
      
      // CRITICAL: If fences is empty array, always clear editGeoConversionFences
      if (Array.isArray(fencesArray) && fencesArray.length === 0) {
        this.editGeoConversionFences = [];
        this.editEnableGeoConversion = false;
        return;
      }
      
      this.editGeoConversionFences = JSON.parse(JSON.stringify(fencesArray)); // Deep copy
      
      // Auto-toggle: Enable editEnableGeoConversion if fences exist
      if (fencesArray.length > 0 && !this.editEnableGeoConversion) {
        this.editEnableGeoConversion = true;
      }
      
      // Auto-toggle: Disable editEnableGeoConversion if all fences are deleted
      if (fencesArray.length === 0 && this.editEnableGeoConversion) {
        this.editEnableGeoConversion = false;
      }
    },
    handleConversionTypesVisibleChange(visible) {
      // Track dropdown state
      this.conversionTypesDropdownOpen = visible;
      
      // Load conversion types when dropdown opens
      if (visible) {
        this.loadConversionTypes(visible, false);
      }
    },
    async loadConversionTypes(visible, force = false) {
      // If called from visible-change event, only load if visible is true
      // If force is true, always load (used when loading for edit modal)
      if (!force && (!visible || this.loadingConversionTypes || this.conversionTypes.length > 0)) return;
      
      // If force is false but visible is false, don't load
      if (!force && !visible) return;
      
      // If already loading, wait for it to finish
      if (this.loadingConversionTypes) {
        // Wait for loading to finish
        while (this.loadingConversionTypes) {
          await new Promise(resolve => setTimeout(resolve, 100));
        }
        return;
      }
      
      // If already loaded and not forcing, return
      if (!force && this.conversionTypes.length > 0) return;
      
      // Store if dropdown was open before loading
      const wasDropdownOpen = this.conversionTypesDropdownOpen;
      
      this.loadingConversionTypes = true;
      try {
        const response = await this.$store.dispatch('getSimplifiConversionTypes');
        if (response && response.result === 'success' && response.data) {
          // Handle both direct array and nested structure
          let typesArray = [];
          if (Array.isArray(response.data)) {
            typesArray = response.data;
          } else if (response.data.segment_custom_value_types && Array.isArray(response.data.segment_custom_value_types)) {
            typesArray = response.data.segment_custom_value_types;
          }
          
          if (typesArray.length > 0) {
            // Use Vue.set or direct assignment to ensure reactivity
            this.$set(this, 'conversionTypes', typesArray.map(type => ({
              id: type.id,
              name: type.name || `Type #${type.id}`
            })));
          } else {
            console.warn('No conversion types found in response, using fallback');
            this.useFallbackConversionTypes();
          }
        } else {
          console.warn('Invalid response format:', response, 'using fallback');
          this.useFallbackConversionTypes();
        }
      } catch (error) {
        console.error('Failed to load conversion types:', error, 'using fallback');
        this.useFallbackConversionTypes();
        this.$notify({
          type: 'warning',
          message: 'Failed to load conversion types from API, using default types',
          icon: 'el-icon-warning'
        });
      } finally {
        this.loadingConversionTypes = false;
        
        // If dropdown was open before loading, keep it open after data is loaded
        if (wasDropdownOpen) {
          // Use double nextTick to ensure DOM is fully updated
          this.$nextTick(() => {
            this.$nextTick(() => {
              const createSelect = this.$refs.conversionTypesSelectCreate;
              const editSelect = this.$refs.conversionTypesSelectEdit;
              
              // Function to reopen dropdown
              const reopenDropdown = (selectRef) => {
                if (!selectRef) return;
                
                // Get the input element
                const input = selectRef.$el.querySelector('input');
                if (!input) return;
                
                // Method 1: Try to set visible state directly via internal state
                if (selectRef.$data) {
                  selectRef.$data.visible = true;
                }
                
                // Method 2: Focus and trigger dropdown programmatically
                input.focus();
                
                // Method 3: Use Element UI's internal method if available
                if (selectRef.handleFocus) {
                  selectRef.handleFocus();
                }
              };
              
              // Reopen dropdown for both create and edit mode
              reopenDropdown(createSelect);
              reopenDropdown(editSelect);
            });
          });
        }
      }
    },
    useFallbackConversionTypes() {
      // Fallback conversion types if API fetch fails
      const fallbackTypes = [
        { id: 1, name: 'Purchase/Sale' },
        { id: 2, name: 'Lead' },
        { id: 3, name: 'Signup' },
        { id: 4, name: 'Other' }
      ];
      this.$set(this, 'conversionTypes', fallbackTypes);
    },
    async loadCampaignConversionState(campaignId) {
      try {
        // Follow audience pattern: use data directly from selectedRowData (from local database)
        // Infer conversion_enabled from conversion_type_ids (not empty = enabled)
        const hasConversion = this.selectedRowData && 
            Array.isArray(this.selectedRowData.conversion_type_ids) && 
            this.selectedRowData.conversion_type_ids.length > 0;
        this.editEnableSiteConversion = hasConversion;
        if (!hasConversion) {
          this.editSelectedConversionTypes = [];
          return;
        }

        // First, try to use conversion_type_ids from local database (selectedRowData)
        if (Array.isArray(this.selectedRowData.conversion_type_ids) && this.selectedRowData.conversion_type_ids.length > 0) {
          this.editSelectedConversionTypes = this.selectedRowData.conversion_type_ids.map(id => parseInt(id, 10));
          // Ensure conversion types list is loaded for labels
          if (this.conversionTypes.length === 0) {
            await this.loadConversionTypes(true, true);
          }
          return;
        }

        // Always load conversion types first (force load for edit modal)
        await this.loadConversionTypes(true, true);
        
        // Get custom value type IDs from Simplifi API using segment_id from local database
        if (this.selectedRowData.conversion_segment_id) {
          try {
            const segmentId = this.selectedRowData.conversion_segment_id;
            const segmentResponse = await this.$store.dispatch('getSimplifiConversionSegment', segmentId);
            
            // Handle different response structures
            let customValues = [];
            if (segmentResponse && segmentResponse.result === 'success' && segmentResponse.data) {
              // Try different possible structures
              if (segmentResponse.data.first_party_segment_custom_values && Array.isArray(segmentResponse.data.first_party_segment_custom_values)) {
                customValues = segmentResponse.data.first_party_segment_custom_values;
              } else if (segmentResponse.data.custom_values && Array.isArray(segmentResponse.data.custom_values)) {
                customValues = segmentResponse.data.custom_values;
              } else if (segmentResponse.data.first_party_segments && segmentResponse.data.first_party_segments[0]) {
                const segment = segmentResponse.data.first_party_segments[0];
                if (segment.custom_values && Array.isArray(segment.custom_values)) {
                  customValues = segment.custom_values;
                } else if (segment.first_party_segment_custom_values && Array.isArray(segment.first_party_segment_custom_values)) {
                  customValues = segment.first_party_segment_custom_values;
                }
              }
            }
            
            if (customValues.length > 0) {
              this.editSelectedConversionTypes = customValues.map(cv => cv.segment_custom_value_type_id);
            } else {
              console.warn('No custom values found in segment response');
              this.editSelectedConversionTypes = [];
            }
          } catch (error) {
            console.error('Failed to load segment custom values:', error);
            // If we can't load custom values, just enable toggle but leave types empty
            this.editSelectedConversionTypes = [];
          }
        } else {
          this.editSelectedConversionTypes = [];
        }
      } catch (error) {
        console.error('Failed to load campaign conversion state:', error);
        this.editEnableSiteConversion = false;
        this.editSelectedConversionTypes = [];
      }
    },
    async loadCampaignGeoConversionState(campaignId) {
      try {
        this.loadingGeoConversionState = true;
        
        // Follow audience pattern: use data directly from selectedRowData (from local database)
        // Infer geo_conversion_enabled from geo_conversion_fence_ids (not empty = enabled)
        const hasGeoConversion = this.selectedRowData && 
            Array.isArray(this.selectedRowData.geo_conversion_fence_ids) && 
            this.selectedRowData.geo_conversion_fence_ids.length > 0;
        this.editEnableGeoConversion = hasGeoConversion;
        
        if (!hasGeoConversion) {
          this.editGeoConversionFences = [];
          this.editGeoConversionRecencyId = 4; // Default: 1 month
          return;
        }

        // Get geo conversion fences from API
        // Use get_campaign_conversion_segments endpoint which now includes geo_conversion_fences
        try {
          const response = await this.$store.dispatch('getCampaignConversionSegments', campaignId);
          
          if (response && response.result === 'success' && response.data) {
            // Check for geo conversion fences in response
            if (response.data.geo_conversion_fences && Array.isArray(response.data.geo_conversion_fences) && response.data.geo_conversion_fences.length > 0) {
              this.editGeoConversionFences = response.data.geo_conversion_fences;
              
              // Extract recency_id from first fence (if available)
              if (response.data.geo_conversion_fences[0] && response.data.geo_conversion_fences[0].recency_id) {
                this.editGeoConversionRecencyId = response.data.geo_conversion_fences[0].recency_id;
              } else {
                this.editGeoConversionRecencyId = 4; // Default: 1 month
              }
              
              // Load fences into map component - wait for component to be ready
              await this.$nextTick();
              setTimeout(() => {
                if (this.$refs.editGeoConversionMap) {
                  this.$refs.editGeoConversionMap.loadExistingFences(response.data.geo_conversion_fences);
                }
              }, 300);
            } else {
              // Fallback: try to get from geo_fences endpoint and filter by type
              const geoFencesResponse = await this.SimplifiGetGeoFences(campaignId);
              if (geoFencesResponse && geoFencesResponse.result === 'success' && geoFencesResponse.data && geoFencesResponse.data.geo_fences) {
                // Filter only conversion fences
                const conversionFences = geoFencesResponse.data.geo_fences.filter(fence => 
                  fence.geo_fence_type_name === 'Conversion'
                );
                
                if (conversionFences.length > 0) {
                  this.editGeoConversionFences = conversionFences;
                  
                  if (conversionFences[0] && conversionFences[0].recency_id) {
                    this.editGeoConversionRecencyId = conversionFences[0].recency_id;
                  } else {
                    this.editGeoConversionRecencyId = 4;
                  }
                  
                  await this.$nextTick();
                  setTimeout(() => {
                    if (this.$refs.editGeoConversionMap) {
                      this.$refs.editGeoConversionMap.loadExistingFences(conversionFences);
                    }
                  }, 300);
                } else {
                  this.editGeoConversionFences = [];
                  this.editGeoConversionRecencyId = 4;
                }
              } else {
                this.editGeoConversionFences = [];
                this.editGeoConversionRecencyId = 4;
              }
            }
          } else {
            this.editGeoConversionFences = [];
            this.editGeoConversionRecencyId = 4;
          }
        } catch (error) {
          console.error('Failed to load geo conversion fences:', error);
          this.editGeoConversionFences = [];
          this.editGeoConversionRecencyId = 4;
        }
      } catch (error) {
        console.error('Failed to load campaign geo conversion state:', error);
        this.editEnableGeoConversion = false;
        this.editGeoConversionFences = [];
        this.editGeoConversionRecencyId = 4;
        } finally {
          this.loadingGeoConversionState = false;
        }
      },
      async loadCampaignCpaAndAttributionSettings() {
        try {
          // Load CPA and Attribution settings from database (selectedRowData)
          if (this.selectedRowData) {
            // Load CPA settings if goal_type is CPA
            if (this.selectedRowData.goal_type === 'cpa') {
              // Convert decimal to percentage and floor for display (0.206 = 20.6% → display as 20%)
              // Like Simpli.fi: display floored (truncated), but store decimal in database
              if (this.selectedRowData.cpa_view_thru_per !== null && this.selectedRowData.cpa_view_thru_per !== undefined) {
                this.editCpaViewThruPercentage = Math.floor(parseFloat(this.selectedRowData.cpa_view_thru_per) * 100);
              } else {
                this.editCpaViewThruPercentage = 100; // Default
              }
              
              if (this.selectedRowData.cpa_click_thru_per !== null && this.selectedRowData.cpa_click_thru_per !== undefined) {
                this.editCpaClickThruPercentage = Math.floor(parseFloat(this.selectedRowData.cpa_click_thru_per) * 100);
              } else {
                this.editCpaClickThruPercentage = 100; // Default
              }
            } else {
              // Reset to defaults if not CPA
              this.editCpaViewThruPercentage = 100;
              this.editCpaClickThruPercentage = 100;
            }
            
            // Load Attribution Settings from database
            if (this.selectedRowData.view_attribution_window !== null && this.selectedRowData.view_attribution_window !== undefined) {
              this.editViewAttributionWindow = parseInt(this.selectedRowData.view_attribution_window, 10);
            } else {
              this.editViewAttributionWindow = 30; // Default
            }
            
            if (this.selectedRowData.click_attribution_window !== null && this.selectedRowData.click_attribution_window !== undefined) {
              this.editClickAttributionWindow = parseInt(this.selectedRowData.click_attribution_window, 10);
            } else {
              this.editClickAttributionWindow = 30; // Default
            }
          } else {
            // Set defaults if no row data available
            this.editCpaViewThruPercentage = 100;
            this.editCpaClickThruPercentage = 100;
            this.editViewAttributionWindow = 30;
            this.editClickAttributionWindow = 30;
          }
        } catch (error) {
          console.error('Error loading CPA and Attribution settings:', error);
          // Set defaults on error
          this.editCpaViewThruPercentage = 100;
          this.editCpaClickThruPercentage = 100;
          this.editViewAttributionWindow = 30;
          this.editClickAttributionWindow = 30;
        }
      },
      async loadEditGeoFences() {
      try {
        // Skip if campaign doesn't have valid leadspeek_api_id
        if (!this.selectedRowData || !this.selectedRowData.leadspeek_api_id) {
          this.editUseGeoFence = false;
          this.editGeoFences = [];
          this.editGeoFenceRecencyId = 4;
          return;
        }
        
        // Check if campaign has geo fences
        const response = await this.SimplifiGetGeoFences(this.selectedRowData.leadspeek_api_id);
        
        if (response.result === 'success' && response.data && response.data.geo_fences && response.data.geo_fences.length > 0) {
          // Filter only Target fences (exclude Conversion fences)
          const targetFences = response.data.geo_fences.filter(fence => 
            fence.geo_fence_type_name === 'Target' || 
            !fence.geo_fence_type_name || 
            fence.geo_fence_type_name === null
          );
          
          if (targetFences.length > 0) {
            // Campaign has geo fences
            this.editUseGeoFence = true;
            this.editGeoFences = targetFences;
            // Store original untuk comparison
            this.editGeoFencesOriginal = JSON.parse(JSON.stringify(targetFences));
            
            // Extract recency_id from first fence (if available)
            if (targetFences[0] && targetFences[0].recency_id) {
              this.editGeoFenceRecencyId = targetFences[0].recency_id;
              this.editGeoFenceRecencyIdOriginal = targetFences[0].recency_id;
            } else {
              // No recency from API, use default: 1 month
              this.editGeoFenceRecencyId = 4;
              this.editGeoFenceRecencyIdOriginal = 4;
            }
            
            // Load fences into map component - wait for component to be ready
            await this.$nextTick();
            // Wait a bit more to ensure GeoFenceMap component is fully mounted
            setTimeout(() => {
              if (this.$refs.editGeoFenceMap) {
                this.$refs.editGeoFenceMap.loadExistingFences(targetFences);
              }
            }, 300);
          } else {
            // Campaign doesn't have Target geo fences
            this.editUseGeoFence = false;
            this.editGeoFences = [];
            this.editGeoFenceRecencyId = 4; // Default: 1 month
            this.editGeoFencesOriginal = [];
            this.editGeoFenceRecencyIdOriginal = 4; // Default: 1 month
          }
        } else {
          // Campaign doesn't have geo fences
          this.editUseGeoFence = false;
          this.editGeoFences = [];
          this.editGeoFenceRecencyId = 4; // Default: 1 month
          this.editGeoFencesOriginal = [];
          this.editGeoFenceRecencyIdOriginal = 4; // Default: 1 month
        }
      } catch (error) {
        console.error('Failed to load geo fences for edit:', error);
        // Default to no geo fences
        this.editUseGeoFence = false;
        this.editGeoFences = [];
        this.editGeoFenceRecencyId = 4; // Default: 1 month
        this.editGeoFencesOriginal = [];
        this.editGeoFenceRecencyIdOriginal = 4; // Default: 1 month
      }
    },
    async setModuleCost() {
      this.onBudgetInput('totalBudget', this.LeadspeekMonthlyBudget, 'financial');

      /* VALIDATION */
      const userData = this.$store.getters.userData;

      if (Number(this.LeadspeekMaxBid) < Number(this.simplifiPriceRule.maxBid.minimum)) {
        this.$notify({ type: 'danger', message: `max bid minimum $${this.simplifiPriceRule.maxBid.minimum}`, icon: 'fas fa-bug' }); return;
      }
      if (!this.LeadspeekMaxBid) {
        this.$notify({ type: 'danger', message: 'max bid cannot be empty', icon: 'fas fa-bug' }); return;
      }

      if (this.LeadspeekMonthlyBudget <= 0) {
        this.$notify({ type: 'danger', message: 'monthly budget must be above 0', icon: 'fas fa-bug' }); return;
      }
      if (!this.LeadspeekMonthlyBudget) {
        this.$notify({ type: 'danger', message: 'monthly budget cannot be empty', icon: 'fas fa-bug' }); return;
      }

      if (Number(this.LeadspeekDailyBudget) < Number(this.simplifiPriceRule.dailyBudget.minimum)) {
        this.$notify({ type: 'danger', message: `daily budget minimum $${this.simplifiPriceRule.dailyBudget.minimum}`, icon: 'fas fa-bug' }); return;
      }
      if (!this.LeadspeekDailyBudget) {
        this.$notify({ type: 'danger', message: 'daily budget cannot be empty', icon: 'fas fa-bug' }); return;
      }
      /* VALIDATION */

      // this.processSetModuleCost();
      // return alert('tahap ke 0');

      /* check whether the daily budget becomes larger in the middle of the road and the campaign status is active  */
      this.isLoadingModuleCost = true;
      let isCampaignRunning = false;
      let isCampaignBudgetIncreased = false;
      let costClientByRemainingDays = 0 
      let profitAgencyByRemainingDays = 0
      let costAgencyByRemainingDays = 0

      try { 
        const response = await this.$store.dispatch('checkBudgetSimplifiIncrease', {
          campaign_action_source: "from_financial_campaign",
          leadspeek_api_id: this.ActiveLeadspeekID,
          current_daily_budget: this.LeadspeekDailyBudget,
          current_agency_markup: this.LeadspeekAgencyMarkup,
          current_goal_type: this.LeadspeekGoalType,
          current_goal_value: this.LeadspeekGoalValue,
        });
        // console.log('checkBudgetSimplifiIncrease', { response });

        isCampaignRunning = response.is_campaign_running;
        isCampaignBudgetIncreased = response.is_campaign_budget_increased;

        if (isCampaignBudgetIncreased && isCampaignRunning) { // perbaru nilai remaining days, previous spend dan previous total remaining
          this.LeadspeekRemainingDays = response.remaining_days;
          this.LeadspeekTotalSpend = response.previous_total_spend;
          this.LeadspeekTotalRemaining = response.previous_total_remaining;

          costClientByRemainingDays = response.cost_client_by_remaining_days;
          profitAgencyByRemainingDays = response.profit_agency_by_remaining_days;
          costAgencyByRemainingDays = response.cost_agency_by_remaining_days;
        }
      } catch (error) {
        console.log(error);

        this.isLoadingModuleCost = false;
        const message = typeof(error.response.data.message) != 'undefined' ? error.response.data.message : 'something went wrong'
        return this.$notify({ type: 'danger', message: message, icon: 'fas fa-bug' });
      }
      /* check whether the daily budget becomes larger in the middle of the road and the campaign status is active  */

      // this.isLoadingModuleCost = false;
      // return alert('tahap ke 1');

      if (isCampaignBudgetIncreased && isCampaignRunning) { // jika budget dirubah di tengah jalan dan campaign sedang running, maka langsung di charge sisa nya
        // console.log('if');
        this.isLoadingModuleCost = false;
        
        // ul and li
        let btnOkName = 'I agree';
        let defaultText = '<p style="text-align: left; color: initial; margin-left: 16px;">Changing this budget will authorize the following costs:<br>';
        
        defaultText += '<ul style="text-align: left; margin-left: 16px;">';
        defaultText += `<li class="alert-li">Frequency capping: ${this.LeadspeekFrequencyCappingImpressions} impression per ${this.LeadspeekFrequencyCappingHours} hours</li>`;
        
        if (this.LeadspeekGoalType == 'none') {
          defaultText += `<li class="alert-li">Goal: None specified</li>`;
        } else if (this.LeadspeekGoalType == 'ctr') {
          defaultText += `<li class="alert-li">Goal: ${this.LeadspeekGoalValue}% ${this.LeadspeekGoalType.toUpperCase()}</li>`;
        } else {
          defaultText += `<li class="alert-li">Goal: $${this.LeadspeekGoalValue} ${this.LeadspeekGoalType.toUpperCase()}</li>`;
        }
        
        defaultText += `<li class="alert-li">Maximum bid: $${this.LeadspeekMaxBid} CPM</li>`;
        defaultText += `<li class="alert-li">Daily budget: $${this.LeadspeekDailyBudget}</li>`;
        
        defaultText += `<li class="alert-li">Client Monthly Cost: $${costClientByRemainingDays}</li>`;
        if(['userdownline', 'user'].includes(userData.user_type)) {
          defaultText += `<li class="alert-li">Monthly Ad Budget: $${costAgencyByRemainingDays}</li>`;
          defaultText += `<li class="alert-li">Agency Profit: $${profitAgencyByRemainingDays}</li>`;
        }

        defaultText += '</ul>';
        defaultText += '. I understand that the purchase of prepaid contacts is non-refundable.';
        // ul and li

        const result = await swal.fire({
          title: "Are you sure you want to increase daily budget?",
          html: defaultText,
          icon: '',
          showCancelButton: true,
          customClass: {
            confirmButton: 'btn btn-default btn-fill',
            cancelButton: 'btn btn-danger btn-fill'
          },
          confirmButtonText: btnOkName,
          buttonsStyling: false
        });

        if (result.isConfirmed) {
          this.processChargeCampaignByRemainingDays(costClientByRemainingDays, costAgencyByRemainingDays);
        }
      } else { // jika tidak maka save cost module kaya biasa
        // console.log('else');
        this.processSetModuleCost();
      }
    },
    processSetModuleCost() {
      this.$store.dispatch('SimplifiModuleCost', {
        ClientID: this.ClientActiveID,
        LeadspeekMaxBid: this.LeadspeekMaxBid,
        LeadspeekMonthlyBudget: this.LeadspeekMonthlyBudget,
        LeadspeekDailyBudget: this.LeadspeekDailyBudget,
        LeadspeekGoalValue: this.LeadspeekGoalValue,
        LeadspeekGoalType: this.LeadspeekGoalType,
        LeadspeekAgencyMarkup: this.LeadspeekAgencyMarkup,
        LeadspeekAgencyCoversCost: this.LeadspeekAgencyCoversCost,
      })
      .then(response => {
        // user logs edit
        let descriptionLogs = "";
        const { LeadspeekMaxBid, LeadspeekMonthlyBudget, LeadspeekDailyBudget, LeadspeekGoalValue, LeadspeekGoalType, LeadspeekAgencyMarkup, LeadspeekAgencyCoversCost } = this.prevCampaignFinancial;
        const updates = [
          { label: 'Max Bid', prev: LeadspeekMaxBid, new: this.LeadspeekMaxBid },
          { label: 'Monthly Budget', prev: LeadspeekMonthlyBudget, new: this.LeadspeekMonthlyBudget },
          { label: 'Daily Budget', prev: LeadspeekDailyBudget, new: this.LeadspeekDailyBudget },
          { label: 'Goal Value', prev: LeadspeekGoalValue, new: this.LeadspeekGoalValue },
          { label: 'Goal Type', prev: LeadspeekGoalType, new: this.LeadspeekGoalType },
          { label: 'Agency Profit Margin', prev: LeadspeekAgencyMarkup, new: this.LeadspeekAgencyMarkup },
          { label: 'Client costs covered by Agency', prev: LeadspeekAgencyCoversCost ? 'Yes' : 'No', new: this.LeadspeekAgencyCoversCost ? 'Yes' : 'No' },
        ]

        updates.forEach(({ label, prev, new: newValue }) => {
          descriptionLogs += (prev !== newValue) ?
                             (`${label} : Update values from ${prev} to ${newValue} | `) :
                             (`${label} : No changes, value remains ${prev} | `);
        });

        descriptionLogs = descriptionLogs.trim().replace(/\|$/, "");
        const desc = descriptionLogs ? descriptionLogs : 'No updates were made as all values remain unchanged.';
        
        this.$store.dispatch('onSaveUserLogs', {
          desc: `Campaign Id: ${this.ActiveLeadspeekID} | ${desc}`,
          action: 'Edit Campaign Financial Simplifi',
          target_id: this.userIdCampaign,
        })
        // user logs edit

        // update rows
        this.tableData.filter(item => {
          if (item.id == this.ClientActiveID) {
            item.max_bid = this.LeadspeekMaxBid;
            item.monthly_budget = this.LeadspeekMonthlyBudget;
            item.daily_budget = this.LeadspeekDailyBudget;
            item.goal_type = this.LeadspeekGoalType;
            item.goal_value = this.LeadspeekGoalValue;
            item.agency_markup = this.LeadspeekAgencyMarkup;
          }
        })
        // update rows

        this.isLoadingModuleCost = false;
        this.modals.pricesetup = false;

        this.$notify({ type: 'success', message: 'Data has been updated successfully', icon: 'tim-icons icon-bell-55' });
        this.GetClientList(this.currSortBy,this.currOrderBy,this.searchQuery);
      })
      .catch(error => {
        console.log(error);

        this.isLoadingModuleCost = false;
        const message = typeof(error.response.data.message) != 'undefined' ? error.response.data.message : 'something went wrong'
        this.$notify({ type: 'danger', message: message, icon: 'fas fa-bug' });
      });
    },
    processChargeCampaignByRemainingDays(costClientByRemainingDays, costAgencyByRemainingDays) {
      this.modals.pricesetup = false;
      this.isLoadingModuleCost = true;
      this.popProcessingTxt = 'Please wait for increase daily budget';
      $('#processingArea').addClass('disabled-area');
      $('#popProcessing').show();

      this.$store.dispatch('processChargeCampaignByRemainingDays', {
        companyID: this.companyID,
        leadspeekID: this.ClientActiveID,
        LeadspeekUserId: this.LeadspeekUserId,
        leadspeekMaxBid: this.LeadspeekMaxBid,
        leadspeekMonthlyBudget: this.LeadspeekMonthlyBudget,
        leadspeekDailyBudget: this.LeadspeekDailyBudget,
        leadspeekGoalValue: this.LeadspeekGoalValue,
        leadspeekGoalType: this.LeadspeekGoalType,
        leadspeekAgencyMarkup: this.LeadspeekAgencyMarkup,
        leadspeekRemainingDays: this.LeadspeekRemainingDays,
        leadspeekTotalSpend: this.LeadspeekTotalSpend,
        costClientByRemainingDays: costClientByRemainingDays,
        costAgencyByRemainingDays: costAgencyByRemainingDays,
      })
      .then(response => {
        $('#processingArea').removeClass('disabled-area');
        $('#popProcessing').hide();

        this.isLoadingModuleCost = false;
        this.GetClientList(this.currSortBy,this.currOrderBy,this.searchQuery);

        // variable for user logs
        let goal_value_format = null;
        if (this.LeadspeekGoalType == 'ctr') {
          goal_value_format = `${this.LeadspeekGoalValue}%`;
        } else if (['cpc', 'cpa'].includes(this.LeadspeekGoalType)) {
          goal_value_format = `$${this.LeadspeekGoalValue}`;
        }

        let descriptionLogs = [
          `campaign id: ${this.ActiveLeadspeekID}`,
          `campaign type: simplifi`,
          `frequency capping impressions: ${this.LeadspeekFrequencyCappingImpressions}`,
          `frequency capping hours: ${this.LeadspeekFrequencyCappingHours}`,
          `max bid: $${this.LeadspeekMaxBid}`,
          `monthly budget: $${this.LeadspeekMonthlyBudget}`,
          `daily budget: $${this.LeadspeekDailyBudget}`,
          `goal type: ${this.LeadspeekGoalType.toUpperCase()}`,
          `goal value: ${goal_value_format}`,
          `Agency Profit Margin: ${this.LeadspeekAgencyMarkup}%`
        ].join(" | ");
        // variable for user logs

        if (typeof (response.result) != 'undefined' && response.result == 'failed') {
          // log action
          this.$store.dispatch('onSaveUserLogs', {
            desc: descriptionLogs,
            action: 'Increase Daily Budget From Financial Settings Failed',
            target_id: row.user_id,
          })
          // log action

          // notify
          return this.$notify({
            type: 'danger',
            message: response.msg,
            icon: 'fas fa-bug'
          }); 
          // notify
        } else if (typeof (response.result) !== 'undefined' && response.result === 'failedPayment') {
          // log action
          this.$store.dispatch('onSaveUserLogs', {
            desc: descriptionLogs,
            action: "Increase Daily Budget From Financial Settings Failed Payment",
            target_id: row.user_id,
          })
          // log action

          // notify
          return this.$notify({
            type: 'danger',
            message: response.msg,
            icon: 'fas fa-bug'
          }); 
          // notify
        }

        // log action
        this.$store.dispatch('onSaveUserLogs', {
          desc: descriptionLogs,
          action: "Increase Daily Budget From Financial Settings",
          target_id: this.LeadspeekUserId,
        })
        // log action

        this.$notify({
          type: 'success',
          message: 'Daily budget increased campaign successfully.',
          icon: 'tim-icons icon-bell-55'
        });
      })
      .catch(error => {
        this.isLoadingModuleCost = false;
        $('#processingArea').removeClass('disabled-area');
        $('#popProcessing').hide();

        this.$notify({
          type: 'primary',
          message: `sorry this campaign cannot be change budget campaign, please contact your administrator with campaign ID : #${this.ActiveLeadspeekID} (1)`,
          icon: 'fas fa-bug'
        });
      });
    },
    formatPrice(value) {
      const num = this.parseSimplifiPrice(value);
      if (Number.isNaN(num)) {
        return "0";
      }
      const val = num.toFixed(2);
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    sanitizeSimplifiPrice(value) {
      if (value === null || value === undefined) {
        return "";
      }
      let cleaned = String(value).replace(/[^0-9.]/g, "");
      const dotIndex = cleaned.indexOf(".");
      if (dotIndex === -1) {
        return cleaned.slice(0, 12);
      }
      const intPart = cleaned.slice(0, dotIndex).slice(0, 12);
      const decPart = cleaned
        .slice(dotIndex + 1)
        .replace(/\./g, "")
        .slice(0, 2);
      const result = decPart.length ? `${intPart}.${decPart}` : `${intPart}.`;
      return result.slice(0, 20);
    },
    formatSimplifiPrice(value) {
      const sanitized = this.sanitizeSimplifiPrice(value);
      if (!sanitized || sanitized === "." || !/^[0-9]*(\.[0-9]*)?$/.test(sanitized)) {
        return "0";
      }
      return formatCurrencyUSD(sanitized);
    },
    parseSimplifiPrice(value) {
      const sanitized = this.sanitizeSimplifiPrice(value);
      if (!sanitized || sanitized === "." || !/^[0-9]*(\.[0-9]*)?$/.test(sanitized)) {
        return NaN;
      }
      const num = Number(sanitized);
      return Number.isFinite(num) ? num : NaN;
    },
    onSimplifiPriceInput(scope, type, value) {
      const sanitized = this.sanitizeSimplifiPrice(value);
      if (scope === "addCampaign" && type === "maxBid") {
        this.campaign.maxBid = sanitized;
      } else if (scope === "financialCampaign" && type === "maxBid") {
        this.LeadspeekMaxBid = sanitized;
      }
    },
    formatPercentage(value) {
      if (value === null || value === undefined) return '-';
      return parseFloat(value).toFixed(2) + ' %';
    },
    handlePriceSet(index, row) {
      const campaignId = row.id; 
      const leadspeekId = row.leadspeek_api_id;
      this.prevCampaignFinancial = {
        LeadspeekMaxBid: row.max_bid,
        LeadspeekMonthlyBudget: row.monthly_budget,
        LeadspeekDailyBudget: row.daily_budget,
        LeadspeekGoalValue: row.goal_value,
        LeadspeekGoalType: row.goal_type,
        LeadspeekAgencyMarkup: row.LeadspeekAgencyMarkup,
        LeadspeekAgencyCoversCost: row.agency_covers_cost === true || row.agency_covers_cost === 1 || row.agency_covers_cost === '1' || row.agency_covers_cost === 'true',
      }

      this.budgetInformationType = 'current_budget';
      this.ClientActiveID = row.id;
      this.LeadspeekUserId = row.user_id;
      this.LeadspeekFrequencyCappingImpressions = row.frequency_capping_impressions;
      this.LeadspeekFrequencyCappingHours = row.frequency_capping_hours;
      this.isLoadingIconFinancials[this.ClientActiveID] = true;
      this.ActiveLeadspeekID = row.leadspeek_api_id;
      this.LeadspeekCompany = row.campaign_name + ' #' + row.leadspeek_api_id;
      this.LeadspeekCompanyName = '(' + row.company_name + ')';
      this.LeadspeekMaxBid = this.formatSimplifiPrice(row.max_bid);
      this.LeadspeekMonthlyBudget = this.formatSimplifiPrice(row.monthly_budget);
      this.LeadspeekDailyBudget = this.formatSimplifiPrice(row.daily_budget);
      this.LeadspeekGoalValue = (row.goal_type === 'ctr') ? row.goal_value : this.formatSimplifiPrice(row.goal_value);
      this.LeadspeekGoalType = (row.goal_type) ? (row.goal_type) : 'none';
      this.LeadspeekAgencyMarkup = row.agency_markup || '0';
      
      // Initialize agency_covers_cost from row data
      // Convert to boolean: handle 0/1, "0"/"1", true/false, null/undefined
      const agencyCoversCostValue = row.agency_covers_cost;
      this.LeadspeekAgencyCoversCost = agencyCoversCostValue === true || agencyCoversCostValue === 1 || agencyCoversCostValue === '1' || agencyCoversCostValue === 'true';
      
      // If agency_covers_cost is true, force agency markup to 0%
      if (this.LeadspeekAgencyCoversCost) {
        this.LeadspeekAgencyMarkup = '0';
      }
      
      this.getRemainingBudget(campaignId, leadspeekId);
    },
    getRemainingBudget(targetCampaignId, targetLeadspeekId) {
      this.$store.dispatch('getRemainingBudgetSimplifi', {
        leadspeek_api_id: targetLeadspeekId,
      })
      .then(response => {
        this.$set(this.isLoadingIconFinancials, targetCampaignId, false);
        if (this.ClientActiveID === targetCampaignId) {
           this.modals.pricesetup = true;
        }

        this.LeadspeekActive = response.leadspeek_active;
        this.LeadspeekDisabled = response.leadspeek_disabled;
        this.LeadspeekActiveUser = response.leadspeek_active_user;
        this.LeadspeekStatus = '';
        if (this.LeadspeekActive == 'F' && this.LeadspeekDisabled == 'T' && this.LeadspeekActiveUser == 'F') {
          this.LeadspeekStatus = 'stopped';
        } else if ((this.LeadspeekActive == 'T' && this.LeadspeekDisabled == 'F' && this.LeadspeekActiveUser == 'T') || (this.LeadspeekActive == 'F' && this.LeadspeekDisabled == 'F' && this.LeadspeekActiveUser == 'T')) {
          this.LeadspeekStatus = 'running';
        }
        
        const prefixWordingChangeBudget1 = this.LeadspeekStatus === 'stopped' ? 'When activating a campaign. ': '';
        this.LeadspeekWordingChangeBudget1 = `* ${prefixWordingChangeBudget1}If the new daily budget is higher, it applies immediately. If lower, it applies in the next cycle. If the same, nothing changes.`;

        this.LeadspekStartDate = response.start_date;
        this.LeadspeekEndDate = response.end_date;
        this.LeadspeekNowDate = response.now_date;
        this.LeadspeekRemainingDays = response.remaining_days; 
        this.budgetHistory = response.budget_history;

        // console.log({
        //   LeadspekStartDate: this.LeadspekStartDate,
        //   LeadspeekEndDate: this.LeadspeekEndDate,
        //   LeadspeekNowDate: this.LeadspeekNowDate,
        //   LeadspeekRemainingDays: this.LeadspeekRemainingDays,
        //   budgetHistory: this.budgetHistory
        // });

        this.LeadspeekIsBudgetPaid = response.is_budget_paid;
        this.LeadspeekTotalDaily = response.total_daily;
        this.LeadspeekTotalSpend = response.total_spend;
        this.LeadspeekTotalRemaining = response.total_remaining;
        this.LeadspeekTotalBudget = response.total_budget;

        this.LeadspeekPreviousDaily = this.LeadspeekTotalDaily; 
        this.LeadspeekPreviousRemaining = this.LeadspeekTotalRemaining; 
        this.LeadspeekPreviousBudget = this.LeadspeekTotalBudget;

        this.profitcalculation();
        this.validateMinimumInput('keyup','financialCampaign','maxBid');
        this.validateMinimumInput('keyup','financialCampaign','dailyBudget');
      })
      .catch(error => {
        this.$set(this.isLoadingIconFinancials, targetCampaignId, false);
        if (this.ClientActiveID === targetCampaignId) {
            this.modals.pricesetup = false;
         }
        this.isLoadingIconFinancials[this.ClientActiveID] = false;
        const message = error.response && error.response.data && error.response.data.message ? error.response.data.message : 'Something Went Wrong';
        this.$notify({ type: 'danger', message: message, icon: 'fas fa-bug' });
      });
    },
    profitcalculation(type = '') {
      if (type == 'add_campaign') {
        this.LeadspeekProfitAgency = (this.campaign.totalBudget * this.agencyMarkup.selected) / 100;
        this.LeadspeekCostAgency = this.campaign.totalBudget - this.LeadspeekProfitAgency;
      } else {
        this.LeadspeekProfitAgency = (this.LeadspeekMonthlyBudget * this.LeadspeekAgencyMarkup) / 100;
        this.LeadspeekCostAgency = this.LeadspeekMonthlyBudget - this.LeadspeekProfitAgency;
  
        if (this.LeadspeekIsBudgetPaid) { // jika budget sudah bayar dan status campaign running
          const LeadspeekMonthlyBudget = this.formatPrice(this.LeadspeekMonthlyBudget);
          const LeadspeekPreviousDaily = this.formatPrice(this.LeadspeekPreviousDaily); 
          const LeadspeekDailyBudget = this.formatPrice(this.LeadspeekDailyBudget); 
  
          if (parseFloat(LeadspeekDailyBudget) > parseFloat(LeadspeekPreviousDaily)) { // calculate sisa budget
            // untuk menghitung total daily, total budget, total remaining ketika daily di edit lebih besar dari previous nya
            this.prevBudgetVisible = true;
            this.LeadspeekTotalDaily = LeadspeekDailyBudget;
            this.LeadspeekTotalBudget = LeadspeekMonthlyBudget;
            this.LeadspeekTotalRemaining = this.formatPrice(LeadspeekMonthlyBudget - this.LeadspeekTotalSpend);
            // untuk menghitung total daily, total budget, total remaining ketika daily di edit lebih besar dari previous nya
          
            // untuk menghitung cost client, cost agency, profit agency by remaining days
            this.LeadspeekTotalBudgetByRemainingDays = this.formatPrice(this.LeadspeekDailyBudget * this.LeadspeekRemainingDays);
            this.LeadspeekCostClientByRemainingDays = this.formatPrice(this.LeadspeekTotalBudgetByRemainingDays - this.LeadspeekPreviousRemaining);
            this.LeadspeekProfitAgencyByRemainingDays = this.formatPrice(this.LeadspeekCostClientByRemainingDays * this.LeadspeekAgencyMarkup / 100);
            this.LeadspeekCostAgencyByRemainingDays = this.formatPrice(this.LeadspeekCostClientByRemainingDays - this.LeadspeekProfitAgencyByRemainingDays);
            // console.log({
            //   'action': 'if',
            //   'LeadspeekTotalBudgetByRemainingDays': this.LeadspeekTotalBudgetByRemainingDays,
            //   'LeadspeekCostClientByRemainingDays': this.LeadspeekCostClientByRemainingDays,
            //   'LeadspeekProfitAgencyByRemainingDays': this.LeadspeekProfitAgencyByRemainingDays,
            //   'LeadspeekCostAgencyByRemainingDays': this.LeadspeekCostAgencyByRemainingDays,
            // });
            // untuk menghitung cost client, cost agency, profit agency by remaining days
          } else { // reset
            // untuk ngebalikin data total daily, total budget, total remaining ke previous
            this.prevBudgetVisible = false;
            this.LeadspeekTotalDaily = LeadspeekDailyBudget;
            this.LeadspeekTotalBudget = LeadspeekMonthlyBudget;
            this.LeadspeekTotalRemaining = this.formatPrice(this.LeadspeekPreviousRemaining);
            // untuk ngebalikin data total daily, total budget, total remaining ke previous
          
            // untuk reset cost" by remaining days
            this.LeadspeekTotalBudgetByRemainingDays = 0;
            this.LeadspeekCostClientByRemainingDays = 0;
            this.LeadspeekProfitAgencyByRemainingDays = 0;
            this.LeadspeekCostAgencyByRemainingDays = 0;
            // console.log({
            //   'action': 'else',
            //   'LeadspeekTotalBudgetByRemainingDays': this.LeadspeekTotalBudgetByRemainingDays,
            //   'LeadspeekCostClientByRemainingDays': this.LeadspeekCostClientByRemainingDays,
            //   'LeadspeekProfitAgencyByRemainingDays': this.LeadspeekProfitAgencyByRemainingDays,
            //   'LeadspeekCostAgencyByRemainingDays': this.LeadspeekCostAgencyByRemainingDays,
            // });
            // untuk reset cost" by remaining days
          }
        }
      }
    },
    async activepauseclient(index,row,action) {
      // console.log({ index, row, action });
      // console.log(action, row.disabled, row.active_user);
      const userData = this.$store.getters.userData;

      if (action == 'play' && row.disabled == 'T' && row.active_user == 'F' && row.customer_card_id == '' && this.$store.getters.userData.manual_bill == 'F') {
        return false;
      }

      if (action == 'play' && row.disabled == 'T' && row.active_user == 'F') {
        // validation audience status
        if (!row.audience_status || row.audience_status == 'progress') {
          return this.$notify({ type: 'danger', message: 'Cannot play campaign while the audience is still processing.' });
        } else if (row.audience_status == 'error') {
          return this.$notify({ type: 'danger', message: 'Cannot play campaign because of an audience error. Try updating the campaign again.' });
        }
        // validation audience status

        // validation ads upload status (only check if ads_upload_status exists, legacy campaigns without this field are allowed)
        if (row.ads_upload_status) {
          if (row.ads_upload_status == 'progress') {
            return this.$notify({ type: 'danger', message: 'Cannot play campaign while the ads are still uploading.' });
          } else if (row.ads_upload_status == 'error') {
            return this.$notify({ type: 'danger', message: 'Cannot play campaign because of an ads upload error. Try updating the campaign again.' });
          }
        }
        // validation ads upload status

        // validation minimum input
        if (Number(row.max_bid) < Number(this.simplifiPriceRule.maxBid.minimum)) {
          return this.$notify({ type: 'danger', message: `max bid minimum $${this.simplifiPriceRule.maxBid.minimum}`, icon: 'fas fa-bug' });
        }
        if (Number(row.daily_budget) < Number(this.simplifiPriceRule.dailyBudget.minimum)) {
          return this.$notify({ type: 'danger', message: `daily budget minimum $${this.simplifiPriceRule.dailyBudget.minimum}`, icon: 'fas fa-bug' });
        }
        // validation minimum input

        // check whether the daily budget becomes larger in the middle of the road
        let isCampaignBudgetIncreased = false;
        let costClientByRemainingDays = 0;
        let profitAgencyByRemainingDays = 0;
        let costAgencyByRemainingDays = 0;

        try {
          this.isLoadingIconActiveCampaigns[row.id] = true;
          const response = await this.$store.dispatch('checkBudgetSimplifiIncrease', {
            campaign_action_source: "from_active_campaign",
            leadspeek_api_id: row.leadspeek_api_id,
          });

          this.isLoadingIconActiveCampaigns[row.id] = false;
          isCampaignBudgetIncreased = response.is_campaign_budget_increased;
          costClientByRemainingDays = response.cost_client_by_remaining_days;
          profitAgencyByRemainingDays = response.profit_agency_by_remaining_days;
          costAgencyByRemainingDays = response.cost_agency_by_remaining_days;
        } catch (error) {
          console.log(error);

          this.isLoadingIconActiveCampaigns[row.id] = false;
          const message = typeof(error.response.data.message) != 'undefined' ? error.response.data.message : 'something went wrong'
          return this.$notify({ type: 'danger', message: message, icon: 'fas fa-bug' });
        }
        // check whether the daily budget becomes larger in the middle of the road

        
        // ul and li
        let btnOkName = 'I agree';
        let defaultText = '<p style="text-align: left; color: initial; margin-left: 16px;">By activating this campaign, you confirm the following settings and costs:<br>';
        
        defaultText += '<ul style="text-align: left; margin-left: 16px;">';
        defaultText += `<li class="alert-li">Frequency capping: ${row.frequency_capping_impressions} impression per ${row.frequency_capping_hours} hours</li>`;
          
        if (row.goal_type== 'none') {
          defaultText += `<li class="alert-li">Goal: None specified</li>`;
        } else if (row.goal_type== 'ctr') {
          defaultText += `<li class="alert-li">Goal: ${row.goal_value}% ${row.goal_type.toUpperCase()}</li>`;
        } else {
          defaultText += `<li class="alert-li">Goal: $${row.goal_value} ${row.goal_type.toUpperCase()}</li>`;
        }
        
        defaultText += `<li class="alert-li">Maximum bid: $${row.max_bid} CPM</li>`;
        defaultText += `<li class="alert-li">Daily budget: $${row.daily_budget}</li>`;

        const monthly_budget = parseFloat(row.monthly_budget);
        const agency_markup = parseFloat(row.agency_markup);
        let client_total_cost = this.formatPrice(monthly_budget);
        let agency_profit_cost = (monthly_budget * agency_markup) / 100; 
        let agency_total_cost = this.formatPrice((monthly_budget - agency_profit_cost)); 
        if (isCampaignBudgetIncreased) {
          client_total_cost = costClientByRemainingDays;
          agency_profit_cost = profitAgencyByRemainingDays;
          agency_total_cost = costAgencyByRemainingDays;
        }

        defaultText += `<li class="alert-li">Client Monthly Cost: $${client_total_cost}</li>`; // client bayar ke agency
        if (['userdownline', 'user'].includes(userData.user_type)) {
          defaultText += `<li class="alert-li">Monthly Ad Budget: $${agency_total_cost}</li>`; // agency bayar ke emm
          defaultText += `<li class="alert-li">Agency Profit: $${agency_profit_cost}</li>`; // profit agency
        }

        defaultText += '</ul>';
        defaultText += 'This campaign will be charged immediately. I understand that the purchase of display ads is non-refundable.'
        // ul and li

        // swal
        let goal_value_format = null;
        if (row.goal_type == 'ctr') {
          goal_value_format = `${row.goal_value}%`;
        } else if (['cpc', 'cpa'].includes(row.goal_type)) {
          goal_value_format = `$${row.goal_value}`;
        }

        let descriptionLogs = [
          `campaign id: ${row.leadspeek_api_id}`,
          `campaign type: ${row.leadspeek_type}`,
          `frequency capping impressions: ${row.frequency_capping_impressions}`,
          `frequency capping hours: ${row.frequency_capping_hours}`,
          `max bid: $${row.max_bid}`,
          `monthly budget: $${row.monthly_budget}`,
          `daily budget: $${row.daily_budget}`,
          `goal type: ${row.goal_type.toUpperCase()}`,
          `goal value: ${goal_value_format}`,
          `Agency Profit Margin: ${row.agency_markup}%`
        ].join(" | ");
        
        swal.fire({
          title: "Are you sure you want to activate this campaign?",
          html: defaultText,
          icon: '',
          showCancelButton: true,
          customClass: {
            confirmButton: 'btn btn-default btn-fill',
            cancelButton: 'btn btn-danger btn-fill'
          },
          confirmButtonText: btnOkName,
          buttonsStyling: false
        })
        .then(({ value }) => {
          if(!value) {
            return;
          }
          
          this.process_activepauseclient(index,row,descriptionLogs,isCampaignBudgetIncreased);
        })
        // swal
      }
    },
    process_activepauseclient(index,row,descriptionLogs,isCampaignBudgetIncreased) {
      const userData = this.$store.getters.userData;
      const _status = (row.disabled == 'F') ? 'T' : 'F';

      this.popProcessingTxt = (row.disabled == 'F') ? 'Please wait, pausing campaign ....' : 'Please wait, activating campaign ....'
      $('#processingArea').addClass('disabled-area');
      $('#popProcessing').show();

      this.$store.dispatch('activepauseLeadsPeek', {
        companyID: this.companyID,
        leadspeekID: row.id,
        status: _status,
        activeuser: row.active_user,
        userID: row.user_id,
        ip_user: userData.ip_login,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        idSys: this.$global.idsys,
      })
      .then(response => {
        $('#processingArea').removeClass('disabled-area');
        $('#popProcessing').hide();

        $('#activePause' + index).removeClass('fas fa-pause orange').addClass('fas fa-pause gray');
        $('#activePlay' + index).removeClass('fas fa-play gray').addClass('fas fa-play green nocursor');

        if (typeof (response.result) != 'undefined' && response.result == 'failed') {
          // log action
          const action = 'Campaign Failed Active';
          this.$store.dispatch('onSaveUserLogs', {
            desc: descriptionLogs,
            action:  action,
            target_id: row.user_id,
          })
          // log action

          // get campaign and notify
          this.GetClientList(this.currSortBy,this.currOrderBy,this.searchQuery);
          this.$notify({
            type: 'danger',
            message: response.msg,
            icon: 'fas fa-bug'
          }); 
          // get campaign and notify

          return;
        } else if (typeof (response.result) !== 'undefined' && response.result === 'failedPayment') { // jika payment failed
          // log action
          this.$store.dispatch('onSaveUserLogs', {
            desc: descriptionLogs,
            action: "Campaign failed payment",
            target_id: row.user_id,
          })
          // log action
          
          // get campaign and notify
          this.GetClientList(this.currSortBy,this.currOrderBy,this.searchQuery);
          this.$notify({
            type: 'danger',
            message: response.msg,
            icon: 'fas fa-bug'
          }); 
          // get campaign and notify
          
          return;
        } else if (typeof(response.result) !== 'undefined' && (response.result == 'failed_campaign_already_active' || response.result == 'failed_campaign_already_paused')) { // jika payment already active or pause
          // log action
          const action = (response.result == 'failed_campaign_already_active') ? 'Campaign Is Already Active' : 'Campaign Is Already Pause';
          this.$store.dispatch('onSaveUserLogs', {
            desc: descriptionLogs,
            action:  action,
            target_id: row.user_id,
          })
          // log action

          // get campaign and notify
          this.GetClientList(this.currSortBy,this.currOrderBy,this.searchQuery);
          this.$notify({
            type: 'danger',
            message: response.msg,
            icon: 'fas fa-bug'
          }); 
          // get campaign and notify
          
          return;
        }

        row.campaign_never_started = 'F';

        if (row.disabled == 'F') { // jika behasil pause campaign
          // code, untuk sementara ini pause tidak ada, nanti kedepan siapa tau ada
        } else { // jika behasil play campaign
          row.active = 'T';
          row.disabled = 'F';
          row.active_user = 'T';

          this.$notify({
            type: 'success',
            message: 'Campaign successfully activated.',
            icon: 'tim-icons icon-bell-55'
          });

          // log action
          this.$store.dispatch('onSaveUserLogs', {
            desc: descriptionLogs,
            action: isCampaignBudgetIncreased ? "Increase Daily Budget When Campaign Active" : "Campaign Activate",
            target_id: row.user_id,
          })
          // log action
        }
      })
      .catch(error => {
        $('#processingArea').removeClass('disabled-area');
        $('#popProcessing').hide();

        this.$notify({
          type: 'primary',
          message: 'sorry this campaign cannot be started, please contact your administrator with campaign ID : #' + row.leadspeek_api_id + ' (1)',
          icon: 'fas fa-bug'
        }); 
      })
    },
    handleDelete(index, row) {
      // console.log({ index, row });

      const userData = this.$store.getters.userData
      const _status = (row.active_user == 'F') ? 'T' : 'F';
      if (_status == 'T') {
        return false;
      }

      //LOG ACTION
      let descriptionLogs = `campaign id: ${row.leadspeek_api_id} | campaign type: ${row.leadspeek_type} | payment term: ${row.paymentterm.toLowerCase()} `
      //LOG ACTION

        this.$global.confirmStopCampaign().then(({ value }) => {
        if (!value) {
          return;
        }

        this.popProcessingTxt = "Please wait, stopping campaign ....";
        $('#processingArea').addClass('disabled-area');
        $('#popProcessing').show();

        this.$store.dispatch('RemoveLeadsPeekClient', {
          companyID: this.companyID,
          leadspeekID: row.id,
          status: _status,
          userID: row.user_id,
        })
        .then(response => {
          // console.log(response);

          $('#processingArea').removeClass('disabled-area');
          $('#popProcessing').hide();
          $('#userstartstop' + index).removeClass('fas fa-stop green').addClass('fas fa-stop gray');

          row.active = 'F';
          row.disabled = 'T';
          row.active_user = 'F';
          // this.GetClientList(this.currSortBy,this.currOrderBy,this.searchQuery);
          
          if (typeof(response.result) != 'undefined' && response.result == 'failed_campaign_already_stopped') {
            this.$notify({
              type: 'danger',
              message: response.message,
              icon: 'tim-icons icon-bell-55'
            }); 

            this.$store.dispatch('onSaveUserLogs', {
              desc: descriptionLogs,
              action: "Campaign Is Already Stopped",
              target_id: row.user_id,
            })
          } else {
            this.$notify({
              type: 'success',
              message: 'Campaign successfully stopped.',
              icon: 'tim-icons icon-bell-55'
            }); 

            // LOG ACTION
            this.$store.dispatch('onSaveUserLogs', {
              desc: descriptionLogs,
              action: "Campaign Stopped",
              target_id: row.user_id,
            })
            // LOG ACTION
          }
        })
        .catch(error => {
          $('#processingArea').removeClass('disabled-area');
          $('#popProcessing').hide();
        })
      })
    },
    startTour() {

    },
    changePage() {
      this.GetClientList(this.currSortBy,this.currOrderBy,this.searchQuery);
    },
    validateGoalValue(value, target) {
      // Remove all non-numeric characters except decimal point
      let cleaned = String(value).replace(/[^0-9.]/g, '');
      
      // Handle multiple decimal points - keep only the first one
      const decimalIndex = cleaned.indexOf('.');
      if (decimalIndex !== -1) {
        cleaned = cleaned.substring(0, decimalIndex + 1) + cleaned.substring(decimalIndex + 1).replace(/\./g, '');
      }
      
      // If empty, set to 0
      if (cleaned === '' || cleaned === '.') {
        cleaned = '0';
      }
      
      // Convert to number and ensure it's >= 0
      const numValue = parseFloat(cleaned) || 0;
      let finalValue = Math.max(0, numValue);
      
      // Get current goal type based on target
      let currentGoalType = 'none';
      if (target === 'create') {
        currentGoalType = this.campaignGoal.goal || 'none';
      } else if (target === 'edit') {
        currentGoalType = this.selectedRowData.goal_type || 'none';
      } else if (target === 'financial') {
        currentGoalType = this.LeadspeekGoalType || 'none';
      }
      
      // For CTR, ensure value is <= 1
      if (currentGoalType === 'ctr') {
        finalValue = Math.min(1, finalValue);
      } else if (currentGoalType !== 'none') {
        finalValue = this.sanitizeSimplifiPrice(value) || '0';
        if (finalValue === '.') {
          finalValue = '0';
        }
      }
      
      // Update the target based on the context
      if (target === 'create') {
        this.campaignGoal.value = finalValue;
      } else if (target === 'edit') {
        this.selectedRowData.goal_value = finalValue;
      } else if (target === 'financial') {
        this.LeadspeekGoalValue = finalValue;
      }
      
      return finalValue;
    },
    formatGoalValue(target) {
      let currentGoalType = 'none';
      if (target === 'create') {
        currentGoalType = this.campaignGoal.goal || 'none';
        if (currentGoalType !== 'ctr' && currentGoalType !== 'none') {
          this.campaignGoal.value = this.formatSimplifiPrice(this.campaignGoal.value);
        }
      } else if (target === 'edit') {
        currentGoalType = this.selectedRowData.goal_type || 'none';
        if (currentGoalType !== 'ctr' && currentGoalType !== 'none') {
          this.selectedRowData.goal_value = this.formatSimplifiPrice(this.selectedRowData.goal_value);
        }
      } else if (target === 'financial') {
        currentGoalType = this.LeadspeekGoalType || 'none';
        if (currentGoalType !== 'ctr' && currentGoalType !== 'none') {
          this.LeadspeekGoalValue = this.formatSimplifiPrice(this.LeadspeekGoalValue);
        }
      }
    },
    campaignGoalChange(type = '') {
      if (type == 'financial') {
        this.LeadspeekGoalValue = 0;
      } else {
        this.campaignGoal.value = 0;
        
        // Reset CPA Settings to default if goal is changed from CPA to something else
        // This provides better UX: if user changes goal away from CPA, reset CPA settings
        // Handle both create mode (campaignGoal.goal) and edit mode (selectedRowData.goal_type)
        const currentGoal = this.modals.editCampaign ? this.selectedRowData.goal_type : this.campaignGoal.goal;
        
        if (currentGoal !== 'cpa') {
          // Reset CPA settings for create mode
          this.cpaViewThruPercentage = 100;
          this.cpaClickThruPercentage = 100;
          
          // Reset CPA settings for edit mode
          if (this.modals.editCampaign) {
            this.editCpaViewThruPercentage = 100;
            this.editCpaClickThruPercentage = 100;
          }
        }
      }
    },
    archiveCampaign(index,row) {
        if (row.disabled == 'T' && row.active_user == 'F') {
            swal.fire({
                title: "Are you sure you want to archive this campaign?",
                text: '',
                icon: '',
                showCancelButton: true,
                customClass: {
                confirmButton: 'btn btn-default btn-fill',
                cancelButton: 'btn btn-danger btn-fill'
                },
                confirmButtonText: 'Archive this campaign',
                buttonsStyling: false
            }).then(result => {
                if (result.value) {

                    if (this.modals.campaignDetails = true) {
                      this.detailsDateFilter.range = 'Last 7 Days'
                      this.detailsDateFilter.customDates = []
                      this.detailedStats = { total_spend: 0, impressions: 0, clicks: 0, actions: 0, cpm: 0, ctr: 0, cpc: 0 }
                      this.modals.campaignDetails = false
                    }

                    this.$store.dispatch('archiveCampaign', {
                        lpuserid: row.id,
                        status: 'T',
                    }).then(response => {
                        if(response.result == 'success') {
                            this.GetClientList(this.currSortBy,this.currOrderBy);
                            this.$notify({
                                type: 'success',
                                message: 'Campaign has been archive.',
                                icon: 'far fa-save'
                            });  
                        }

                        // LOGS ACTION
                        let descriptionLogs = `campaign id: ${row.leadspeek_api_id} | campaign type: ${row.leadspeek_type} `
                        const userData = this.$store.getters.userData
                        // const data = {
                        //     userID: userData.id,
                        //     action: 'Campaign archive',
                        //     desc: descriptionLogs,
                        //     userIP: this.$store.getters.userData.ip_login,
                        // }
                        // const userViewMode = userData.isViewMode ? userData.isViewMode : false;
                        // if (userViewMode) {
                        //     const userRoot = decryptData(localStorage.getItem('userDataOri'));
                        //     data.userID = userRoot.id;
                        // }
                        // this.userLogSaved({ data});
                        this.$store.dispatch('onSaveUserLogs', {
                            desc: descriptionLogs,
                            action: 'Campaign archive',
                            target_id: row.user_id,
                        })
                        // LOGS ACTION
                    },error => {
                        this.$notify({
                            type: 'primary',
                            message: 'Sorry there is something wrong, pleast try again later',
                            icon: 'fas fa-bug'
                        }); 

                    });
                }

            });

        }else{
                this.$notify({
                type: 'primary',
                message: 'Please stop the campaign before archive it.',
                icon: 'fas fa-bug'
            }); 
        }
    },
    async duplicateCampaign(index,row){      
      // validation audience status
      if (!row.audience_status || row.audience_status == 'progress') {
        return this.$notify({ type: 'danger', message: 'Cannot duplicate campaign while the audience is still processing.' });
      }
      
      // Set media type from campaign data (if available)
      // media_type from backend: 1 = display, 2 = video
      // Handle both string and number types
      let mediaType = 'display'; // default
      if (row.media_type !== null && row.media_type !== undefined) {
        const mediaTypeNum = parseInt(row.media_type, 10);
        mediaType = mediaTypeNum === 2 ? 'video' : 'display';
      } else {
        // Fallback: determine from selected media types if media_type not available
        // This is a best-effort approach - if media_type is not set, default to display
        mediaType = 'display';
      }
      
      // validation audience status
      const loadingNotification = Notification({
            message: `
              <div style="position : relative">
              <i style="position : absolute ; left : -19px" class="el-icon-loading"></i>
              <div>
                <p style="color: #000; font-size: 20px; font-weight: bold;">Duplicating Campaign...</p>
                <p style="color: #000; font-size: 14px; margin-top: 10px;">Please wait while we duplicating your campaign.</p>
              </div>
            </div>
            `,
            duration: 0,
            dangerouslyUseHTMLString: true,
      });      
      
      const selectedMedia = await this.fetchMediaDetailsByIds(
        row.leadspeek_api_id,
        row.simplifi_selected_media
      );

      const deviceTypes = row.device_types || []
      const selectedDeviceTypes = deviceTypes
                        .filter(item => item.val && item.name !== 'Connected TV')
                        .map(item => item.name);
      
      // Get device type IDs for Connected TV sub-devices
      // Note: For duplicate, we'll use the device type IDs from the original campaign if available
      // Otherwise, we'll let the backend handle the mapping
      const deviceTypeIds = [];
      deviceTypes.forEach(item => {
        if (item.val && item.id) {
          deviceTypeIds.push(item.id);
        }
      });
      
      // If Connected TV main is selected, add it to names
      const connectedTVMain = deviceTypes.find(item => item.name === 'Connected TV');
      if (connectedTVMain && connectedTVMain.val) {
        selectedDeviceTypes.push('Connected TV');
      }

      // Fetch geo fences from original campaign to duplicate them
      let geoFencesToDuplicate = [];
      let geoFenceRecencyIdToDuplicate = null;
      let useGeoFenceToDuplicate = false;
      
      try {
        const geoFencesResponse = await this.SimplifiGetGeoFences(row.leadspeek_api_id);
        if (geoFencesResponse.result === 'success' && 
            geoFencesResponse.data && 
            geoFencesResponse.data.geo_fences && 
            geoFencesResponse.data.geo_fences.length > 0) {
          // Campaign has geo fences - prepare them for duplication
          useGeoFenceToDuplicate = true;
          geoFencesToDuplicate = geoFencesResponse.data.geo_fences.map(fence => ({
            name: fence.name,
            geo_fence_type_name: fence.geo_fence_type_name || 'Target',
            bid_area: fence.bid_area
            // Note: We don't include 'id' because new fences will be created
          }));
          
          // Extract recency_id from first fence (if available)
          if (geoFencesResponse.data.geo_fences[0] && geoFencesResponse.data.geo_fences[0].recency_id) {
            geoFenceRecencyIdToDuplicate = geoFencesResponse.data.geo_fences[0].recency_id;
          } else {
            // No recency from API, use default: 1 month
            geoFenceRecencyIdToDuplicate = 4;
          }
        }
      } catch (error) {
        console.error('Failed to fetch geo fences for duplication:', error);
        // Continue with duplication even if geo fences fetch fails
        // Campaign will be duplicated without geo fences
      }

      // Fetch site conversion data from original campaign
      let conversionDataToDuplicate = {
        enable_conversion: false,
        conversion_types: [],
        conversion_type: 'site'
      };
      
      try {
        if (row.conversion_enabled && row.conversion_type_ids && row.conversion_type_ids.length > 0) {
          // Load conversion types to get full conversion data
          const conversionSegmentsResponse = await this.$store.dispatch('getCampaignConversionSegments', row.leadspeek_api_id);
          if (conversionSegmentsResponse && conversionSegmentsResponse.site_conversion) {
            const siteConversion = conversionSegmentsResponse.site_conversion;
            conversionDataToDuplicate = {
              enable_conversion: true,
              conversion_types: siteConversion.conversion_types || row.conversion_type_ids,
              conversion_type: 'site'
            };
          } else {
            // Fallback: use conversion_type_ids from row
            conversionDataToDuplicate = {
              enable_conversion: true,
              conversion_types: row.conversion_type_ids,
              conversion_type: 'site'
            };
          }
        }
      } catch (error) {
        console.error('Failed to fetch site conversion data for duplication:', error);
        // Continue with duplication even if conversion fetch fails
      }

      // Fetch geo conversion data from original campaign
      let geoConversionDataToDuplicate = {
        enable_conversion: false,
        geo_fences: []
      };
      
      try {
        if (row.geo_conversion_enabled && row.geo_conversion_fence_ids && row.geo_conversion_fence_ids.length > 0) {
          // Fetch geo conversion fences from API
          const geoConversionFencesResponse = await this.SimplifiGetGeoFences(row.leadspeek_api_id);
          if (geoConversionFencesResponse.result === 'success' && 
              geoConversionFencesResponse.data && 
              geoConversionFencesResponse.data.geo_fences) {
            // Filter only conversion fences (geo_fence_type_name === 'Conversion')
            const conversionFences = geoConversionFencesResponse.data.geo_fences
              .filter(fence => fence.geo_fence_type_name === 'Conversion')
              .map(fence => ({
                name: fence.name,
                geo_fence_type_name: fence.geo_fence_type_name,
                bid_area: fence.bid_area
              }));
            
            if (conversionFences.length > 0) {
              geoConversionDataToDuplicate = {
                enable_conversion: true,
                geo_fences: conversionFences
              };
            }
          }
        }
      } catch (error) {
        console.error('Failed to fetch geo conversion data for duplication:', error);
        // Continue with duplication even if geo conversion fetch fails
      }

      // Prepare CPA and Attribution settings from row data
      let cpaViewThruPercentageToDuplicate = null;
      let cpaClickThruPercentageToDuplicate = null;
      let viewAttributionWindowToDuplicate = 30; // Default
      let clickAttributionWindowToDuplicate = 30; // Default
      
      if (row.goal_type === 'cpa') {
        // Convert decimal to percentage for CPA settings
        if (row.cpa_view_thru_per !== null && row.cpa_view_thru_per !== undefined) {
          cpaViewThruPercentageToDuplicate = parseFloat(row.cpa_view_thru_per) * 100;
        } else {
          cpaViewThruPercentageToDuplicate = 100; // Default
        }
        
        if (row.cpa_click_thru_per !== null && row.cpa_click_thru_per !== undefined) {
          cpaClickThruPercentageToDuplicate = parseFloat(row.cpa_click_thru_per) * 100;
        } else {
          cpaClickThruPercentageToDuplicate = 100; // Default
        }
      }
      
      // Load Attribution Settings from row
      if (row.view_attribution_window !== null && row.view_attribution_window !== undefined) {
        viewAttributionWindowToDuplicate = parseInt(row.view_attribution_window, 10);
      }
      
      if (row.click_attribution_window !== null && row.click_attribution_window !== undefined) {
        clickAttributionWindowToDuplicate = parseInt(row.click_attribution_window, 10);
      }

      // Prepare agency_covers_cost from row data
      // Convert to boolean: handle 0/1, "0"/"1", true/false, null/undefined
      const agencyCoversCostToDuplicate = row.agency_covers_cost === true || row.agency_covers_cost === 1 || row.agency_covers_cost === '1' || row.agency_covers_cost === 'true';
      
      // If agency_covers_cost is true, force agency markup to 0%
      let agencyMarkupToDuplicate = row.agency_markup || 0;
      if (agencyCoversCostToDuplicate) {
        agencyMarkupToDuplicate = 0;
      }

      await this.$store.dispatch('SimplifiCreateCampaign', {
        companyID: row.company_parent,
        userID: row.user_id,
        companyName: row.company_name,
        campaignName: 'Copy of ' + row.campaign_name,
        frequencyCappingImpressions: row.frequency_capping_impressions,
        frequencyCappingHour: row.frequency_capping_hours,
        maxBid: row.max_bid,
        monthlyBudget: row.monthly_budget,
        dailyBudget: row.daily_budget,
        goalType: row.goal_type,
        goalValue: row.goal_value,
        agencyMarkup: agencyMarkupToDuplicate,
        agencyCoversCost: agencyCoversCostToDuplicate,
        selectedCampaignAudience: row.simplifi_selected_campaign,
        selectedAudience: row.simplifi_selected_audience,
        selectedMediaList: selectedMedia,
        mediaType: mediaType,
        destinationUrl: row.destination_url,
        deviceTypes: selectedDeviceTypes,
        device_type_ids: deviceTypeIds.length > 0 ? deviceTypeIds : undefined,
        timezone: this.$global.clientTimezone,
        idSys: this.$global.idsys,
        useGeoFence: useGeoFenceToDuplicate,
        geoFences: geoFencesToDuplicate,
        geoFenceRecencyId: geoFenceRecencyIdToDuplicate,
        geoTargetingAgreement: true,
        cpaViewThruPercentage: cpaViewThruPercentageToDuplicate,
        cpaClickThruPercentage: cpaClickThruPercentageToDuplicate,
        viewAttributionWindow: viewAttributionWindowToDuplicate,
        clickAttributionWindow: clickAttributionWindowToDuplicate,
        conversion_data: conversionDataToDuplicate,
        geo_conversion_data: geoConversionDataToDuplicate
      })  
      .then(response => {
          loadingNotification.close()
          this.$notify({
              type: 'success',
              message: 'Campaign has been duplicated successfully',
              icon: 'far fa-save'
          });
          
          this.clearCampaignForm();
          this.GetClientList(this.currSortBy,this.currOrderBy);
      })
      .catch(error => {
          if (error && error.status === 422 && error.errors) {
              loadingNotification.close()
              Object.entries(error.errors).forEach(([field, messages]) => {
                  messages.forEach(message => {
                      this.$notify({
                          type: 'danger',
                          message: message || "Server might be busy please try again later.",
                          icon: 'fas fa-save',
                      });
                  });
              });
          } else {
              loadingNotification.close()
              this.$notify({
                  type: 'danger',
                  message: (error.message) 
                            || error.message 
                            || "Something's wrong, please try again later.",
                  icon: 'fas fa-bug',
              });
          }
      });
    },
    async ProcessAddEditClient(updatedData,action = '') {
      if (updatedData == '') { // Add Campaign
        // jika tidak ada action khusus
        if (action == '') {
          // validation
          if (Number(this.campaign.maxBid) < Number(this.simplifiPriceRule.maxBid.minimum)) {
            return this.$notify({ type: 'danger', message: `Max Bid Minimum $${this.simplifiPriceRule.maxBid.minimum}`, icon: 'fas fa-bug' })
          }
          if (Number(this.campaign.dailyBudget) < Number(this.simplifiPriceRule.dailyBudget.minimum)) {
            return this.$notify({ type: 'danger', message: `Daily Budget Minimum $${this.simplifiPriceRule.dailyBudget.minimum}`, icon: 'fas fa-bug' })
          }
          // Geo Targeting Agreement validation
          if (!this.geoTargetingAgreement) {
            return this.$notify({ 
              type: 'danger', 
              message: 'You must acknowledge that Geo Targeting mode cannot be changed after the campaign starts.', 
              icon: 'fas fa-exclamation-triangle',
              duration: 5000
            })
          }
          // CPA Settings validation: CPA settings can only be filled if campaign goal is CPA
          if (this.campaignGoal.goal !== 'cpa' && (this.cpaViewThruPercentage !== 100 || this.cpaClickThruPercentage !== 100)) {
            return this.$notify({ 
              type: 'danger', 
              message: 'CPA Settings can only be configured when Campaign Goal is set to CPA.', 
              icon: 'fas fa-exclamation-triangle',
              duration: 5000
            })
          }
          // Site Conversion validation: at least one selected campaign must have leadspeek_type = 'local'
          if (this.enableSiteConversion && !this.hasLocalCampaignInSelected) {
            if (!this.isLocalModuleActive) {
              // Local product module is disabled for this user — the Site
              // Conversion UI is hidden via v-if, so any lingering enabled
              // state is stale. Silently normalize and proceed with save.
              this.enableSiteConversion = false;
              this.selectedConversionTypes = [];
            } else {
              const localModuleName = this.localModuleName;
              return this.$notify({
                type: 'danger',
                message: `Site Conversion requires at least one campaign with type "${localModuleName}" to be selected from "Select Audience from Existing Campaigns".`,
                icon: 'fas fa-exclamation-triangle',
                duration: 5000
              })
            }
          }
          // validation

          $('#processingArea').addClass('disabled-area');
          $('#popProcessing').show();
          
          $('#btnSave' + updatedData).attr('disabled',true)
          $('#btnSave' + updatedData).html('Processing <i class="fas fa-spinner fa-spin ml-1"></i>');          
          
          $('#btnPrevious' + updatedData).attr('disabled',true)
          $('#btnCancel' + updatedData).attr('disabled',true)
        } else if (action == 'validation_request') {
          $('#btnNext' + updatedData).attr('disabled',true);
          $('#btnNext' + updatedData).html('Processing <i class="fas fa-spinner fa-spin ml-1"></i>');
        }
        // jika tidak ada action khusus

        // Get device type IDs (backend will automatically fetch all Connected TV sub-devices if Connected TV is selected)
        const deviceTypeIds = this.getSelectedDeviceTypeIds();
        
        // For backward compatibility, also send device type names
        const deviceTypes = this.deviceTypes
                                .filter(item => item.val)
                                .map(item => item.name);

        // UX Improvement: Ensure geoFences is updated from draftFences before save
        // This is important because user might create polygon but didn't click "Save" in form
        // Solution: Auto-sync draftFences to geoFences before save campaign
        if (this.$refs.geoFenceMap) {
          try {
            const draftFences = this.$refs.geoFenceMap.getDraftFences();
            if (draftFences && draftFences.length > 0) {
              // If there are draftFences, ensure geoFences is updated
              this.geoFences = JSON.parse(JSON.stringify(draftFences)); // Deep copy
              // Automatically enable useGeoFence if not already active
              if (!this.useGeoFence) {
                this.useGeoFence = true;
              }
            }
          } catch (error) {
            console.error('Error syncing draftFences:', error);
          }
        }

        // UX Improvement: Ensure geo fence data is always sent if useGeoFence = true
        // This ensures that every change on map is automatically saved
        // If useGeoFence = true but geoFences is empty, ensure it's still sent (for backend validation)
        if (this.useGeoFence && (!this.geoFences || this.geoFences.length === 0)) {
          console.warn('Warning: useGeoFence is true but geoFences is empty!');
        }

        // UX Improvement: Ensure geoConversionFences is updated from draftFences before save
        // This is important because user might create polygon but didn't click "Save" in form
        // Solution: Auto-sync draftFences to geoConversionFences before save campaign
        if (this.$refs.geoConversionMap) {
          try {
            const draftFences = this.$refs.geoConversionMap.getDraftFences();
            if (draftFences && draftFences.length > 0) {
              // If there are draftFences, ensure geoConversionFences is updated
              this.geoConversionFences = JSON.parse(JSON.stringify(draftFences)); // Deep copy
              // Automatically enable enableGeoConversion if not already active
              if (!this.enableGeoConversion) {
                this.enableGeoConversion = true;
              }
            }
          } catch (error) {
            console.error('Error syncing geo conversion draftFences:', error);
          }
        }
        
        await this.$store.dispatch('SimplifiCreateCampaign', {
          companyID: this.companyID,
          userID: this.ClientUserID,
          companyName: this.ClientCompanyName,
          campaignName: this.ClientCampaignName,
          frequencyCappingImpressions: this.frequencyCapping.impressions,
          frequencyCappingHour: this.frequencyCapping.hours,
          maxBid: this.campaign.maxBid,
          monthlyBudget: this.campaign.totalBudget,
          dailyBudget: this.campaign.dailyBudget,
          goalType: this.campaignGoal.goal,
          goalValue: this.campaignGoal.value,
          agencyMarkup: this.agencyMarkup.selected,
          agencyCoversCost: this.agencyMarkup.coversCost,
          selectedCampaignAudience: this.SelectedCampaignsAudience,
          selectedAudience: this.selectedAudience,
          selectedMediaList: this.selectedAddMediaList,
          mediaType: this.selectedMediaType,
          destinationUrl: this.campaign.destinationURL,
          deviceTypes: deviceTypes,
          device_type_ids: deviceTypeIds,
          timezone: this.$global.clientTimezone,
          idSys: this.$global.idsys,
          action: action,
          cpaViewThruPercentage: this.campaignGoal.goal === 'cpa' ? this.cpaViewThruPercentage : null,
          cpaClickThruPercentage: this.campaignGoal.goal === 'cpa' ? this.cpaClickThruPercentage : null,
          viewAttributionWindow: this.viewAttributionWindow,
          clickAttributionWindow: this.clickAttributionWindow,
          useGeoFence: this.useGeoFence,
          geoFences: this.geoFences,
          geoFenceRecencyId: this.geoFenceRecencyId,
          geoTargetingAgreement: this.geoTargetingAgreement,
          conversion_data: {
            enable_conversion: this.enableSiteConversion,
            conversion_types: this.selectedConversionTypes,
            conversion_type: 'site'
          },
          geo_conversion_data: {
            enable_conversion: this.enableGeoConversion,
            geo_fences: this.geoConversionFences
          },
        })  
        .then(response => {
          // console.log(response);
          if (action == '') { // jika tidak action khusus
            this.modals.addEditCampaign = false;
            $('#processingArea').removeClass('disabled-area');
            $('#popProcessing').hide();

            $('#btnSave' + updatedData).attr('disabled',false);
            $('#btnSave' + updatedData).html('Save'); 

            $('#btnPrevious' + updatedData).attr('disabled',false)
            $('#btnCancel' + updatedData).attr('disabled',false)

            this.$notify({
              type: 'success',
              message: 'Data has been added successfully',
              icon: 'far fa-save'
            });
                        
            this.clearCampaignForm();
            this.GetClientList(this.currSortBy,this.currOrderBy);
          } else if (action == 'validation_request') { // jika hanya untuk validasi request
            if (this.stepCreateCampaignActive < 2) {
              this.stepCreateCampaignActive++;
              this.addClassModalOpenInBody();
            }

            $('#btnNext' + updatedData).attr('disabled',false);
            $('#btnNext' + updatedData).html('Next'); 
          }
      })
        .catch(error => {
          // console.error(error)

          if (action == '') { // jika tidak action khusus
            // this.modals.addEditCampaign = false;
            $('#processingArea').removeClass('disabled-area');
            $('#popProcessing').hide();

            $('#btnSave' + updatedData).attr('disabled',false);
            $('#btnSave' + updatedData).html('Save'); 

            $('#btnPrevious' + updatedData).attr('disabled',false)
            $('#btnCancel' + updatedData).attr('disabled',false)
          } else if (action == 'validation_request') {
            $('#btnNext' + updatedData).attr('disabled',false);
            $('#btnNext' + updatedData).html('Next');
          }

          if (error && error.status === 422 && error.errors) {
              Object.entries(error.errors).forEach(([field, messages]) => {
                  messages.forEach(message => {
                    setTimeout(() => {
                      Notification({ 
                        message: `
                          <p style="display: flex; align-items: center; color: #000; font-size: 14px; font-weight: bold;">
                            <i class="el-notification__icon el-icon-error" style="margin-right: 10px;"></i> 
                            <span style="font-size: 16px; font-family: 'Poppins', sans-serif;">Error</span>
                          </p>
                          <p style="color: #000; font-size: 14px; margin-top: 10px; font-family: 'Poppins', sans-serif;">
                            ${message || 'Server might be busy please try again later.'}
                          </p>
                        `,
                        duration: 5000,
                        dangerouslyUseHTMLString: true,
                       })
                    },1)
                  });
              });
          } else {
              this.$notify({
                type: 'danger',
                message: (error.message) || error.message || "Something's wrong, please try again later.",
                icon: 'fas fa-bug',
              });
          }
        });
      } else { // Update Campaign
        // Site Conversion validation: at least one selected campaign must have leadspeek_type = 'local'
        if (this.editEnableSiteConversion && !this.hasLocalCampaignInSelected) {
          if (!this.isLocalModuleActive) {
            // Local product module is disabled for this user — the Site
            // Conversion UI is hidden via v-if, so any lingering enabled
            // state is stale. Silently normalize and proceed with save.
            this.editEnableSiteConversion = false;
            this.editSelectedConversionTypes = [];
          } else {
            const localModuleName = this.localModuleName;
            this.$notify({
              type: 'danger',
              message: `Site Conversion requires at least one campaign with type "${localModuleName}" to be selected from "Select Audience from Existing Campaigns".`,
              icon: 'fas fa-exclamation-triangle',
              duration: 5000
            });
            return;
          }
        }

        if (!this.validateEditAudienceBeforeSave(updatedData)) {
          return;
        }
        
        $('#processingArea').addClass('disabled-area');
        $('#popProcessing').show();

        // $('#btnSave' + updatedData.id).attr('disabled',true);
        // $('#btnSave' + updatedData.id).html('Processing...');
        this.isProcessingEdit = true;

        const campaignKey = [
          'campaign_name',
          'simplifi_selected_campaign',
          'agency_markup',
          'agency_covers_cost',
          'simplifi_selected_audience',
          'simplifi_selected_media',
          'goal_value',
          'goal_type',
          'daily_budget',
          'monthly_budget',
          'max_bid',
          'frequency_capping_hours',
          'frequency_capping_impressions',
          'media_type',
          'device_types',
          'destination_url'
        ];

        const changes = this.getChangedFields(updatedData, this.selectedRowDataOriginal, campaignKey);

        // Simpli.fi requires both impressions and hours when updating frequency capping
        if (
          changes.frequencyCappingHours !== undefined ||
          changes.frequencyCappingImpressions !== undefined
        ) {
          const impressions = Number(updatedData.frequency_capping_impressions);
          const hours = Number(updatedData.frequency_capping_hours);
          if (!impressions || impressions < 1 || impressions > 32767) {
            this.isProcessingEdit = false;
            $('#processingArea').removeClass('disabled-area');
            $('#popProcessing').hide();
            $('#btnSave' + updatedData.id).attr('disabled', false).html('Save');
            return this.$notify({
              type: 'danger',
              message: 'Frequency capping impressions must be between 1 and 32,767.',
              icon: 'fas fa-exclamation-triangle'
            });
          }
          if (!hours || hours < 1 || hours > 24) {
            this.isProcessingEdit = false;
            $('#processingArea').removeClass('disabled-area');
            $('#popProcessing').hide();
            $('#btnSave' + updatedData.id).attr('disabled', false).html('Save');
            return this.$notify({
              type: 'danger',
              message: 'Frequency capping hours must be between 1 and 24.',
              icon: 'fas fa-exclamation-triangle'
            });
          }
          changes.frequencyCappingImpressions = updatedData.frequency_capping_impressions;
          changes.frequencyCappingHours = updatedData.frequency_capping_hours;
        }

        if (changes && changes.campaignName && changes.campaignName.length > 180) {
            this.isProcessingEdit = false;
            $('#processingArea').removeClass('disabled-area');
            $('#popProcessing').hide();

            // Reset tombol biar bisa diklik lagi
            $('#btnSave' + updatedData.id).attr('disabled', false).html('Save');

            return this.$notify({
                type: 'danger',
                message: `Campaign name is too long (Maximum 180 characters). Current length: ${changes.campaignName.length} characters.`,
                icon: 'fas fa-exclamation-triangle'
            }); 
        }
        
        if (Object.keys(changes).length === 0) {
          this.$notify({
            type: 'info',
            message: 'No changes detected',
            icon: 'fas fa-info-circle'
          });

          $('#processingArea').removeClass('disabled-area');
          $('#popProcessing').hide();
          $('#btnSave' + updatedData.id).attr('disabled', false).html('Save');
          return;
        }

        if (changes.deviceTypes) {
          // Store original deviceTypes array before converting
          const originalDeviceTypes = changes.deviceTypes;
          
          // Get device type names (for backward compatibility)
          const deviceTypeNames = originalDeviceTypes.filter(item => item.val && item.name !== 'Connected TV').map(item => item.name);
          const connectedTVMain = originalDeviceTypes.find(item => item.name === 'Connected TV');
          if (connectedTVMain && connectedTVMain.val) {
            deviceTypeNames.push('Connected TV');
          }
          changes.deviceTypes = deviceTypeNames;
          
          // Get device type IDs (including Connected TV sub-devices)
          const deviceTypeIds = [];
          // Get device type IDs (backend will automatically fetch all Connected TV sub-devices if Connected TV is selected)
          originalDeviceTypes.forEach(item => {
            if (item.val && item.id) {
              deviceTypeIds.push(item.id);
            }
          });
          
          if (deviceTypeIds.length > 0) {
            changes.device_type_ids = deviceTypeIds;
          }
        }
        
        // UX Improvement: Ensure editGeoFences is updated from fences on map before check changes
        // This is important because user might create new polygon but hasn't synced to editGeoFences yet
        if (this.editUseGeoFence && this.$refs.editGeoFenceMap) {
          try {
            const fences = this.$refs.editGeoFenceMap.getDraftFences();
            // Always sync fences from map, even if empty (to detect when all fences are deleted)
            if (fences !== undefined && fences !== null) {
              this.editGeoFences = JSON.parse(JSON.stringify(fences || [])); // Deep copy, handle empty array
            }
          } catch (error) {
            console.error('Error syncing fences to editGeoFences:', error);
          }
        }

        // UX Improvement: Ensure editGeoConversionFences is updated from fences on map before check changes
        // This is important because user might create new polygon but hasn't synced to editGeoConversionFences yet
        if (this.editEnableGeoConversion && this.$refs.editGeoConversionMap) {
          try {
            const fences = this.$refs.editGeoConversionMap.getDraftFences();
            // Always sync fences from map, even if empty (to detect when all fences are deleted)
            if (fences !== undefined && fences !== null) {
              this.editGeoConversionFences = JSON.parse(JSON.stringify(fences || [])); // Deep copy, handle empty array
            }
          } catch (error) {
            console.error('Error syncing fences to editGeoConversionFences:', error);
          }
        }
        
        // Check if geo fences have changed
        const geoFencesChanged = this.hasGeoFencesChanged();
        
        // Additional debug: Compare fences content
        if (this.editGeoFences && this.editGeoFencesOriginal) {
          const currentCoords = this.editGeoFences.map(f => JSON.stringify(f.bid_area.coordinates || []));
          const originalCoords = this.editGeoFencesOriginal.map(f => JSON.stringify(f.bid_area.coordinates || []));
        }
        
        // UX Improvement: Always send geo fence data if editUseGeoFence = true
        // This ensures backend validation can check for minimum 1 fence requirement
        if (this.editUseGeoFence) {
          // Always send useGeoFence and geoFences if toggle is ON (even if empty, for backend validation)
          const fencesToSend = (this.editGeoFences && this.editGeoFences.length > 0) 
            ? JSON.parse(JSON.stringify(this.editGeoFences)) // Deep copy
            : []; // Send empty array if no fences (backend will validate and reject)
          
          changes.useGeoFence = true;
          changes.geoFences = fencesToSend;
          changes.geoFenceRecencyId = this.editGeoFenceRecencyId;
        } else if (geoFencesChanged && !this.editUseGeoFence) {
          // If geoFencesChanged and editUseGeoFence = false, means user switched to default
          changes.useGeoFence = false;
          changes.geoFences = [];
          changes.geoFenceRecencyId = null;
        } else if (!geoFencesChanged) {
          console.log('No geo fence changes detected, skipping geo fence data');
        }
        
          this.$store.dispatch('SimplifiUpdateCampaign', {
            campaignId: updatedData.id,
            companyId: updatedData.company_id,
            userId: updatedData.user_id,
            companyName: updatedData.company_name,
            timezone: this.$global.clientTimezone,
            idSys: this.$global.idsys,
            mediaType: this.selectedMediaType,
            conversion_data: {
              enable_conversion: this.editEnableSiteConversion,
              conversion_types: this.editSelectedConversionTypes,
              conversion_type: 'site'
            },
            geo_conversion_data: {
              enable_conversion: this.editEnableGeoConversion,
              geo_fences: this.editGeoConversionFences
            },
            cpaViewThruPercentage: this.selectedRowData.goal_type === 'cpa' ? this.editCpaViewThruPercentage : null,
            cpaClickThruPercentage: this.selectedRowData.goal_type === 'cpa' ? this.editCpaClickThruPercentage : null,
            viewAttributionWindow: this.editViewAttributionWindow,
            clickAttributionWindow: this.editClickAttributionWindow,
            ...changes
          })
          .then(response => {
              // console.log(response);

              this.modals.editCampaign = false;
              this.isProcessingEdit = false;
              $('#processingArea').removeClass('disabled-area');
              $('#popProcessing').hide();

              // $('#btnSave' + updatedData.id).attr('disabled',false);
              // $('#btnSave' + updatedData.id).html('Save'); 

              this.$notify({
                  type: 'success',
                  message: 'Data has been updated successfully',
                  icon: 'far fa-save'
              });
              
              this.clearCampaignForm();
              this.GetClientList(this.currSortBy,this.currOrderBy);
          })
          .catch(error => {
              // console.error(error)

              // this.modals.editCampaign = false;
              this.isProcessingEdit = false;
              $('#processingArea').removeClass('disabled-area');
              $('#popProcessing').hide();

              $('#btnSave' + updatedData.id).attr('disabled',false);
              $('#btnSave' + updatedData.id).html('Save'); 

              if (error && error.status === 422 && error.errors) {
                  Object.entries(error.errors).forEach(([field, messages]) => {
                      messages.forEach(message => {
                          this.$notify({
                              type: 'danger',
                              message: message || "Server might be busy please try again later.",
                              icon: 'fas fa-save',
                          });
                      });
                  });
              } else {
                  this.$notify({
                      type: 'danger',
                      message: (error.message) 
                                || error.message 
                                || "Something's wrong, please try again later.",
                      icon: 'fas fa-bug',
                  });
              }
          });

        $('#processingArea').removeClass('disabled-area');
        $('#popProcessing').hide();

        // $('#btnSave' + updatedData.id).attr('disabled',false);
        // $('#btnSave' + updatedData.id).html('Save'); 

      }
    },
    campaignRowHasAudienceSources(row) {
      if (!row) return false;
      const localIds = Array.isArray(row.simplifi_selected_audience)
        ? row.simplifi_selected_audience
        : (typeof row.simplifi_selected_audience === 'string' && row.simplifi_selected_audience.trim() !== ''
          ? row.simplifi_selected_audience.split(',').map(id => id.trim()).filter(Boolean)
          : []);
      const campaignIds = Array.isArray(row.simplifi_selected_campaign)
        ? row.simplifi_selected_campaign
        : (typeof row.simplifi_selected_campaign === 'string' && row.simplifi_selected_campaign.trim() !== ''
          ? row.simplifi_selected_campaign.split(',').map(id => id.trim()).filter(Boolean)
          : []);
      return localIds.length > 0 || campaignIds.length > 0;
    },
    campaignHasEverStarted(row) {
      const c = row || {};
      const isNeverStarted = c.campaign_never_started === 'T' || c.campaign_never_started == null;
      const isDraft = isNeverStarted
        && c.active_user === 'F'
        && String(c.total_leads || '0') === '0';
      return !isDraft;
    },
    validateEditAudienceBeforeSave(updatedData) {
      const row = updatedData || this.selectedRowData || {};
      if (!this.campaignHasEverStarted(row)) {
        return true;
      }
      const original = this.selectedRowDataOriginal || {};
      if (!this.campaignRowHasAudienceSources(original)) {
        return true;
      }
      const current = updatedData || this.selectedRowData || {};
      if (!this.campaignRowHasAudienceSources(current)) {
        this.$notify({
          type: 'danger',
          message: 'At least one audience or source campaign must remain selected when updating a campaign that already uses audience targeting.',
          icon: 'fas fa-exclamation-triangle',
          duration: 6000,
        });
        return false;
      }
      return true;
    },
    getChangedFields(newData, originalData, keys) {
      const changes = {};

      keys.forEach(key => {
        const newVal = newData[key];
        const oldVal = originalData[key];

        if (key === "simplifi_selected_audience" || key === "simplifi_selected_campaign") {
          changes[this.toCamelCase(key)] = newVal;
        } else if (key === "simplifi_selected_media") {
          changes[this.toCamelCase(key)] = this.selectedEditMediaList.filter(item => this.isValidCampaignMediaItem(item));
        } else if (key === "device_types") {
          if (JSON.stringify(newVal) != JSON.stringify(oldVal)) {
            changes[this.toCamelCase(key)] = newVal;
          }
        } else {
          if (newVal != oldVal) {
            changes[this.toCamelCase(key)] = newVal;
          }
        }
      });

      return changes;
    },
    hasGeoFencesChanged() {
      // Check if useGeoFence status changed
      const originalUseGeoFence = this.editGeoFencesOriginal && this.editGeoFencesOriginal.length > 0;
      const currentUseGeoFence = this.editUseGeoFence && this.editGeoFences && this.editGeoFences.length > 0;
      
      if (currentUseGeoFence !== originalUseGeoFence) {
        return true;
      }
      
      // If not using geo fences, no change
      if (!this.editUseGeoFence) {
        return false;
      }
      
      // Check if recency_id changed
      if (this.editGeoFenceRecencyId !== this.editGeoFenceRecencyIdOriginal) {
        return true;
      }
      
      // Check if fences count changed
      const currentCount = (this.editGeoFences && this.editGeoFences.length) || 0;
      const originalCount = (this.editGeoFencesOriginal && this.editGeoFencesOriginal.length) || 0;
      
      if (currentCount !== originalCount) {
        return true;
      }
      
      // If no fences in both, no change
      if (currentCount === 0 && originalCount === 0) {
        return false;
      }
      
      // Compare fences by their content (not just count)
      // Convert to comparable format for easier comparison
      const normalizeFence = (fence) => {
        return {
          name: fence.name || '',
          type: fence.geo_fence_type_name || 'Target',
          coordinates: JSON.stringify(fence.bid_area.coordinates || [])
        };
      };
      
      const currentFencesNormalized = (this.editGeoFences || []).map(normalizeFence);
      const originalFencesNormalized = (this.editGeoFencesOriginal || []).map(normalizeFence);
      
      // Compare arrays
      if (currentFencesNormalized.length !== originalFencesNormalized.length) {
        // console.log('Fence count changed:', { 
        //   current: currentFencesNormalized.length, 
        //   original: originalFencesNormalized.length 
        // });
        return true;
      }
      
      // Compare each fence
      for (let i = 0; i < currentFencesNormalized.length; i++) {
        const current = currentFencesNormalized[i];
        const original = originalFencesNormalized[i];
        
        if (!original) {
          // console.log('New fence added at index:', i);
          return true; // New fence added
        }
        
        // Compare all properties
        if (current.name !== original.name || 
            current.type !== original.type || 
            current.coordinates !== original.coordinates) {
          return true;
        }
      }
      return false;
    },
    toCamelCase(str) {
      return str.replace(/[-_\s]+(.)?/g, (_, c) => (c ? c.toUpperCase() : ''))
                .replace(/^./, (c) => c.toLowerCase());
    },
    CancelAddEditClient(id){
      if (id == '') {
        this.resetStepCreateCampaign();
        this.modals.addEditCampaign = false
      }else{
        this.modals.editCampaign = false
      }
    },
    onEditCampaignCardClick(campaign, queriedData) {
      if (this.fetchingCampaignData) {
        this.$notify({
          type: 'warning',
          message: 'Please wait until the campaign list has finished loading, then open Edit again.',
          icon: 'fas fa-info-circle',
          duration: 4500,
        });
        return;
      }
      this.handleExpandChange(campaign, queriedData);
    },
    handleExpandChange(row, expandedRows) {
        if (this.fetchingCampaignData) {
          return;
        }
        const tableDataArray = Array.isArray(this.tableData) ? this.tableData : Object.values(this.tableData);
        const rowIndex = tableDataArray.findIndex((item) => item.id === row.id);
        
        if (expandedRows.includes(row)) {
            // Row is expanded
            this.rowClickedEdit(rowIndex,row);
        //    this.updatekeywordcontextualBulkEdit(row)


            //console.log('Expanded:', row.name, 'Index:', rowIndex);
        }
    },
    async rowClickedEdit(index, row) {
      if (!row || !row.user_id) {
        this.$notify({ type: 'danger', message: 'Cannot edit campaign: required data is missing.' });
        return;
      }

      this.selectedRowData = JSON.parse(JSON.stringify(row));
      this.selectedRowDataOriginal = JSON.parse(JSON.stringify(row));
      
      // Initialize agency_covers_cost if not present (for old records)
      if (this.selectedRowData.agency_covers_cost === undefined || this.selectedRowData.agency_covers_cost === null) {
        this.selectedRowData.agency_covers_cost = false;
      }
      if (this.selectedRowDataOriginal.agency_covers_cost === undefined || this.selectedRowDataOriginal.agency_covers_cost === null) {
        this.selectedRowDataOriginal.agency_covers_cost = false;
      }
      
      // If agency_covers_cost is true, force agency markup to 0%
      if (this.selectedRowData.agency_covers_cost) {
        this.selectedRowData.agency_markup = 0;
        this.selectedRowDataOriginal.agency_markup = 0;
      }
      
      // Set LeadspeekAgencyMarkup from selectedRowData for edit form
      this.LeadspeekAgencyMarkup = this.selectedRowData.agency_markup || '0';

      if (!this.selectedRowData.audience_status || this.selectedRowData.audience_status == 'progress') {
        return this.$notify({ type: 'danger', message: 'Cannot edit campaign while the audience is still processing.' });
      }

      // Only check ads_upload_status if it exists (legacy campaigns without this field are allowed)
      if (this.selectedRowData.ads_upload_status && this.selectedRowData.ads_upload_status == 'progress') {
        return this.$notify({ type: 'danger', message: 'Cannot edit campaign while the ads are still uploading.' });
      }

      this.onCompanyChange(this.selectedRowData.user_id);
      // audience
      // await this.fetchUserLocalAudience(this.selectedRowData.user_id);

      // Set media type from campaign data (if available)
      // media_type from backend: 1 = display, 2 = video
      // Handle both string and number types
      if (this.selectedRowData.media_type !== null && this.selectedRowData.media_type !== undefined) {
        const mediaType = parseInt(this.selectedRowData.media_type, 10);
        this.selectedMediaType = mediaType === 2 ? 'video' : 'display';
        // console.log('[rowClickedEdit] Set media type from campaign data:', {
        //   media_type: this.selectedRowData.media_type,
        //   parsed: mediaType,
        //   selectedMediaType: this.selectedMediaType
        // });
      } else {
        // Fallback: determine from selected media types
        this.selectedMediaType = 'display';
        // console.log('[rowClickedEdit] Media type not found, defaulting to display');
      }

      // media
      const mediaDetails = await this.fetchMediaDetailsByIds(
        this.selectedRowData.leadspeek_api_id,
        this.selectedRowData.simplifi_selected_media
      );
      this.selectedEditMediaList = mediaDetails;
      if (
        Array.isArray(this.selectedRowData.simplifi_selected_media) &&
        mediaDetails.length < this.selectedRowData.simplifi_selected_media.length
      ) {
        this.selectedRowData.simplifi_selected_media = mediaDetails.map(item => item.id);
      }
      
      this.modals.editCampaign = true;
      this.$nextTick(() => {
        if (this.$refs.userLocalAudienceEdit) {
          this.calculateInitialEditTotal();
        }
        // Explicit call covers the "reopen same row before modal=false took effect"
        // case where the watcher on modals.editCampaign would not fire.
        this.tryPruneInactiveSelectedCampaigns();
      });

    },    
    tryPruneInactiveSelectedCampaigns() {
      // Auto-prune selected campaign audiences whose product module has been
      // disabled for the signed-in user (source of truth: $global.{client|agency}sidebar,
      // same as DashboardLayout.vue hide/show logic).
      //
      // Idempotent: safe to call multiple times. Only mutates state and notifies
      // when there is actually something to prune.
      if (!this.modals || this.modals.editCampaign !== true) return;

      const campaignList = (this.selectsCompany && this.selectsCompany.campaignList)
        ? this.selectsCompany.campaignList
        : [];
      if (!campaignList || campaignList.length === 0) return;

      const activeModules = this.activeProductModulesByCompany;
      if (!activeModules) return;

      const selectedIds = (this.selectedRowData && Array.isArray(this.selectedRowData.simplifi_selected_campaign))
        ? this.selectedRowData.simplifi_selected_campaign
        : null;
      if (!selectedIds || selectedIds.length === 0) return;

      const typeLabels = (this.$global && this.$global.globalModulNameLink) ? this.$global.globalModulNameLink : {};
      const kept = [];
      const removedTypes = new Set();

      for (const id of selectedIds) {
        const campaign = campaignList.find(c => c && Number(c.id) === Number(id));
        if (!campaign) {
          // Unknown campaign (not in list): keep to avoid silent data loss.
          kept.push(id);
          continue;
        }
        const type = campaign.leadspeek_type ? String(campaign.leadspeek_type) : '';
        if (!type) {
          kept.push(id);
          continue;
        }
        if (type in activeModules && activeModules[type] === false) {
          removedTypes.add(type);
          continue;
        }
        kept.push(id);
      }

      if (kept.length !== selectedIds.length) {
        this.selectedRowData.simplifi_selected_campaign = kept;

        const removedCount = selectedIds.length - kept.length;
        const typeNames = Array.from(removedTypes).map(t => {
          const entry = typeLabels[t];
          return (entry && entry.name) ? entry.name : t;
        });
        const typeText = typeNames.length > 0 ? ` (${typeNames.join(', ')})` : '';
        const audienceWord = removedCount === 1 ? 'audience' : 'audiences';

        // this.$notify({
        //   type: 'warning',
        //   icon: 'fas fa-exclamation-triangle',
        //   message: `${removedCount} ${audienceWord} from disabled product(s)${typeText} has been removed from this campaign. Save the campaign to persist this change.`
        // });
      }

      // Site Conversion depends on having at least one local campaign in the
      // selection. If local module was disabled and the feature is still on,
      // auto-disable it so the modal state stays consistent with the hidden UI
      // and save-time validation does not block the user.
      if (this.editEnableSiteConversion && !this.hasLocalCampaignInSelected) {
        this.editEnableSiteConversion = false;
        this.editSelectedConversionTypes = [];

        const localLabel = this.localModuleName || 'local';
        // this.$notify({
        //   type: 'warning',
        //   icon: 'fas fa-exclamation-triangle',
        //   message: `Site Conversion has been disabled because the "${localLabel}" product is no longer available. Save the campaign to persist this change.`
        // });
      }
    },
    isValidCampaignMediaItem(item) {
      if (!item || item.id == null) return false;
      const name = (item.name || item.media_name || '').trim();
      if (name === 'Deleted Media') return false;
      const url = (item.media || item.url || '').trim();
      return url.length > 0;
    },
    async fetchMediaDetailsByIds(campaignId, mediaIds) {
      if (!campaignId || !mediaIds || mediaIds.length === 0) {
        return [];
      }
      const response = await this.SimplifiGetCampaignMedia({ data: { campaign_id: campaignId } });
      if (response.result !== 'success' || !response.media) {
        return [];
      }
      const allMedia = response.media;
      const normalizedSelectedIds = new Set(mediaIds.map(Number));
      const filteredMedia = allMedia.filter(item => normalizedSelectedIds.has(item.id));
      
      // Ensure ad_file_type_id is set for each media item
      return filteredMedia
        .filter(item => this.isValidCampaignMediaItem(item))
        .map(item => {
        if (!item.ad_file_type_id) {
          item.ad_file_type_id = this.detectAdFileType(item);
        }
        return item;
      });
    },
    onAudienceSelected(selectedRows) {
      if (this.isUpdatingAudience) return;
      if (this.modals.editCampaign) {
        // Edit mode: check 0→1 combined audience transition with geo fence
        const oldEditLocal = this.selectedRowData.simplifi_selected_audience ? this.selectedRowData.simplifi_selected_audience.length : 0;
        const oldEditCampaign = this.selectedRowData.simplifi_selected_campaign ? this.selectedRowData.simplifi_selected_campaign.length : 0;
        const oldEditCombined = oldEditLocal + oldEditCampaign;

        this.selectedRowData.simplifi_selected_audience = selectedRows.map(row => row.id);
        this.totalSelectedAudienceEdit = selectedRows.reduce((sum, item) => sum + item.total, 0);

        const newEditCombined = this.selectedRowData.simplifi_selected_audience.length + oldEditCampaign;
        if (this.editUseGeoFence && oldEditCombined === 0 && newEditCombined > 0) {
          this.showTargetingOverlapWarning();
        }
      } else {
        // Create mode: check 0→1 combined audience transition with geo fence
        const oldLocal = this.selectedAudience.length;
        const oldCampaign = this.SelectedCampaignsAudience.length;
        const oldCombined = oldLocal + oldCampaign;

        this.selectedAudience = selectedRows.map(row => row.id);
        this.totalSelectedAudience = selectedRows.reduce((sum, item) => sum + item.total, 0);

        const newCombined = this.selectedAudience.length + oldCampaign;
        if (this.useGeoFence && oldCombined === 0 && newCombined > 0) {
          this.showTargetingOverlapWarning();
        }
      }
    },
    onMediaListSelectionChanged(selectedRows) {
      if (this.modals.editCampaign) {
        this.selectedRowData.simplifi_selected_media = selectedRows.map(row => row.id);
      }else{
        this.selectedAddMediaList = selectedRows;
      }
    },
    openMediaSelectAdd(){      
      this.mediaSelectDimensionFilter = 'all';
      this.modals.mediaSelect = true;
    },
    openMediaSelectEdit(){
      this.mediaSelectDimensionFilter = 'available';
      this.modals.mediaSelect = true;
    },
    /**
     * Detect ad file type from media URL
     * Returns: 1 (Image), 6 (Video), 9 (HTML5), or null if unknown
     */
    detectAdFileType(mediaItem) {
      const url = mediaItem.media || mediaItem.url || '';
      const lowerUrl = url.toLowerCase();
      
      // Check for video extensions
      if (lowerUrl.match(/\.(mp4|mov|mpeg)$/i)) {
        return 6; // Video
      }
      
      // Check for HTML5 ZIP
      if (lowerUrl.match(/\.zip$/i)) {
        return 9; // HTML5
      }
      
      // Check for image extensions
      if (lowerUrl.match(/\.(jpg|jpeg|png|gif)$/i)) {
        return 1; // Image
      }
      
      // Default to image if unknown (backward compatibility)
      return 1;
    },
    
    /**
     * Get allowed ad file types for a media type
     */
    getAllowedAdFileTypes(mediaType) {
      if (mediaType === 'video') {
        return [6]; // Video only
      }
      return [1, 9]; // Image, HTML5 (for display)
    },
    
    /**
     * Validate media item is allowed for current campaign media type
     */
    validateMediaForCampaign(mediaItem) {
      const adFileTypeId = this.detectAdFileType(mediaItem);
      const allowedTypes = this.getAllowedAdFileTypes(this.selectedMediaType);
      
      if (!allowedTypes.includes(adFileTypeId)) {
        const typeNames = {
          1: 'Image',
          6: 'Video',
          9: 'HTML5'
        };
        const allowedNames = allowedTypes.map(t => typeNames[t] || 'Unknown').join(', ');
        return {
          valid: false,
          message: `${typeNames[adFileTypeId] || 'This file type'} is not allowed for ${this.selectedMediaType} campaigns. Allowed types: ${allowedNames}`
        };
      }
      
      return { valid: true };
    },
    
    /**
     * Handle media type change
     */
    async onMediaTypeChange(newType) {
      // Store old type BEFORE any changes (since we're using :value instead of v-model)
      const oldType = this.selectedMediaType;
      
      // If same type, no need to process
      if (oldType === newType) {
        return;
      }
      
      // Check how many items will be removed
      const allowedTypes = this.getAllowedAdFileTypes(newType);
      let incompatibleItems = [];
      let currentMediaList = [];
      
      if (this.modals.editCampaign) {
        currentMediaList = this.selectedEditMediaList;
        incompatibleItems = this.selectedEditMediaList.filter(item => {
          const adFileTypeId = this.detectAdFileType(item);
          return !allowedTypes.includes(adFileTypeId);
        });
      } else {
        currentMediaList = this.selectedMediaList;
        incompatibleItems = this.selectedMediaList.filter(item => {
          const adFileTypeId = this.detectAdFileType(item);
          return !allowedTypes.includes(adFileTypeId);
        });
      }
      
      // If there are incompatible items, show confirmation dialog
      if (incompatibleItems.length > 0) {
        const fromType = oldType === 'video' ? 'Video' : 'Display';
        const toType = newType === 'video' ? 'Video' : 'Display';
        
        try {
          await MessageBox.confirm(
            `<div style="text-align: left;">
              <p style="margin-bottom: 16px; color: #303133; font-size: 14px; line-height: 1.6;">
                You are changing the campaign media type from <strong style="color: #409EFF;">${fromType}</strong> to <strong style="color: #409EFF;">${toType}</strong>.
              </p>
              <div style="background: #FFF7E6; border-left: 4px solid #E6A23C; padding: 12px; margin-bottom: 16px; border-radius: 4px;">
                <p style="margin: 0 0 8px 0; color: #E6A23C; font-weight: 600; font-size: 13px; display: flex; align-items: center;">
                  <i class="el-icon-warning" style="margin-right: 6px; font-size: 16px;"></i>
                  Incompatible Media Will Be Removed
                </p>
                <p style="margin: 0; color: #606266; font-size: 13px; line-height: 1.5;">
                  <strong>${incompatibleItems.length}</strong> of <strong>${currentMediaList.length}</strong> selected media item(s) are not compatible with ${toType} campaigns and will be removed from your selection.
                </p>
              </div>
              <p style="margin: 0; color: #909399; font-size: 12px; font-style: italic;">
                You can add new compatible media after switching the type.
              </p>
            </div>`,
            'Change Media Type?',
            {
              confirmButtonText: 'Yes, Switch Type',
              cancelButtonText: 'Cancel',
              type: 'warning',
              dangerouslyUseHTMLString: true,
              distinguishCancelAndClose: true
            }
          );
        } catch (error) {
          // User cancelled or closed the dialog - revert to old value
          // Use $nextTick to ensure the revert happens after dialog closes
          this.$nextTick(() => {
            this.selectedMediaType = oldType;
            // Force update to ensure select component reflects the change
            this.$forceUpdate();
          });
          return;
        }
      }
      
      // User confirmed or no incompatible items - update selectedMediaType FIRST
      // This ensures the select shows the new value immediately
      this.selectedMediaType = newType;
      
      // User confirmed or no incompatible items - proceed with filtering
      // Only show loading if there are items to filter (for better UX)
      const hasIncompatibleItems = incompatibleItems.length > 0;
      let loading = null;
      
      if (hasIncompatibleItems) {
        // Add loading state for smooth transition when items will be removed
        // Find the media list container - use refs if available, otherwise fallback to querySelector
        let loadingTarget = document.body;
        
        if (this.modals.editCampaign && this.$refs.editMediaList) {
          loadingTarget = this.$refs.editMediaList.$el || this.$refs.editMediaList;
        } else if (!this.modals.editCampaign && this.$refs.mediaList) {
          loadingTarget = this.$refs.mediaList.$el || this.$refs.mediaList;
        } else {
          // Fallback: find media-list component in the modal
          const modalBody = document.querySelector('.el-dialog__body');
          if (modalBody) {
            const mediaListEl = modalBody.querySelector('.media-list, [class*="media-list"]');
            loadingTarget = mediaListEl || modalBody;
          }
        }
        
        loading = Loading.service({
          target: loadingTarget,
          lock: false,
          text: 'Updating media list...',
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0.7)'
        });
        
        // Small delay for visual feedback
        await new Promise(resolve => setTimeout(resolve, 300));
      }
      
      try {
        // Filter out incompatible media
        if (this.modals.editCampaign) {
          const beforeCount = this.selectedEditMediaList.length;
          this.selectedEditMediaList = this.selectedEditMediaList.filter(item => {
            const adFileTypeId = this.detectAdFileType(item);
            return allowedTypes.includes(adFileTypeId);
          });
          const removedCount = beforeCount - this.selectedEditMediaList.length;
          
          // Update selectedRowData.simplifi_selected_media to match filtered list
          // This ensures the MediaList component stays in sync
          this.selectedRowData.simplifi_selected_media = this.selectedEditMediaList.map(item => item.id);
          
          if (removedCount > 0) {
            this.$notify({
              type: 'success',
              title: 'Media Type Changed',
              message: `Successfully switched to ${newType} campaigns. ${removedCount} incompatible media item(s) removed.`,
              icon: 'el-icon-success',
              duration: 4000
            });
          }
        } else {
          const beforeCount = this.selectedMediaList.length;
          this.selectedMediaList = this.selectedMediaList.filter(item => {
            const adFileTypeId = this.detectAdFileType(item);
            return allowedTypes.includes(adFileTypeId);
          });
          const removedCount = beforeCount - this.selectedMediaList.length;
          
          // Update selectedAddMediaList to match filtered list
          // This ensures both selectedMediaList (display) and selectedAddMediaList (save) stay in sync
          this.selectedAddMediaList = [...this.selectedMediaList];
          
          if (removedCount > 0) {
            this.$notify({
              type: 'success',
              title: 'Media Type Changed',
              message: `Successfully switched to ${newType} campaigns. ${removedCount} incompatible media item(s) removed.`,
              icon: 'el-icon-success',
              duration: 4000
            });
          }
        }
      } finally {
        // Close loading after a brief delay for smooth transition (if it was opened)
        if (loading) {
          setTimeout(() => {
            loading.close();
          }, 200);
        }
      }
    },
    
    async onMediaSelected(mediaArray){
      const validMediaArray = (mediaArray || []).filter(item => this.isValidCampaignMediaItem(item));
      const skippedInvalid = (mediaArray || []).length - validMediaArray.length;
      if (skippedInvalid > 0) {
        this.$notify({
          type: 'warning',
          message: 'Some selected files are no longer available and were not added.',
          icon: 'el-icon-warning',
          duration: 4000
        });
      }
      if (!validMediaArray.length) {
        return;
      }
      let existingIds = new Set();
      if (this.modals.editCampaign) {
        existingIds = new Set(this.selectedEditMediaList.map(item => Number(item.id)));
      }else{
        existingIds = new Set(this.selectedMediaList.map(item => Number(item.id)));
      }
      const uniqueNewMedia = validMediaArray.filter(item => !existingIds.has(Number(item.id)));
      
      // Validate and set ad_file_type_id for each media item
      const validatedMedia = [];
      const invalidMedia = [];
      
      uniqueNewMedia.forEach(item => {
        const validation = this.validateMediaForCampaign(item);
        if (validation.valid) {
          item.ad_file_type_id = this.detectAdFileType(item);
          validatedMedia.push(item);
        } else {
          invalidMedia.push({ item, message: validation.message });
        }
      });
      
      // Show error for invalid media
      if (invalidMedia.length > 0) {
        invalidMedia.forEach(({ item, message }) => {
          this.$notify({
            type: 'danger',
            message: `${item.name || 'Media'}: ${message}`,
            icon: 'el-icon-error'
          });
        });
      }
      
      if (validatedMedia.length === 0) {
        this.modals.mediaSelect = false;
        return;
      }
      
      if (this.modals.editCampaign) {
        if (this.selectedRowData.destination_url) {
          validatedMedia.forEach((item) => {
            item.destination = this.selectedRowData.destination_url
          })
        }
        this.selectedEditMediaList.push(...validatedMedia);
      }else{
        if (this.campaign.destinationURL) {
          validatedMedia.forEach((item) => {
            item.destination = this.campaign.destinationURL
          })
        }
        this.selectedMediaList.push(...validatedMedia);
      }
      this.modals.mediaSelect = false;
    },
    onRemoveMedia(mediaId) {
      if (this.modals.editCampaign) {
        this.selectedEditMediaList = this.selectedEditMediaList.filter(item => item.id !== mediaId);
      }else{
        this.selectedMediaList = this.selectedMediaList.filter(item => item.id !== mediaId);
      }
    },
    onMediaListUpdated(updatedList) {
      if (this.modals.editCampaign) {
        this.selectedEditMediaList = updatedList;
      }else{
        this.selectedMediaList = updatedList;
      }
    },
    restrictInput(event, inputType) {
      const input = event.target.value;
      // Allow backspace, arrow keys, and other non-character keys
      const char = event.key;
      if (['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab'].includes(char)) {
        return;
      }

      if (inputType == 'integer') {
        if (!/^\d$/.test(char)) {
          event.preventDefault();
        }
      }

      // Check if the character is not a number
      if (!char.match(/[0-9]/) && char !== '.') {
        event.preventDefault();
      }

      // Allow only one period
      if (char === '.' && input.includes('.')) {
        event.preventDefault();
      }
    },
    populateHoursOptions() {
      for (let i = 1; i <= 24; i++) {
        this.frequencyCapping.hoursOptions.push({ id: i, value: i });
      }
    },
    applyFilter(filter) {
      this.filterCampaignStatus = filter.value;
      this.GetClientList(this.currSortBy, this.currOrderBy)
      this.dropdownVisible = false;
    },
    tooltip_campaign(index, row, stat) {
      if (stat == "play") {
        if (
          row.disabled == "T" &&
          row.active_user == "F" &&
          row.customer_card_id != ""
        ) {
          return "Start Campaign";
        } else if (
          row.disabled == "F" &&
          row.active_user == "T" &&
          row.customer_card_id != ""
        ) {
          return "Campaign is Running";
        } else if (
          row.active_user == "F" &&
          row.customer_card_id == "" &&
          this.$store.getters.userData.manual_bill == "F"
        ) {
          return "Campaign can not start before your complete payment information";
        } else {
          return "Start Campaign";
        }
      } else if (stat == "pause") {
        if (
          row.disabled == "F" &&
          row.active_user == "F" &&
          row.customer_card_id != ""
        ) {
          return "Pause Campaign";
        } else if (
          row.disabled == "T" &&
          row.active_user == "T" &&
          row.customer_card_id != ""
        ) {
          return "Campaign is Paused";
        } else if (
          row.active_user == "F" &&
          row.customer_card_id == "" &&
          this.$store.getters.userData.manual_bill == "F"
        ) {
          return "Campaign can not start before your complete payment information";
        } else {
          return "Pause Campaign";
        }
      } else if (stat == "stop") {
        if (row.active_user == "T" && row.customer_card_id != "") {
          return "Stop Campaign";
        } else if (row.active_user == "F" && row.customer_card_id != "") {
          return "Campaign is Stopped";
        } else if (
          row.active_user == "F" &&
          row.customer_card_id == "" &&
          this.$store.getters.userData.manual_bill == "F"
        ) {
          return "Campaign can not start before your complete payment information";
        } else {
          return "Stop Campaign";
        }
      }

      return "";
    },
    searchKeyWord() {
        this.pagination.currentPage = 1;
        this.GetClientList(this.currSortBy,this.currOrderBy,this.searchQuery);
    },
    fetchCampaignList() {
      // console.log('fetchCampaignList', {
      //   companyID: this.companyID,
      //   groupCompanyID: this.selectsCompany.companyId,
      // });
      //console.log(_sortby + ' | ' + _order);
      var _groupCompanyID = "";
      if (
        localStorage.getItem("companyGroupSelected") != null &&
        localStorage.getItem("companyGroupSelected") != ""
      ) {
        _groupCompanyID = localStorage.getItem("companyGroupSelected");
      }
      this.selectsCompany.campaignList = [];
      this.$store
        .dispatch("GetAllCampaigns", {
          companyID: this.companyID,
          groupCompanyID: this.selectsCompany.companyId,
        })
        .then(
          response => {
            this.selectsCompany.campaignList = response.campaigns;
          },
          error => { }
        );
      /** GET CLIENT LIST */
    },
    async GetClientList(sortby, order, searchkey, isFilter) {
      this.fetchingCampaignData = true;
      var _sortby = "";
      var _order = "";
      var _searchkey = "";

      if (typeof sortby != "undefined") {
        _sortby = sortby;
      }
      if (typeof order != "undefined") {
        _order = order;
      }
      if (this.searchQuery != "") {
        _searchkey = this.searchQuery;
      }

      //console.log(_sortby + ' | ' + _order);
      var _groupCompanyID = "";
      if (
        localStorage.getItem("companyGroupSelected") != null &&
        localStorage.getItem("companyGroupSelected") != ""
      ) {
        _groupCompanyID = localStorage.getItem("companyGroupSelected");
      }
      /** GET CLIENT LIST */
      // this.tableData = [];
      // $('.el-table__empty-text').html('<i class="fas fa-spinner fa-pulse fa-2x d-block"></i>Loading data...');
      // console.log('getClientList', {
      //   companyID: this.companyID,
      //   leadspeekType: "simplifi",
      //   groupCompanyID: _groupCompanyID,
      //   sortby: _sortby,
      //   order: _order,
      //   searchkey: _searchkey,
      //   page: this.pagination.currentPage,
      //   view: "campaign",
      //   campaignStatus: this.filterCampaignStatus
      // });
      await this.$store
        .dispatch("GetLeadsPeekClientList", {
          companyID: this.companyID,
          leadspeekType: "simplifi",
          groupCompanyID: _groupCompanyID,
          sortby: _sortby,
          order: _order,
          searchkey: _searchkey,
          page: this.pagination.currentPage,
          view: "campaign",
          campaignStatus: this.filterCampaignStatus
        })
        .then(
          response => {
          if (response.data.length === 0 && this.pagination.currentPage !== 1) {
                this.pagination.currentPage = 1;
                this.GetClientList(sortby, order, searchkey);
                return;
            }
            //console.log(response.length);
            this.pagination.currentPage = response.current_page
              ? response.current_page
              : 1;
            this.pagination.total = response.total ? response.total : 0;
            this.pagination.lastPage = response.last_page
              ? response.last_page
              : 2;
            this.pagination.from = response.from ? response.from : 0;
            this.pagination.to = response.to ? response.to : 0;
            if(response.data.length == 0) {
                $('.el-table__empty-text').html('No Data');
            }
            // console.log(response);
            this.tableData = this.AttachedAdminNotify(response.data);
            if(this.tableData.length > 0) {
              this.isLoadingIconFinancials = {};
              this.isLoadingIconActiveCampaigns = {};
              this.tableData.forEach(e => {
                this.$set(this.isLoadingIconFinancials, e.id, false);
                this.$set(this.isLoadingIconActiveCampaigns, e.id, false);
              })
              // console.log({
              //   'this.isLoadingIconFinancials': this.isLoadingIconFinancials,
              //   'this.isLoadingIconActiveCampaigns': this.isLoadingIconActiveCampaigns,
              // });
            }
            // this.searchedData = this.tableData;
            // this.searchQuery = "";
            // this.initialSearchFuse();
            this.fetchingCampaignData = false;
            this.$nextTick(() => {
                if (this.tableData.length > 0) {
                    this.fetchSimplifiData();
                }
            });
            this.checkAutoRefresh(); 
          },
          error => {
            this.fetchingCampaignData = false;
            this.stopAutoRefresh();
          }
        );
        return
      /** GET CLIENT LIST */
    },
    AttachedAdminNotify(response) {
        /** SET ADMIN NOTIFY */
        // Ensure response is always an array
        let dataArray = Array.isArray(response) ? response : Object.values(response);
        
        for(let i=0;i<dataArray.length;i++) {
            var tmp = "";
            var tmpArray = Array();
            tmp = dataArray[i]['admin_notify_to'];
            if(tmp) {
                tmpArray = tmp.split(",");
                for(let k=0;k<tmpArray.length;k++) {
                    tmpArray[k] = parseInt(tmpArray[k]);
                }
                dataArray[i]['admin_notify_to'] = tmpArray;
            }
            //dataArray[i]['admin_notify_to'].push(split);
        }
        return dataArray;
        /** SET ADMIN NOTIFY */
    },
    async GetCompanyList() {
      this.fetchingCampaignData = true;
      // $('.el-select-dropdown__empty').html('Loading data...');
      var _groupCompanyID = "";

      if (this.userType == "client") {
        const userData = this.$store.getters.userData;
        _groupCompanyID = userData.id;
      }

      /** GET CLIENT LIST */
      await this.$store
        .dispatch("GetClientList", {
          companyID: this.companyID,
          idsys: this.$global.idsys,
          userType: "client",
          userModule: "LeadsPeek",
          groupCompanyID: _groupCompanyID
        })
        .then(
          response => {
            // console.log('GetClientList', { response });
            if (response.length == 0) {
              $(".el-select-dropdown__empty").html("No new client");
            }
            this.selectsCompany.companyList = response;
            if (
              localStorage.getItem("companyGroupSelected") != null &&
              localStorage.getItem("companyGroupSelected") != ""
            ) {
              this.onCompanyChange(
                localStorage.getItem("companyGroupSelected")
              );
              this.CompanyNamedisabled = true;
            }
          },
          error => {
            this.fetchingCampaignData = false;
          }
        );
      /** GET CLIENT LIST */
      return
    },
    onCompanyChange(_companySelected, isClearCampaign = false) { // isinya id dari client
      // console.log('onCompanyChange', {
      //   _companySelected 
      // });

      if (isClearCampaign) { // clear campaign form digunakan hanya untuk ketika add campaign saja
        this.clearCampaignForm();
      }

      this.selectsCompany.companyId = _companySelected;

      for (let i = 0; i < this.selectsCompany.companyList.length; i++) {
        if (this.selectsCompany.companyList[i].id == _companySelected) {
          this.ClientFullName = this.selectsCompany.companyList[i].name;
          this.ClientEmail = this.selectsCompany.companyList[i].email;
          this.ClientPhone = this.selectsCompany.companyList[i].phonenum;
          this.ClientUserID = this.selectsCompany.companyList[i].id;
          this.ClientCompanyName = this.selectsCompany.companyList[i].company_name;
          this.selectsCompany.companySelected = this.selectsCompany.companyList[i].company_name;

          // var enabled_phone_number;
          // if (this.selectsCompany.companyList[i].enabled_phone_number == 'T') {
          //     enabled_phone_number = true;
          // } else {
          //     enabled_phone_number = false;
          // }
          // this.checkboxes.phoneenabled = enabled_phone_number;
        }
      }

      for(let i=0;i<this.$global.selectsGroupCompany.companyGroupList.length;i++) {
        if (this.$global.selectsGroupCompany.companyGroupList[i].id == _companySelected) {
          this.campaign.maxBid = this.$global.selectsGroupCompany.companyGroupList[i].SimplifiMaxBid;
          this.campaign.dailyBudget = this.$global.selectsGroupCompany.companyGroupList[i].SimplifiDailyBudget;
          this.agencyMarkup.selected = this.$global.selectsGroupCompany.companyGroupList[i].SimplifiAgencyMarkup;

          this.onBudgetInput('dailyBudget', this.campaign.dailyBudget)
          this.validateMinimumInput('keyup', 'addCampaign', 'maxBid')
          this.validateMinimumInput('keyup', 'addCampaign', 'dailyBudget')

          // console.log('onCompanyChange', {
          //   '_companySelected': _companySelected,
          //   'this.campaign.maxBid': this.campaign.maxBid,
          //   'this.campaign.dailyBudget': this.campaign.dailyBudget,
          //   'this.agencyMarkup.selected': this.agencyMarkup.selected,
          // });
        }
      }

      this.fetchCampaignList()
    },
    GetCompanyGroup() {
      const userData = this.$store.getters.userData;
      const companyID = userData.user_type != "client" ? userData.company_id: userData.company_parent;

      this.$store.dispatch("GetCompanyGroup", {
        companyID: companyID,
        userModule: "LeadsPeek",
      })
      .then(response => {
        if (response.result == "success") {
          this.$global.selectsGroupCompany.companyGroupList = response.params;
          this.$global.selectsGroupCompany.companyGroupList.unshift({id: "",group_name: "View All"});
          // console.log('GetCompanyGroup', {
          //   'this.$global.selectsGroupCompany.companyGroupList': this.$global.selectsGroupCompany.companyGroupList
          // });

          if (localStorage.getItem("companyGroupSelected") == null && response.params.length > 1) {
            localStorage.setItem("companyGroupSelected",response.params[1].id);
          }
        }
      });
      return
    },
    AddEditClient(id) {
      const companyGroupSelected = localStorage.getItem("companyGroupSelected");
      if (companyGroupSelected != null && companyGroupSelected != "") { // ini untuk client view
        this.onCompanyChange(companyGroupSelected);
      } else if (this.selectsCompany.companyId != "") { // ini untuk agency view, ini menyimpan history yang pernah di selecy client nye
        this.onCompanyChange(this.selectsCompany.companyId);
      }
      if (this.selectsCompany.companySelected == '') { // ini untuk agency view, ketika pertama kali masuk ke page sini this.selectsCompany.companyId kon kosong. makanya langsung ambil client index ke-0
        this.selectsCompany.companySelected = (this.selectsCompany.companyList.length > 0) ? (this.selectsCompany.companyList[0].id) : '';
        this.onCompanyChange(this.selectsCompany.companySelected);
      }
      // this.onCheckItemAdvancedInformation();
      this.resetStepCreateCampaign();
      this.selectedRowData = {}
      this.modals.addEditCampaign = !this.modals.addEditCampaign;

    },
    onBudgetInput(field, event, type = '') {
      const sanitized = this.sanitizeSimplifiPrice(event);
      const num = this.parseSimplifiPrice(sanitized);
      if (field === 'dailyBudget') {
        if (!isNaN(num)) {
          if (type == 'financial') {
            this.LeedspeekMonthlyBudget = this.formatSimplifiPrice((num * 30).toFixed(2));
            this.profitcalculation();
          } else {
            this.campaign.totalBudget = this.formatSimplifiPrice((num * 30).toFixed(2));
            this.profitcalculation('add_campaign');
          }
        } else {
          if (type == 'financial') {
            this.LeadspeekMonthlyBudget = '';
            this.profitcalculation();
          } else {
            this.campaign.dailyBudget = '';
            this.campaign.totalBudget = '';
            this.profitcalculation('add_campaign');
          }
        }
      }
      if (field === 'totalBudget') {
        if (!isNaN(num)) {
          if (type == 'financial') {
            this.LeadspeekDailyBudget = this.formatSimplifiPrice((num / 30).toFixed(2));
            this.profitcalculation();
          } else {
            this.campaign.dailyBudget = this.formatSimplifiPrice((num / 30).toFixed(2));
            this.profitcalculation('add_campaign');
          }
        } else {
          if (type == 'financial') {
            this.LeedspeekDailyBudget = '';
            this.profitcalculation();
          } else {
            this.campaign.totalBudget = '';
            this.campaign.dailyBudget = '';
            this.profitcalculation('add_campaign');
          }
        }
      }


      if (field === 'dailyBudgetEdit') {
        if (!isNaN(num)) {
          this.selectedRowData.monthly_budget = this.formatSimplifiPrice((num * 30).toFixed(2));
        } else {
          this.selectedRowData.monthly_budget = '';
        }
      }
      if (field === 'totalBudgetEdit') {
        if (!isNaN(num)) {
          this.selectedRowData.daily_budget = this.formatSimplifiPrice((num / 30).toFixed(2));
        } else {
          this.selectedRowData.daily_budget = '';
        }
      }

      // if(field === 'dailyBudget')  this.campaign.totalBudget = event * 60;
      // if(field === 'totalBudget')  this.campaign.dailyBudget = event / 60;
    },
    async onUploadAudienceFinished(mediaId) {
      this.isUpdatingAudience = true; // <-- Set flag ke true
      try {
        if (this.modals.editCampaign) {
          const currentSelection = this.selectedRowData.simplifi_selected_audience || [];
          this.selectedRowData.simplifi_selected_audience = [...currentSelection, mediaId];
          if (this.$refs.userLocalAudienceEdit) {
            await this.$refs.userLocalAudienceEdit.refresh();
          }
        } else {
          this.selectedAudience = [...this.selectedAudience, mediaId];
          if (this.$refs.userLocalAudienceAdd) {
            await this.$refs.userLocalAudienceAdd.refresh();
          }
        }
      } finally {
        this.isUpdatingAudience = false; // <-- Selalu set flag kembali ke false
      }
    },
  }
};
</script>

<style lang="scss" scoped>
.inserted-media-list .title {
  display: block;
  font-weight: 600;
  font-size: 16px;
  color: #333;
  margin-bottom: 12px;
}

.input-wrapper {
  display: flex;
  align-items: flex-end;
  gap: 12px;
}

.input-wrapper .base-input {
  flex: 1;
}

.campaign-cost-input.form-group {
  border-color: #cad1d7;
  border-radius: 6.856px;
}

/* Conversion Settings Input (CPA & Attribution) */
.conversion-settings-input.form-group {
  border-color: #cad1d7;
  border-radius: 6.856px;
}

/* Make borders merge together like Max Bid */
/* Style the input-group wrapper */
.conversion-settings-input.form-group .input-group {
  border: 1px solid #cad1d7;
  border-radius: 6.856px;
  display: flex;
  align-items: stretch;
}

/* Remove right border from input field and adjust border-radius */
.conversion-settings-input.form-group .input-group .form-control {
  border-right: none !important;
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
  border-left: 1px solid #cad1d7;
  border-top: 1px solid #cad1d7;
  border-bottom: 1px solid #cad1d7;
}

/* Remove left border from addon (right side) and adjust border-radius */
.conversion-settings-input.form-group .input-group .input-group-append .input-group-text,
.conversion-settings-input.form-group .input-group > .input-group-text:last-child {
  border-left: none !important;
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
  border-right: 1px solid #cad1d7;
  border-top: 1px solid #cad1d7;
  border-bottom: 1px solid #cad1d7;
}

/* Dark mode border fix for conversion-settings-input */
:root.dark-theme .conversion-settings-input.form-group .input-group {
  border-color: #cad1d7 !important;
}

:root.dark-theme .conversion-settings-input.form-group .input-group-text {
  border-color: #cad1d7 !important;
}

:root.dark-theme .conversion-settings-input.form-group .form-control {
  border-color: #cad1d7 !important;
  border-right: none !important;
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
  border-left: 1px solid #cad1d7 !important;
  border-top: 1px solid #cad1d7 !important;
  border-bottom: 1px solid #cad1d7 !important;
}

:root.dark-theme .conversion-settings-input.form-group .input-group .input-group-append .input-group-text,
:root.dark-theme .conversion-settings-input.form-group .input-group > .input-group-text:last-child {
  border-left: none !important;
  border-color: #cad1d7 !important;
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
  border-right: 1px solid #cad1d7 !important;
  border-top: 1px solid #cad1d7 !important;
  border-bottom: 1px solid #cad1d7 !important;
}

.upload-button:hover {
  border-color: initial !important;
  color: initial !important;
}

.upload-button:active {
  border-color: initial !important;
  color: initial !important;
}

.loading-icon-active-campaign {
  position: absolute;
  z-index: 9;
  background-color: rgb(100,100,100); 
  width: 26px;
  height: 26px;
  border-radius: 8px;
}

.loading-icon-financial {
  position: absolute; 
  z-index: 9; 
  background-color: rgb(100,100,100); 
  width: 100%; 
  height: 100%; 
  border-radius: 8px;
}

// Recommended Sizes Section Styles
.recommended-sizes-section {
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 16px 20px;
  margin-bottom: 16px;
}

.recommended-sizes-header {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

.recommended-sizes-title {
  font-weight: 600;
  font-size: 14px;
  color: #1e293b;
}

.recommended-sizes-description {
  margin-bottom: 12px;
}

.recommended-sizes-description span {
  font-size: 12px;
  color: #64748b;
  font-style: italic;
}

.recommended-sizes-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.size-badge {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 4px;
  padding: 3px 6px;
  font-size: 11px;
  font-weight: 400;
  color: #64748b;
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
  cursor: default;
  user-select: none;
}

// RESPONSIVE BREAKPOINTS
@media (max-width: 767.98px) {
  .recommended-sizes-grid {
    gap: 6px;
  }
  
  .size-badge {
    font-size: 10px;
    padding: 3px 6px;
  }
}
</style>
<style>
/* Tambah garis sebelum step pertama */
.el-steps--horizontal .el-step:first-child::before {
  content: "";
  position: absolute;
  left: 25%;
  top: 20%;
  width: 25%;
  height: 2px;
  background-color: #3b82f6;
  z-index: 0;
}
.el-steps--horizontal .el-step:last-child::after {
  content: "";
  position: absolute;
  right: 25%;
  top: 20%;
  width: 25%;
  height: 2px;
  background-color: #dcdfe6;
  z-index: 0;
}
.el-steps--horizontal.is-last-step .el-step:last-child::after {
  background-color: #3b82f6 !important;
}
.el-steps--horizontal {
  position: relative;
}
.el-step__line {
  background-color: #dcdfe6 !important; /* abu-abu */
}
.el-step__head.is-wait {
  color: #dcdfe6;
  border-color: #dcdfe6;
}
.el-step__head.is-process {
  color: #2c3e50;
  border-color: #2c3e50;
}
.el-step__head.is-success {
  color: #3b82f6 !important;
  border-color: #3b82f6 !important;
}
.el-step__line-inner {
  background-color: #3b82f6 !important;
}
.el-step__title.is-success {
  color: #3b82f6 !important;
}
.el-step__title {
  font-weight: 600 !important;
}

.error-input-price-simplifi {
  border: 1px solid #942434 !important;
}
.error-message-price-simplifi {
  color:#942434;
  font-size: 12px;
  font-weight: 400;
  line-height: 12px;
  margin-top: 4px;
  display: block;
  margin-bottom: 8px;
}

.tabs-simplifi {
  display: grid;
  margin-top: -8px;
}
.tabs-simplifi.el-tabs--border-card>.el-tabs__content {
  padding: 10px 5px !important;
}
.campaign-audiance-dropdown .el-input input {
  border-color: #cad1d7 !important;
  color: black !important;
}
.alert-li {
  color: initial !important;
}
.client-payment-simplifi-setup {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

/* Tooltip content styling for better readability */
.tooltip-content {
  text-align: left !important;
  font-size: 13px !important;
  line-height: 1.5 !important;
  color: #303133 !important;
}
.tooltip-content p {
  margin: 0 0 10px 0 !important;
  color: #303133 !important;
}
.tooltip-content p:last-child {
  margin-bottom: 0 !important;
}
.tooltip-content .tooltip-definitions {
  margin-top: 8px !important;
  padding-top: 8px !important;
  border-top: 1px solid #dcdfe6 !important;
  color: #303133 !important;
}
.tooltip-content .tooltip-definitions strong {
  color: #1f2d3d !important;
}

@media (max-width: 768px) {
  .calculations-divider {
    border-top: 1.5px solid;
    padding-top: 10px;
  }
}

.previous-spend-financial-container {
  width: max-content;
  display: flex;
  flex-direction: column;
  border: 1px solid #777;
  border-radius: 6px;
  padding: 0 8px;
  background-color: rgb(250,250,250);
  margin-bottom: 4px;
}
.previous-spend-financial-value {
  gap: 30px;
}
@media (min-width: 768px) {
  .previous-spend-financial-container {
    margin-left: -8px;
  }
  .previous-spend-financial-value {
    gap: 88px;
  }
}

.details-header {
    display: grid !important;
    grid-template-columns: 1fr !important;
    gap: 15px;
    align-items: start !important; 
    padding-bottom: 1rem;
    border-bottom: 1px solid #e9ecef;
    text-align: left;
}

@media (min-width: 768px) {
    .details-header {
        display: flex !important;
        justify-content: space-between !important;
        align-items: center !important;
        grid-template-columns: none !important;
        gap: 0;
    }
}

@media (max-width: 767px) {
    .details-header-right {
        width: 100% !important;
        display: flex !important;
        justify-content: space-between !important;
        align-items: center !important;
    }
}

.details-header-left h3 {
  font-size: 1.5rem;
  font-weight: 600;
  color: black !important;
}

.details-header-right {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.badge-status-active {
  background-color: #d1fae5;
  color: #065f46;
  padding: 0.25rem 0.75rem;
  border-radius: 999px;
  font-weight: 600;
  font-size: 0.8rem;
}

.details-metrics {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 1.5rem;
  padding: 1.5rem 0;
  border-bottom: 1px solid #e9ecef;
}

.metric-item {
  display: flex;
  flex-direction: column;
}

.metric-item label {
  font-size: 0.8rem;
  color: #6c757d;
  margin-bottom: 0.25rem;
  text-transform: uppercase;
  font-weight: 500;
}

.metric-item span {
  font-size: 1rem;
  font-weight: 600;
  color: #212529;
}

.details-content {
  margin-top: 1.5rem;
}

.summary-box {
  border: 1px solid #e9ecef;
  border-radius: 8px;
  padding: 1.5rem;
  height: 100%;
}

.summary-box h4 {
  font-weight: 600;
  margin-bottom: 1rem;
}

.summary-item {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.75rem;
  font-size: 0.9rem;
}

.summary-item span {
  color: #6c757d;
}

.chart-container {
  border: 1px solid #e9ecef;
  border-radius: 8px;
  padding: 1rem;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f8f9fa;
}

.menu-drop-anchor {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 6px;
  cursor: pointer;
}

.menu-drop-anchor:hover {
  background: rgba(0,0,0,0.05);
}

/* Geo Targeting Agreement Box Styles */
.geo-targeting-agreement-box.agreement-checked {
  background: #f0fdf4 !important;
  border-left-color: #10b981 !important;
}

.geo-targeting-agreement-box.agreement-checked .fa-info-circle {
  color: #10b981 !important;
}
</style>

<style>
/* Loading animation for conversion types */
@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}

@keyframes rotating {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* Connected TV Info Popover Styles */
.connected-tv-info-popover {
  background-color: #409EFF !important;
  border-color: #409EFF !important;
  color: #fff !important;
}

.connected-tv-info-popover .el-popover__title {
  color: #fff !important;
}

.connected-tv-info-popover[x-placement^="top"] .popper__arrow::after {
  border-top-color: #409EFF !important;
}

.connected-tv-info-popover[x-placement^="bottom"] .popper__arrow::after {
  border-bottom-color: #409EFF !important;
}

.connected-tv-info-popover[x-placement^="left"] .popper__arrow::after {
  border-left-color: #409EFF !important;
}

.connected-tv-info-popover[x-placement^="right"] .popper__arrow::after {
  border-right-color: #409EFF !important;
}

  .custom-disabled-input {
  opacity: 0.7;
}

.custom-disabled-input input.form-control {
  background-color: #e9ecef !important;
  cursor: not-allowed !important;
  color: #6c757d !important;
}

.custom-disabled-input .input-group-text {
  background-color: #e9ecef !important;
  border-color: #cad1d7 !important;
  color: #6c757d !important;
}

/* Targeting overlap warning modal */
.targeting-overlap-msgbox {
  max-width: 480px;
  border-radius: 10px;
  overflow: hidden;
  padding-bottom: 10px;
}
.targeting-overlap-msgbox .el-message-box__header {
  padding: 20px 20px 0;
}
.targeting-overlap-msgbox .el-message-box__title {
  font-size: 17px;
  font-weight: 700;
  color: #303133;
}
.targeting-overlap-msgbox .el-message-box__headerbtn {
  top: 18px;
  right: 18px;
}
.targeting-overlap-msgbox .el-message-box__content {
  padding: 12px 20px 0;
}
.targeting-overlap-msgbox .el-message-box__status {
  display: none;
}
.targeting-overlap-msgbox .el-message-box__btns {
  padding: 8px 20px 12px;
}
.targeting-overlap-msgbox .el-message-box__btns .el-button--primary {
  background-color: #409EFF;
  border-color: #409EFF;
  border-radius: 6px;
  padding: 10px 28px;
  font-size: 14px;
  font-weight: 600;
}
.targeting-overlap-msgbox .el-message-box__btns .el-button--primary:hover {
  background-color: #66b1ff;
  border-color: #66b1ff;
}

.cursornodrop {
  cursor: no-drop;
}
</style>
